<template>
  <!-- CPAP 導入申込み -->
  <div id="CpapRequest">
    <section>
      <div id="container-center">
        <form>
        <h1 v-if="temp" style="" class="title has-text-centered printTarget">CPAP 仮持出申込み</h1>
        <h1 v-else-if="isInstrument" style="" class="title has-text-centered printTarget">CPAP 預託機処方申込み</h1>
        <h1 v-else style="" class="title has-text-centered printTarget">CPAP 処方申込み</h1>
        <div>
          <b-steps v-model="activeStep" :animated="true" :rounded="true" :has-navigation="false" label-position="bottom">
            <b-step-item step="1" label="利用規約" icon="comment-alert-outline" v-if="needAgree">
              <div id="item-contens">
                <div class="request-title">
                  <b-button class="is-primary" style="float:left;" icon-left="home" @click.prevent="goHome">ホーム画面 </b-button>
                  <b-button class="is-primary" style="float: right" icon-right="chevron-double-right" :disabled="!isChecked" @click.prevent="Forward">次へ</b-button>
                  <span>以下の利用規約に同意のうえ、申込みを行ってください。</span>
                </div>
                <div v-if="isHospitalNewOrder()" style="margin-bottom: 1em; font-size: 18px" >
                  <router-link :to="{name:'CpapRequestDraftView', params:{}}" style="color: #2255ff; font-weight: bold;">
                    保存中（申込み未完了）の処方作成はこちら
                  </router-link>
                </div>
                <div class="card-content margin-top">
                  <span style="font-size:20px;">利用規約</span>
                  <a @click="download"><b-icon style="margin-top:3px;" icon="file-download-outline"/></a>
                  <table>
                    <tr><td><textarea readonly class="cautionArea noresize" v-model="agreement" /></td></tr>
                    <tr>
                      <td>
                        <div style="text-align: center; color: black">
                          「<a :href="getUrlRentalCondition()" target="_blank" rel="noopener noreferrer">レンタルの一般条件</a>」は<a :href="getUrlRentalCondition()" target="_blank" rel="noopener noreferrer" style="font-weight: bold;color:blue">こちら</a>を参照してください。 「<a :href="getUrlPrivacyPolicy()" target="_blank" rel="noopener noreferrer">プライバシー規則</a>」は<a :href="getUrlPrivacyPolicy()" target="_blank" rel="noopener noreferrer" style="font-weight: bold;color:blue">こちら</a>を参照してください。
                        </div>
                      </td>
                    </tr>
                    <tr><td><div style="text-align: center;"></div></td></tr>
                    <tr><td><div style="text-align: center;"><b-checkbox class="cstmCheckBox" v-model="isChecked" :disabled="!canAgree">利用規約に同意のうえ、申込みを行う。</b-checkbox></div></td></tr>
                  </table>
                </div>
              </div>
            </b-step-item>
            <b-step-item step="2" label="医療機関情報" icon="clipboard-edit-outline">
              <div id="item-contens" v-bind:key="renderKey">
                <div class="request-title">
                  <b-button v-if="false" class="is-primary" style="float:left;" icon-left="chevron-double-left" @click.prevent="Backward">戻る</b-button>
                  <b-button v-else class="is-primary" style="float:left;" icon-left="home" @click.prevent="goHome">ホーム画面 </b-button>
                  <b-button class="is-primary" style="float:right;" icon-right="chevron-double-right" :disabled="!isHospitalAgree||!isPatientAgree" @click.prevent="Forward">次へ</b-button>
                  <span>申込み内容を入力してください。</span>
                  <span v-if="(isHospital || isDealer) && cpapDefaultSettingList.length > 0">
                    <!-- QA491 デフォルト値設定を複数設定可能にする -->
                    <select v-if="!resume" style="width:350px;" @change="cpapPreviousRequestCopy" v-model="cpapBeforeRequestDetail" autocomplete="off">
                      <option value="">デフォルト値設定の選択</option>
                      <option v-for="setting in cpapDefaultSettingList" :value="setting" :key="setting.id">{{ setting.templateName }}</option>
                    </select>
                  </span>
                </div>
                <div class="card-content margin-top">
                  <span style="font-size:20px;">医療機関情報</span>
                  <table>
                    <tr v-if="!isHospital && !isDealer"><th>指示日<span class="require"/></th><td><input type="date" v-model="reqParams.instructionDate" class="2" :name="'指示日'" validate="required|date" style="width:150px;"/></td></tr>
                    <tr><th>医療機関名<span class="require" v-if="isDealer || isHonsha || isAdmin || isSalesOffice"/></th>
                      <td>
                        <template v-if="isDealer || isHonsha || isAdmin || isSalesOffice">
                          <input type="text" style="width:730px;" v-model="reqParams.medicalInstitutionName" class="2" name="医療機関名" validate="required" disabled />
                          <b-button v-if="!cancelResume" style="margin-left:10px; width:150px; height:27px;" @click="organizationModalActive=true">医療機関選択</b-button>
                        </template>
                        <template v-else>{{reqParams.medicalInstitutionName}}</template>
                      </td>
                    </tr>
                    <tr><th>医師名<span class="require"/></th><td><input type="text" v-model="reqParams.doctorName" maxlength="105" id="doctorName" :class="`${reqParams.existingFlag && reqParams.cancelResume ? 'resumeExisting' : '2'}`" name="医師名" validate="required"/></td></tr>
                    <tr><th>事務担当者名</th><td><input type="text"  v-model="reqParams.clerkName" maxlength="100"/></td></tr>
                    <tr v-if="isHonsha || isAdmin || isSalesOffice"><th>コメント</th><td>{{reqParams.note}}</td></tr>
                    <template v-if="isDealer">
                      <tr><th>医療機関メールアドレス</th><td><b-checkbox class="cstmCheckBox" v-model="reqParams.mailNotification">申込み内容を医療機関にメールで通知する。</b-checkbox></td></tr>
                      <tr v-if="reqParams.mailNotification"><th></th><td><input type="text" v-model="reqParams.hospitalMail" maxlength="256" placeholder="例）example@example.com" class="2" name="医療機関メールアドレス" validate="mail|required"></td></tr>
                    </template>
                  </table>
                  <!-- 患者情報 -->
                  <span style="font-size:20px;">患者情報</span>
                  <table>
                    <tr><th>診察券ID（患者ID）<span class="require" /></th><td><input type="text" v-model="reqParams.patient.patientRegistrationCard" maxlength="50" id="patientRegistrationCard" class="2" :name="'診察券ID（患者ID）'" validate="required" /></td></tr>
                    <tr><th>患者名<span class="require" /></th><td><input type="text" style="margin-right: 5px; width: 446px !important;" placeholder="姓" v-model="reqParams.patient.patientFamilyName" class="2" :name="'患者名(姓)'" validate="required" maxlength="49"/><input type="text" style="width: 446px !important;" placeholder="名" v-model="reqParams.patient.patientFirstName" class="2" :name="'患者名(名)'" validate="required" maxlength="49"/></td></tr>
                    <tr><th>患者名（カナ）<span class="require" /></th><td><input type="text" style="margin-right: 5px; width: 446px !important;" placeholder="セイ" v-model="reqParams.patient.patientFamilyNameKana" class="2" :name="'患者名カナ(セイ)'" validate="kana|required" maxlength="49"/><input type="text" style="width: 446px !important;" placeholder="メイ" v-model="reqParams.patient.patientFirstNameKana" class="2" :name="'患者名カナ(メイ)'" validate="kana|required" maxlength="49"/></td></tr>
                    <tr><th>性別<span class="require" /></th><td>
                      <div class="block">
                        <b-radio size="is-small" v-model="reqParams.patient.gender" native-value="-">-</b-radio>
                        <b-radio size="is-small" v-model="reqParams.patient.gender" native-value="男">男</b-radio>
                        <b-radio size="is-small" v-model="reqParams.patient.gender" native-value="女">女</b-radio>
                      </div></td>
                    </tr>
                    <tr><th>生年月日<span class="require"/></th><td><input type="date" v-model="reqParams.patient.birthday" :input="inputBirthday(reqParams.patient.birthday)" class="2" :name="'患者の生年月日'" validate="required|date|birthDay" :max="yyyy_hyp_MM_hyp_dd(new Date())" style="width:150px;"/><span v-if="reqParams.patient.birthday" style="margin-left:10px;">{{reqParams.patient.japaneseCalendar}}</span></td></tr>
                    <tr><th>年齢</th><td><input type="text" disabled v-model="reqParams.patient.age"/></td></tr>
                    <tr>
                      <th>
                        郵便番号<span class="require"/>
                      </th>
                      <td>
                        <input
                          id="patientZip"
                          v-model="reqParams.patient.zip"
                          type="text"
                          maxlength="7"
                          style="width: 270px"
                          class="2"
                          :class="{ 'border-red': invalidPostcode }"
                          name="患者の郵便番号"
                          validate="required|numeric|zip"
                          :placeholder="postcodePlaceholder"
                          @blur="onZipBlur(reqParams.patient.zip, 'digitErrorPostcode')"
                        />
                        <b-button
                          style="margin-left: 10px; width: 150px; height: 27px"
                          v-on:click="patientAddressSearch(reqParams.patient.zip)"
                        >
                          自動入力
                        </b-button>
                        <div v-show="invalidPostcode" class="text-red">{{ invalidNumberMessage }}</div>
                        <div v-show="digitErrorPostcode" class="text-red">{{ digitErrorZipMessage }}</div>
                      </td>
                    </tr>
                    <tr><th>住所（都道府県、市町村区）<span class="require" style="margin-left:-8px;"/></th><td><input type="text" v-model="reqParams.patient.address" maxlength="256" class="2" :name="'患者の住所（都道府県、市町村区）'" validate="required"/></td></tr>
                    <tr><th>住所（それ以降の住所）<span class="require"/></th><td><input type="text" v-model="reqParams.patient.address1" maxlength="256" class="2" :name="'患者の住所（それ以降の住所）'" validate="required" ref="patientAddress1"/></td></tr>
                    <tr><th>住所（建物名、部屋番号）</th><td><input type="text" v-model="reqParams.patient.address2" maxlength="256"/></td></tr>
                    <tr>
                      <th>
                        連絡先（携帯電話）
                      </th>
                      <td>
                        <input
                          type="text"
                          v-model="reqParams.patient.mobilePhone"
                          maxlength="11"
                          id="mobilePhone"
                          class="2"
                          :class="{'border-red': invalidMobilePhoneNumber}"
                          name="連絡先（携帯電話）"
                          validate="numeric"
                          :placeholder="phonePlaceholder"
                        />
                        <div v-show="invalidMobilePhoneNumber" class="text-red">{{ invalidNumberMessage }}</div>
                      </td>
                    </tr>
                    <tr>
                      <th>
                        連絡（自宅・その他）
                      </th>
                      <td>
                        <input
                          type="text"
                          v-model="reqParams.patient.phoneNumber"
                          maxlength="11"
                          id="phoneNumber"
                          class="2"
                          :class="{'border-red': invalidPhoneNumber}"
                          validate="numeric"
                          name="連絡（自宅・その他）"
                          :placeholder="phonePlaceholder"
                        />
                        <div v-show="invalidPhoneNumber" class="text-red">{{ invalidNumberMessage }}</div>
                      </td>
                    </tr>
                    <tr v-if="!reqParams.resume && !reqParams.cancelResume"><th>フォローアップコール<span class="require"/></th>
                      <td>
                        <div>
                          <b-radio class="td_radio" name="followUpCall" v-model="reqParams.patient.followUpCall" :native-value="true">する</b-radio>
                          <b-radio class="td_radio" name="followUpCall" v-model="reqParams.patient.followUpCall" :native-value="false">しない</b-radio>
                        </div>
                      </td>
                    </tr>
                    <tr><th>病名</th>
                      <td>
                        <input type="text" v-model="reqParams.patient.disease" maxlength="256"/>
                      </td>
                    </tr>
                    <tr><th>感染症</th><td>
                      <select v-model="reqParams.patient.infection">
                        <option value=""/>
                        <option value="0">無し</option>
                        <option value="1">MRSA</option>
                        <option value="2">HCV</option>
                        <option value="3">HBV</option>
                        <option value="4">Wa</option>
                        <option value="5">その他</option>
                      </select>
                    </td></tr>
                    <tr><th>感染症名(その他)<span class="require" v-if="reqParams.patient.infection=='5'"/></th><td><input type="text" v-model="reqParams.patient.infectionName" maxlength="256" class="2" :name="'感染症名(その他)'" :validate="`${reqParams.patient.infection=='5' ? 'required' : ''}`"/></td></tr>
                    <tr><th>地域医療連携施設名</th><td><input type="text" v-model="reqParams.patient.hospitalName" maxlength="256" /></td></tr>
                    <tr><th>地域医療連携施設　医師名</th><td><input type="text" v-model="reqParams.patient.doctorName" maxlength="105"/></td></tr>
                    <template v-if="isDealer">
                      <tr/>
                      <tr>
                        <th/><td><b-checkbox class="cstmCheckBox" v-model="isHospitalAgree">申請者がCPAPの申込みを行うことについて、該当医療機関の同意を取得しています。</b-checkbox></td>
                      </tr>
                    </template>
                    <tr v-if="isHospital || isDealer">
                      <th/><td><b-checkbox class="cstmCheckBox" v-model="isPatientAgree">保守目的で個人情報をフィリップスと共有することについて、該当患者の同意を取得しています。</b-checkbox></td>
                    </tr>
                  </table>
                </div>
              </div>
            </b-step-item>
            <b-step-item step="3" label="装置情報" icon="clipboard-pulse-outline">
              <div id="item-contens">
                <div class="request-title">
                  <b-button class="is-primary" style="float:left;" icon-left="chevron-double-left" @click.prevent="Backward">前へ</b-button>
                  <span>装置情報を入力してください。</span>
                  <span v-if="(isHospital || isDealer) && cpapDefaultSettingList.length > 0">
                    <!-- QA491 デフォルト値設定を複数設定可能にする -->
                    <select v-if="!resume" style="width:350px;" @change="cpapPreviousRequestCopyModel" v-model="cpapBeforeRequestDetailModel" autocomplete="off">
                      <option value="">デフォルト値設定の選択</option>
                      <option v-for="setting in cpapDefaultSettingList" :value="setting" :key="setting.id">{{ setting.templateName }}</option>
                    </select>
                  </span>
                  <b-button class="is-primary" style="float:right; margin-left: 10px;" icon-right="chevron-double-right" @click.prevent="Forward" :disabled="reqParams.prescriptionItems.length==0">次へ</b-button>
                </div>
                <div class="card-content margin-top">
                  <span style="font-size:20px;">装置情報</span>
                  <table>
                    <!-- 医療機関/ディーラーユーザーは非表示20230913 -->
                    <template v-if="!isHospital || !isDealer">
                    <tr>
                      <th>機種<span class="require"/></th>
                      <td>
                        <!-- 仮持出 -->
                        <input v-if="temp" disabled style="width:80%;" type="text" v-model="reqParams.model" data-vv-as="機種" class="3" name="機種" validate="required"/>
                        <!-- 仮持出以外 -->
                        <select v-else id="model" class="3" name="機種" validate="required" @change="changeModel" v-model="reqParams.reportFormatType">
                          <option v-for="model in modelList" :value="model.reportFormatType" :key="model.reportFormatType">{{ model.itemName }}</option>
                        </select>
                      </td>
                    </tr>
                    </template>
                    <!-- 新規処方(預託在庫),処方変更申込みの場合シリアル入力する -->
                    <tr v-if="isInstrument || changePrescription">
                      <th style="white-space:pre-wrap;">シリアル<span class="require"/></th>
                      <td>
                        <input type="text" data-vv-as="CPAP機器シリアル" maxlength="18" v-model="reqParams.serial" class="3" name="シリアル" validate="required"/>
                      </td>
                    </tr>
                    <!-- 仮持出 -->
                    <tr v-if="temp">
                      <th style="white-space:pre-wrap;">シリアル<span class="require"/></th>
                      <td><input disabled style="width:80%;" type="text" maxlength="18" v-model="reqParams.serial" data-vv-as="CPAP機器シリアル" class="3" name="シリアル" validate="required"/>
                      <b-button style="margin-left:10px; width:150px; height:27px;" v-on:click="tempDeviceSelectModalActive=true">選択</b-button>
                      </td>
                    </tr>
                    <!--
                    <template>
                      <tr>
                        <th>使用機器</th><td><b-checkbox class="cstmCheckBox" v-model="reqParams.depositUseFlag">預託機を使用する（要預託契約）</b-checkbox></td>
                      </tr>
                    </template>
                    -->
                  </table>
                </div>
                <div class="card-content margin-top" v-if="reqParams.model">
                  <span style="font-size:20px;">設定情報</span>
                  <div style="display: flex;">
                    <form data-vv-scope="form3">
                      <table class="settings">
                        <template v-for="(content, index) in reqParams.prescriptionItems.filter(val=>{ return val.category===0})">
                          <!-- テキスト項目 -->
                          <tr v-if="content.type==='char' && (content.mode.indexOf(0)!=-1 || !reqParams.mode || content.mode.indexOf(reqParams.mode)!=-1)" :key="index">
                            <th style="white-space:pre-wrap;">{{content.displayName}}<span v-if="content.required" class="require"/></th>
                            <td>
                              <b-field
                              :type="{'is-danger':errors.has('form3.form3char_'+index)&&!content.disabled}"
                              :message="
                              `${errors.has('form3.form3char_'+index)&&!content.disabled ? errors.first('form3.form3char_'+index) : ''}`">
                                <input
                                  style="width:500px;"
                                  type="text"
                                  :name="'form3char_'+index"
                                  :data-vv-as="content.displayName"
                                  v-validate="`${content.required ? 'required':''}|validationCheck:${content.value},${encodeURI(content.validationRule)}`"
                                  v-model="content.value"
                                  @input="changeSelect(content.displayName,content.value)"
                                  :disabled="content.disabled"/>{{content.unit}}
                              </b-field>
                            </td>
                            <td>
                              <!-- 説明コメント用 -->
                            </td>
                          </tr>
                          <!-- セレクトボックス -->
                          <tr v-if="content.type=== 'sel' && (content.mode.indexOf(0)!=-1 || !reqParams.mode || content.mode.indexOf(reqParams.mode)!=-1)" :key="index">
                            <th style="white-space:pre-wrap;">{{content.displayName}}<span v-if="content.required" class="require"/></th>
                            <td>
                              <b-field
                              :type="{'is-danger':errors.has('form3.form3sel_'+index)&&!content.disabled}"
                              :message="`${errors.has('form3.form3sel_'+index)&&!content.disabled ? errors.first('form3.form3sel_'+index) : ''}`">
                                <select 
                                style="width:500px;"
                                :name="'form3.form3sel_'+index"
                                :data-vv-as="content.displayName"
                                v-model="content.value"
                                v-validate="`${content.required ? 'required':''}`"
                                @change="changeSelect(content.displayName,content.value)"
                                :disabled="content.disabled">
                                  <option
                                  v-for="tmpValue in content.displayValue"
                                  :value="tmpValue.key"
                                  :key="tmpValue.key"
                                  >{{ tmpValue.value }}</option></select>{{content.unit}}
                              </b-field>
                            </td>
                            <td>
                              <!-- 説明コメント用 -->
                            </td>
                          </tr>
                          <!-- カレンダー -->
                          <tr v-if="content.type=== 'calender' && (content.mode.indexOf(0)!=-1 || !reqParams.mode || content.mode.indexOf(reqParams.mode)!=-1)" :key="index">
                            <th style="white-space:pre-wrap;">{{content.displayName}}<span v-if="content.required" class="require"/></th>
                            <td>
                              <b-field
                              :type="{'is-danger':errors.has('form3.form3calender_'+index)}"
                              :message="errors.first('form3.form3calender_'+index)">
                                <input style="width:500px;" type="date" :name="'form3calender_'+index" :data-vv-as="content.displayName" v-model="content.value" v-validate="`${content.required ? 'required':''}`"/>
                              </b-field>
                            </td>
                            <td>
                              <!-- 説明コメント用 -->
                            </td>
                          </tr>
                          <!-- ラジオボタン -->
                          <tr v-if="content.type==='radio' && (content.mode.indexOf(0)!=-1 || !reqParams.mode || content.mode.indexOf(reqParams.mode)!=-1)" :key="index">
                            <th style="white-space:pre-wrap;">{{content.displayName}}<span v-if="content.required" class="require"/></th>
                            <td>
                              <div>
                                <b-radio
                                v-for="tmpValue in content.displayValue"
                                v-model="content.value"
                                :value="tmpValue.value"
                                :key="tmpValue.key"
                                :name="'form3radio_'+index+'_'"
                                :native-value="tmpValue.key"
                                style="text-align:left; margin-Right:10px;"
                                >{{tmpValue.value}}</b-radio>
                              </div>
                              <!-- :disabled="content.isDisabled=='true'" -->
                            </td>
                          </tr>
                          <tr v-if="content.annotation" :key="index+'α'">
                            <td style="white-space:pre-wrap;color:red;" colspan="3">{{content.annotation}}</td>
                          </tr>
                        </template>
                      </table>
                    </form>
                  </div>
                </div>
              </div>
            </b-step-item>
            <b-step-item step="4" label="関連用品" icon="clipboard-check-outline">
              <form data-vv-scope="form4">
                <div id="item-contens">
                  <div class="request-title">
                    <b-button class="is-primary" style="float:left;" icon-left="chevron-double-left" @click.prevent="Backward">前へ</b-button>
                    <span>関連用品を入力してください。</span>
                    <b-button class="is-primary" style="float:right;" icon-right="chevron-double-right" @click.prevent="Forward">次へ</b-button>
                  </div>
                  <div class="card-content margin-top">
                    <span style="font-size:20px;">加温加湿器</span>
                    <table class="settings">
                      <template v-for="(content, index) in reqParams.prescriptionItems.filter(val=>{ return val.category===1})">
                        <!-- テキスト項目 -->
                        <tr v-if="content.type==='char' && reqParams.useMoist && (content.mode.indexOf(0)!=-1 || !reqParams.mode || content.mode.indexOf(reqParams.mode)!=-1) && (content.displayName=='機種' && !isHospital && !isDealer)" :key="index">
                          <th style="white-space:pre-wrap;width:250px;">{{content.displayName}}<span v-if="content.required" class="require"/></th>
                          <td>
                            <b-field
                            :type="{'is-danger':errors.has('form4.form4char_'+index)}"
                            :message="errors.first('form4.form4char_'+index)">
                              <input style="width:500px;" type="text" :name="'form4char_'+index" :data-vv-as="content.displayName" v-validate="`${content.required ? 'required':''}|validationCheck:${content.value},${encodeURI(content.validationRule)}`" v-model="content.value"/>{{content.unit}}
                              <!-- <span v-if="errors.has('char_'+index)" style="color:red;">{{errors.first('char_'+index)}}</span> -->
                            </b-field>
                          </td>
                          <td>
                            <!-- 説明コメント用 -->
                          </td>
                        </tr>
                        <!-- セレクトボックス -->
                        <tr v-if="content.type=== 'sel' && reqParams.useMoist && (content.mode.indexOf(0)!=-1 || !reqParams.mode || content.mode.indexOf(reqParams.mode)!=-1)" :key="index">
                          <th style="white-space:pre-wrap;">{{content.displayName}}<span v-if="content.required" class="require"/></th>
                          <td>
                            <b-field
                            :type="{'is-danger':errors.has('form4.form4sel_'+index)}"
                            :message="errors.first('form4.form4sel_'+index)">
                              <select
                              style="width:500px;"
                              :name="'form4sel_'+index"
                              :data-vv-as="content.displayName"
                              v-model="content.value"
                              v-validate="`${content.required ? 'required':''}`"
                              @change="changeSelect(content.displayName,content.value)"
                              :disabled="content.disabled">
                                <option
                                v-for="tmpValue in content.displayValue"
                                :value="tmpValue.key"
                                :key="tmpValue.key"
                                >{{ tmpValue.value }}</option></select>{{content.unit}}
                            </b-field>
                          </td>
                          <td>
                            <!-- 説明コメント用 -->
                          </td>
                        </tr>
                        <!-- カレンダー -->
                        <!-- QA421_加湿器、モデムの設置日の項目を削除する -->
                        <!-- <tr v-if="content.type=== 'calender' && reqParams.useMoist && (content.mode.indexOf(0)!=-1 || !reqParams.mode || content.mode.indexOf(reqParams.mode)!=-1)" :key="index">
                          <th style="white-space:pre-wrap;">{{content.displayName}}<span v-if="content.required" class="require"/></th>
                          <td>
                            <b-field
                            :type="{'is-danger':errors.has('form4.form4calender_'+index)}"
                            :message="errors.first('form4.form4calender_'+index)">
                              <input style="width:500px;" type="date" :name="'form4calender_'+index" :data-vv-as="content.displayName" v-model="content.value" v-validate="`${content.required ? 'required':''}`"/>
                            </b-field>
                          </td>
                          <td> -->
                            <!-- 説明コメント用 -->
                          <!-- </td>
                        </tr> -->
                        <!-- ラジオボタン -->
                        <tr v-if="content.type==='radio' && (content.mode.indexOf(0)!=-1 || !reqParams.mode || content.mode.indexOf(reqParams.mode)!=-1)" :key="index">
                          <th style="white-space:pre-wrap;">{{content.displayName}}<span v-if="content.required" class="require"/></th>
                          <td>
                            <div>
                              <b-radio
                              v-for="tmpValue in content.displayValue"
                              v-model="content.value"
                              :value="tmpValue.value"
                              :key="tmpValue.key"
                              :name="'form4radio1_'+index"
                              :native-value="tmpValue.key"
                              style="text-align:left; margin-Right:10px;"
                              @click.native="inputRadioValue(tmpValue.key,'useMoist')"
                              >{{tmpValue.value}}</b-radio>
                            </div>
                            <!-- :disabled="content.isDisabled=='true'" -->
                          </td>
                        </tr>
                      </template>
                      <!-- 預託在庫から申込みの場合シリアル入力する -->
                      <tr v-if="isInstrument && reqParams.useMoist">
                        <th style="white-space:pre-wrap;">シリアル<span class="require"/></th>
                        <td>
                          <input style="width:500px;" type="text" data-vv-as="加湿器シリアル" maxlength="20" v-model="reqParams.moistSerial" :name="'form4char_'+index" v-validate="'required'"/>
                        </td>
                      </tr>
                    </table>
                  </div>
                  <div class="card-content margin-top">
                    <span style="font-size:20px;">通信モジュール</span>
                    <table class="settings">
                      <template v-for="(content, index) in reqParams.prescriptionItems.filter(val=>{ return val.category===2})">
                        <!-- テキスト項目 -->
                        <tr v-if="content.type==='char' && reqParams.useModule && !isHideItem(content.displayName) && (content.mode.indexOf(0)!=-1 || !reqParams.mode || content.mode.indexOf(reqParams.mode)!=-1) && ((content.displayName=='機種' && !isHospital && !isDealer) || content.displayName=='E-mailアドレス')" :key="index">
                          <th style="white-space:pre-wrap;width:250px;">{{content.displayName}}<span v-if="content.required" class="require"/></th>
                          <td>
                            <b-field
                            :type="{'is-danger':errors.has('form4.form4_2char_'+index)}"
                            :message="errors.first('form4.form4_2char_'+index)">
                              <input style="width:500px;" type="text" :name="'form4_2char_'+index" :data-vv-as="content.displayName" v-validate="`${content.required ? 'required':''}|validationCheck:${content.value},${encodeURI(content.validationRule)}`" v-model="content.value"/>{{content.unit}}
                            </b-field>
                          </td>
                          <td>
                            <!-- 説明コメント用 -->
                          </td>
                        </tr>
                        <!-- セレクトボックス -->
                        <tr v-if="content.type=== 'sel' && reqParams.useModule && !isHideItem(content.displayName) && (content.mode.indexOf(0)!=-1 || !reqParams.mode || content.mode.indexOf(reqParams.mode)!=-1)" :key="index">
                          <th style="white-space:pre-wrap;">{{content.displayName}}<span v-if="content.required" class="require"/></th>
                          <td>
                            <b-field
                            :type="{'is-danger':errors.has('form4.form4_2sel_'+index)}"
                            :message="errors.first('form4.form4_2sel_'+index)">
                              <select style="width:500px;" :name="'form4_2sel_'+index" :data-vv-as="content.displayName" v-model="content.value" v-validate="`${content.required ? 'required':''}`">
                                <option
                                v-for="tmpValue in content.displayValue"
                                :value="tmpValue.key"
                                :key="tmpValue.key"
                                >{{ tmpValue.value }}</option></select>{{content.unit}}
                            </b-field>
                          </td>
                          <td>
                            <!-- 説明コメント用 -->
                          </td>
                        </tr>
                        <!-- カレンダー -->
                        <!-- QA421_加湿器、モデムの設置日の項目を削除する -->
                        <!-- <tr v-if="content.type=== 'calender' && reqParams.useModule && (content.mode.indexOf(0)!=-1 || !reqParams.mode || content.mode.indexOf(reqParams.mode)!=-1)" :key="index">
                          <th style="white-space:pre-wrap;">{{content.displayName}}<span v-if="content.required" class="require"/></th>
                          <td>
                            <b-field
                            :type="{'is-danger':errors.has('form4.form4_2calender_'+index)}"
                            :message="errors.first('form4.form4_2calender_'+index)">
                              <input style="width:500px;" type="date" :name="'form4_2calender_'+index" :data-vv-as="content.displayName" v-model="content.value" v-validate="`${content.required ? 'required':''}`"/>
                            </b-field>
                          </td>
                          <td> -->
                            <!-- 説明コメント用 -->
                          <!-- </td>
                        </tr> -->
                        <!-- ラジオボタン -->
                        <tr v-if="content.type==='radio' && (content.mode.indexOf(0)!=-1 || !reqParams.mode || content.mode.indexOf(reqParams.mode)!=-1)" :key="index">
                          <th style="white-space:pre-wrap;">{{content.displayName}}<span v-if="content.required" class="require"/></th>
                          <td>
                            <div>
                              <b-radio
                              v-for="tmpValue in content.displayValue"
                              v-model="content.value"
                              :value="tmpValue.value"
                              :key="tmpValue.key"
                              :name="'form4_2radio2_'+index"
                              :native-value="tmpValue.key"
                              :disabled="reqParams.reportFormatType==6"
                              style="text-align:left; margin-Right:10px;"
                              @click.native="inputRadioValue(tmpValue.key,'useModule')"
                              >{{tmpValue.value}}</b-radio>
                            </div>
                            <!-- :disabled="content.isDisabled=='true'" -->
                          </td>
                        </tr>
                      </template>
                      <!-- 預託在庫から申込みの場合シリアル入力する -->
                      <!-- <tr v-if="isInstrument && reqParams.useModule"> -->
                      <tr v-if="isInstrument && reqParams.useModule && this.reqParams.model !='RJPG500S16'">
                        <th style="white-space:pre-wrap;">シリアル<span class="require"/></th>
                        <td>
                          <input style="width:500px;" type="text" data-vv-as="通信モジュールシリアル" maxlength="20" v-model="reqParams.moduleSerial" :name="'form4_2char_'+index" v-validate="'required'"/>
                        </td>
                      </tr>
                    </table>
                  </div>
                  <div class="card-content margin-top">
                    <span style="font-size:20px;">マスク</span>
                    <table class="settings">
                      <tr>
                        <th style="white-space:pre-wrap;width:250px;">マスク：種類<span class="require"/></th>
                        <td>
                          <input disabled style="width:500px;" type="text" class="4" name="マスク種類" validate="required" v-model="reqParams.maskType"/>
                          <b-button type="is-primary" style="margin-left:10px; width:150px; height:27px;" v-on:click="getMaskMaster()">マスク選択</b-button>
                        </td>
                        <td>
                        </td>
                      </tr>
                      <tr>
                        <th style="white-space:pre-wrap;width:250px;">マスク：クッションサイズ<span class="require"/></th>
                        <td>
                          <input disabled style="width:500px;" type="text" class="4" name="クッションサイズ" validate="required" v-model="reqParams.cushionSize"/>
                        </td>
                        <td></td>
                      </tr>
                      <tr>
                        <th style="white-space:pre-wrap;width:250px;">マスク：フレームサイズ<span class="require"/></th>
                        <td>
                          <input disabled style="width:500px;" type="text" class="4" name="フレームサイズ" validate="required" v-model="reqParams.frameSize"/>
                        </td>
                        <td></td>
                      </tr>
                      <tr>
                        <th style="white-space:pre-wrap;width:250px;">マスク：固定方法<span class="require"/></th>
                        <td>
                          <input disabled style="width:500px;" type="text" class="4" name="固定方法" validate="required" v-model="reqParams.fixingMethod"/>
                        </td>
                        <td></td>
                      </tr>
                      <tr v-if="reqParams.maskType=='その他'">
                        <th style="white-space:pre-wrap;width:250px;">備考</th>
                        <td>
                          <textarea maxlength="256" style="resize:vertical;width:500px;max-width:500px;height:120px" v-model="reqParams.memo"></textarea>
                        </td>
                        <td></td>
                      </tr>
                    </table>
                  </div>
                </div>
              </form>
            </b-step-item>
            <b-step-item step="5" label="納品先情報" icon="clipboard-check-outline" v-if="!temp && !isInstrument && !resume">
              <form data-vv-scope="form5">
                <div id="item-contens">
                  <div class="request-title">
                    <b-button class="is-primary" style="float:left;" icon-left="chevron-double-left" @click.prevent="Backward">前へ</b-button>
                    <span>納品先を入力してください。</span>
                    <b-button class="is-primary" style="float:right;" icon-right="chevron-double-right" @click.prevent="Forward">次へ</b-button>
                  </div>
                  <div class="card-content margin-top">
                    <span style="font-size:20px;">納品先情報</span>
                    <table>
                      <tr><th>機器納品先<span class="require"/></th><td>
                        <div class="block">
                          <b-radio class="td_radio" name="target" v-model="reqParams.delivaryTarget" native-value="home" @input="changeDelivaryTarget(reqParams.delivaryTarget)">患者宅</b-radio>
                          <b-radio class="td_radio" name="target" v-model="reqParams.delivaryTarget" native-value="hospital" @input="changeDelivaryTarget(reqParams.delivaryTarget)">医療機関</b-radio>
                        </div></td>
                      </tr>
                      <tr><th></th>
                        <td style="vertical-align: middle;"><b-checkbox class="cstmCheckBox" value="true" v-model="reqParams.deliveryOther" @input="changeDelivaryTarget(reqParams.delivaryTarget)">お届け先住所を変更する</b-checkbox></td>
                        <td><span v-if="!isHospital && !isDealer" style="font-size:11px; color:red; text-align: left; display: inline-block;">※チェックをした場合、こちらの住所は得意先コードの住所（患者・医療機関）には反映されません。</br>※支店・営業所の住所は入力しないでください。</span></td>
                      </tr>
                      <template v-if="reqParams.deliveryOther">
                        <tr>
                          <th>
                            郵便番号<span class="require"/>
                          </th>
                          <td colspan="2">
                            <input
                              id="deliveryPostcode"
                              style="width: 270px;"
                              v-model="reqParams.deliveryPostcode"
                              class="5"
                              :class="{'border-red': invalidDeliveryPostcode}"
                              name="機器納品先の郵便番号"
                              validate="required|numeric|zip"
                              maxlength="7"
                              :placeholder="postcodePlaceholder"
                              @paste="onPaste"
                              @blur="onZipBlur(reqParams.deliveryPostcode, 'digitErrorDeliveryPostcode')"/>
                            <b-button
                              style="margin-left: 10px; width: 150px; height: 27px;"
                              v-on:click="addressSearch(reqParams.deliveryPostcode)"
                            >
                              自動入力
                            </b-button>
                            <div v-show="invalidDeliveryPostcode" class="text-red">{{ invalidNumberMessage }}</div>
                            <div v-show="digitErrorDeliveryPostcode" class="text-red">{{ digitErrorZipMessage }}</div>
                          </td>
                        </tr>
                        <tr><th>住所（都道府県、市町村区）<span class="require" style="margin-left:-8px;"/></th><td colspan="2"><input type="text" v-model="reqParams.deliveryAddress" class="5" name="機器納品先の住所（都道府県、市町村区）" validate="required" maxlength="280"/></td></tr>
                        <tr><th>住所（それ以降の住所）<span class="require"/></th><td colspan="2"><input type="text" v-model="reqParams.deliveryHouseNumber" class="5" name="機器納品先の住所（それ以降の住所）" validate="required" maxlength="256" ref="deliveryHouseNumber"/></td></tr>
                        <tr><th>住所（建物名、部屋番号）</th><td colspan="2"><input type="text" v-model="reqParams.deliveryBuilding" maxlength="256"/></td></tr>
                        <tr><th>納品先宛名<span class="require"/></th><td colspan="2"><input type="text" v-model="reqParams.deliveryDestination" maxlength="100" class="5" name="納品先宛名" validate="required"/></td></tr>
                        <tr>
                          <th>
                            連絡先（電話番号）<span class="require"/>
                          </th>
                          <td colspan="2">
                            <input
                              type="text"
                              v-model="reqParams.deliveryPhoneNumber"
                              maxlength="11"
                              class="5"
                              :class="{'border-red': invalidDeliveryPhoneNumber}"
                              name="機器納品先の連絡先（電話番号）"
                              validate="required|numeric"
                              :placeholder="phonePlaceholder"
                            />
                            <div v-show="invalidDeliveryPhoneNumber" class="text-red">{{ invalidNumberMessage }}</div>
                          </td>
                        </tr>
                      </template>
                      <template v-else>
                        <tr>
                          <th>
                            郵便番号<span class="require"/>
                          </th>
                          <td colspan="2">
                            <input
                              id="deliveryPostcode"
                              style="width: 270px;"
                              v-model="reqParams.deliveryPostcode"
                              class="5"
                              name="機器納品先の郵便番号"
                              validate="required|numeric"
                              maxlength="7"
                              disabled
                              :placeholder="postcodePlaceholder"/>
                          </td>
                        </tr>
                        <tr><th>住所（都道府県、市町村区）<span class="require" style="margin-left:-8px;"/></th><td colspan="2"><input type="text" v-model="reqParams.deliveryAddress" class="5" name="機器納品先の住所（都道府県、市町村区）" validate="required" maxlength="280" disabled/></td></tr>
                        <tr><th>住所（それ以降の住所）<span class="require"/></th><td colspan="2"><input type="text" v-model="reqParams.deliveryHouseNumber" class="5" name="機器納品先の住所（それ以降の住所）" validate="required" maxlength="256" disabled/></td></tr>
                        <tr><th>住所（建物名、部屋番号）</th><td colspan="2"><input type="text" v-model="reqParams.deliveryBuilding" maxlength="256" disabled/></td></tr>
                        <tr><th>納品先宛名<span class="require"/></th><td colspan="2"><input type="text" v-model="reqParams.deliveryDestination" maxlength="100" class="5" name="納品先宛名" validate="required" disabled/></td></tr>
                        <tr>
                          <th>
                            連絡先（電話番号）<span class="require"/>
                          </th>
                          <td colspan="2">
                            <input
                              type="text"
                              v-model="reqParams.deliveryPhoneNumber"
                              maxlength="11"
                              class="5"
                              name="機器納品先の連絡先（電話番号）"
                              validate="required|numeric"
                              disabled
                              :placeholder="phonePlaceholder"
                            />
                          </td>
                        </tr>
                      </template>
                    </table>
                  </div>
                </div>
              </form>
            </b-step-item>
            <b-step-item step="6" label="申込み" icon="cloud-upload">
              <div id="item-contens">
                <div class="request-title">
                  <b-button class="is-primary" style="float:left;" icon-left="chevron-double-left" @click.prevent="Backward" >前へ</b-button>
                  <span>以下の申込み内容を確認のうえ、下部の「申込みを完了する」ボタンを押下してください。</span>
                </div>
                <!--　申込み詳細 -->
                <cpapRequestDetail :data="reqParams" :showRequestMemo="false" v-bind:key="renderKey" :deliveryHidden="temp||isInstrument" :requestFlg="true" :isinstrument="isInstrument" :resume="resume"/>
                <div class="card-content margin-top">
                  <span style="font-size:20px;">その他</span>
                  <table>
                    <tr>
                      <th style="vertical-align:top;">備考</th>
                      <td>
                        <textarea maxlength="256" style="resize:vertical;max-width:100%;height:120px" v-model="reqParams.memo"></textarea>
                      </td>
                    </tr>
                    <tr><th></th><td><span style="font-size: 14px;">※伝達事項がございましたらご記入ください。</span></td></tr>
                  </table>
                </div>
                <b-button v-if="isHospitalNewOrder()" class="is-primary" style="margin-top:5px;width:250px;" @click="saveCpapRequestDraft">申込み内容を保存する</b-button>
                <b-button class="is-primary" style="margin-top:5px;width:250px;" @click="requestCpap">申込みを完了する</b-button>
              </div>
            </b-step-item>
            <b-step-item step="7" label="完了" icon="check" :type="{'is-success': true}">
              <section class="unPrintTarget">
                <div class="request-title"><span>処方申込みを受け付けました。</span></div>
                <div class="request-title" v-if="needAgree"><span style="color:red;">Philipsにて受付を実施いたします。受付完了しましたらメールにてご連絡いたします。</span></div>
                <div class="margin-top">
                  <b-button class="is-primary" @click="back">戻る</b-button>
                  <b-button v-if="(!isDealer&&(reqParams.reportFormatType == 1 || reqParams.reportFormatType == 2 || reqParams.reportFormatType == 3 || reqParams.reportFormatType == 4))" class="pdfbutton is-primary" icon-left="printer" @click="downloadInstructionsPDF">署名欄付き指示書PDF</b-button>
                  <b-button v-if="(isDealer||!(reqParams.reportFormatType == 1 || reqParams.reportFormatType == 2 || reqParams.reportFormatType == 3 || reqParams.reportFormatType == 4))" class="printbutton is-primary" icon-left="printer" @click="print">印刷</b-button>
                </div>
              </section>
              <section class="printTarget">
                <cpapRequestDetail :data="reqParams" :showRequestInfo="true" v-bind:key="renderKey" :deliveryHidden="temp||isInstrument" :requestFlg="true" :isinstrument="isInstrument" :resume="resume"/>
              </section>
            </b-step-item>
          </b-steps>
        </div>
        </form>
      </div>
    </section>
    <b-modal :active.sync="organizationModalActive" has-modal-card>
      <organizationSelectModal v-if="isSalesOffice || isHonsha || isAdmin" :selectRole="[role.role_hospital]" :selectStatus="extUserStatus.registed" :serviceId="serviceId" :cpapAgentReqFlg="cpapAgentReqFlg" title="医療機関選択" labelForOrg="医療機関名" :cpapDepositUseFlg="isInstrument" @select="setOrganization"></organizationSelectModal>
      <facilitySelectModal v-if="isDealer" :dealerId="userId" @select="setfacility"></facilitySelectModal>
    </b-modal>
    <b-modal :active.sync="maskSelectModalActive" has-modal-card full-screen>
      <cpapMaskSelectModal :formatType="formatType" @select="maskSelect"></cpapMaskSelectModal>
    </b-modal>
    <b-modal :active.sync="tempDeviceSelectModalActive" has-modal-card>
      <instrumentSelectModal @select="tempDeviceSelect" :selectModel="reqParams.model" :selectSerial="reqParams.serial" :searchType="0" :belongsId="reqParams.belongsId" :isShowDisconItems="(reqParams.kind == cpapKindMap.applicationTempRemoval)" :estimateDetailCode="initEstimateDetailCode"></instrumentSelectModal>
    </b-modal>
  </div>
</template>
<script>
import {
  role,
  consentStatement,
  choicesType,
  extUserStatus,
  LendingPeriod,
  cpapRequestStatus,
  cpapKindMap,
  invalidNumberMessage,
  postcodePlaceholder,
  phonePlaceholder,
  prescriptionHardwareList,
  digitErrorZipMessage,
} from "@/components/mock/base/const.js";
import OrganizationSelectModal from "@/components/mock/philips/common/OrganizationSelectModal";
import CpapMaskSelectModal from "@/components/mock/philips/common/CpapMaskSelectModal";
import FacilitySelectModal from "@/components/mock/philips/common/FacilitySelectModal";
import InstrumentSelectModal from "@/components/mock/philips/common/InstrumentSelectModal";
import OfficeCalenderModal from "@/components/mock/guest/OfficeCalenderModal";
import CpapRequestDetail from "@/components/mock/common/CpapRequestDetail";
import {service} from "@/components/mock/base/const.js";

export default {
  name: "CpapRequest",
  methods: {
    Backward: function() {
      this.activeStep -= 1;
    },
    Forward: async function(event) {
      // バリデーションチェック
      var stepItems = document.getElementsByClassName("step-item")
      var target
      for(var item of stepItems){
        if(item.getAttribute("style") != "display: none;"){
          target = item
        }
      }
      var activeStep = target ? target.getAttribute("step") : ""
      if(activeStep){
        var errorMsg = "";
        var errMsg = ""
        var errorFlag = false;
        var errorList = "";
        if (!this.reqParams.existingFlag) {
          const validateResult = await this.$validator.validateAll("form"+activeStep);
          // QA427_エラー内容を項目ごとに取得
          if (!validateResult) {
            errorFlag = true
            errorList = this.$validator.errors.items;
          }
        }
        // 患者情報のバリデーション
        var elements = document.getElementsByClassName(activeStep)
        var result = this.selfMadeValidation(elements)
        errorMsg = errorMsg + result.msg
        if(activeStep==2){
          var phoneNumber = document.getElementById("phoneNumber")
          var mobilePhone = document.getElementById("mobilePhone")
          phoneNumber.style["border-color"] = "";
          mobilePhone.style["border-color"] = "";
          if(!this.reqParams.patient.phoneNumber && !this.reqParams.patient.mobilePhone){
            // 患者の連絡先がいずれも未入力の場合
            errorFlag = true
            errorMsg = errorMsg + "「連絡先（携帯電話）」「連絡（自宅・その他）」いずれかは必須項目です。\n"
            phoneNumber.style["border-color"] = "red";
            mobilePhone.style["border-color"] = "red";
          }
          // 納品先情報を取得
          if (this.reqParams.delivaryTarget == 'home' && !this.reqParams.deliveryOther) {
            this.reqParams.deliveryPostcode = this.reqParams.patient.zip
            this.reqParams.deliveryAddress = this.reqParams.patient.address
            this.reqParams.deliveryHouseNumber = this.reqParams.patient.address1
            this.reqParams.deliveryBuilding = this.reqParams.patient.address2
            this.reqParams.deliveryDestination = this.reqParams.patient.patientFamilyName + " " + this.reqParams.patient.patientFirstName
            if (this.reqParams.patient.mobilePhone) {
              this.reqParams.deliveryPhoneNumber = this.reqParams.patient.mobilePhone
            } else {
              this.reqParams.deliveryPhoneNumber = this.reqParams.patient.phoneNumber
            }
          }
        }
        // 移行データは患者情報以外バリデーション制御を入れない
        if (!this.reqParams.existingFlag) {
          if(activeStep==3){
            var correlationList = [];
            var model = this.modelList.find(val => val.itemCodes && val.itemCodes.indexOf(this.reqParams.model) != -1)
            // 相関チェック
            if (this.reqParams.mode) {
              switch(model.reportFormatType){
                case 1:
                  // ドリームステーションAuto
                  var lampStart = this.reqParams.prescriptionItems.find(val => val.displayName == "ランプスタート圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
                  if(this.reqParams.mode == "1"){
                    var pressureMin = this.reqParams.prescriptionItems.find(val => val.displayName == "最小圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
                    var pressureMax = this.reqParams.prescriptionItems.find(val => val.displayName == "最大圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
                    if (errorMsg.indexOf("最小圧【hPa(cmH2O)】") == -1 && errorMsg.indexOf("最大圧【hPa(cmH2O)】") == -1 ) { // QA427_一括表示対応（単項目チェックを通過した項目のみ項目間チェック）
                      if(Number(pressureMin.value) > Number(pressureMax.value)){
                        // "最小圧【hPa(cmH2O)】" <= "最大圧【hPa(cmH2O)】" でない時
                        correlationList.push({
                          displayOrder: pressureMin.displayOrder,
                          msg: "「最小圧」に「最大圧」以下の値を設定してください。\n",
                        });
                        errorFlag = true;
                      }
                    }
                    if (errorMsg.indexOf("最小圧【hPa(cmH2O)】") == -1 && errorMsg.indexOf("ランプスタート圧【hPa(cmH2O)】") == -1 ) { // QA427_一括表示対応（単項目チェックを通過した項目のみ項目間チェック）
                      if(Number(lampStart.value) > Number(pressureMin.value)){
                        // "ランプスタート圧【hPa(cmH2O)】" <= "最小圧【hPa(cmH2O)】" でない時
                        correlationList.push({
                          displayOrder: lampStart.displayOrder,
                          msg: "「ランプスタート圧」に「最小圧」以下の値を設定してください。\n",
                        });
                        errorFlag = true;
                      }
                    }
                  }else{
                    var pressureCpap = this.reqParams.prescriptionItems.find(val => val.displayName == "CPAP圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
                    if (errorMsg.indexOf("CPAP圧【hPa(cmH2O)】") == -1 && errorMsg.indexOf("ランプスタート圧【hPa(cmH2O)】") == -1 ) { // QA427_一括表示対応（単項目チェックを通過した項目のみ項目間チェック）
                      if(Number(lampStart.value) > Number(pressureCpap.value)){
                        // "ランプスタート圧【hPa(cmH2O)】" <= "CPAP圧【hPa(cmH2O)】" でない時
                        correlationList.push({
                          displayOrder: lampStart.displayOrder,
                          msg: "「ランプスタート圧」に「CPAP圧」以下の値を設定してください。\n",
                        });
                        errorFlag = true;
                      }
                    }
                  }
                  break;
                case 2:
                  // ドリームステーションPro
                  var lampStart = this.reqParams.prescriptionItems.find(val => val.displayName == "ランプスタート圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
                  var pressureCpap = this.reqParams.prescriptionItems.find(val => val.displayName == "CPAP圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
                  if (errorMsg.indexOf("CPAP圧【hPa(cmH2O)】") == -1 && errorMsg.indexOf("ランプスタート圧【hPa(cmH2O)】") == -1 ) { // QA427_一括表示対応（単項目チェックを通過した項目のみ項目間チェック）
                    if(Number(lampStart.value) > Number(pressureCpap.value)){
                      // "ランプスタート圧【hPa(cmH2O)】" <= "CPAP圧【hPa(cmH2O)】" でない時
                      correlationList.push({
                        displayOrder: lampStart.displayOrder,
                        msg: "「ランプスタート圧」に「CPAP圧」以下の値を設定してください。\n",
                      });
                      errorFlag = true;
                    }
                  }
                  break;
                case 3:
                  // ドリームステーションGo
                  var lampStart = this.reqParams.prescriptionItems.find(val => val.displayName == "ランプスタート圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
                  if(this.reqParams.mode == "1"){
                    var pressureMax = this.reqParams.prescriptionItems.find(val => val.displayName == "最大圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
                    var pressureMin = this.reqParams.prescriptionItems.find(val => val.displayName == "最小圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
                    if (errorMsg.indexOf("最小圧【hPa(cmH2O)】") == -1 && errorMsg.indexOf("最大圧【hPa(cmH2O)】") == -1 ) { // QA427_一括表示対応（単項目チェックを通過した項目のみ項目間チェック）
                      if(Number(pressureMin.value) > Number(pressureMax.value)){
                        // "最小圧【hPa(cmH2O)】" <= "最大圧【hPa(cmH2O)】" でない時
                        correlationList.push({
                          displayOrder: pressureMin.displayOrder,
                          msg: "「最小圧」に「最大圧」以下の値を設定してください。\n",
                        });
                        errorFlag = true;
                      }
                    }
                    if (errorMsg.indexOf("最小圧【hPa(cmH2O)】") == -1 && errorMsg.indexOf("ランプスタート圧【hPa(cmH2O)】") == -1 ) { // QA427_一括表示対応（単項目チェックを通過した項目のみ項目間チェック）
                      if(Number(lampStart.value) > Number(pressureMin.value)){
                        // "ランプスタート圧【hPa(cmH2O)】" <= "最小圧【hPa(cmH2O)】" でない時
                        correlationList.push({
                          displayOrder: lampStart.displayOrder,
                          msg: "「ランプスタート圧」に「最小圧」以下の値を設定してください。\n",
                        });
                        errorFlag = true;
                      }
                    }
                  }else{
                    var pressureCpap = this.reqParams.prescriptionItems.find(val => val.displayName == "CPAP圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
                    if (errorMsg.indexOf("CPAP圧【hPa(cmH2O)】") == -1 && errorMsg.indexOf("ランプスタート圧【hPa(cmH2O)】") == -1 ) { // QA427_一括表示対応（単項目チェックを通過した項目のみ項目間チェック）
                      if(Number(lampStart.value) > Number(pressureCpap.value)){
                        // "ランプスタート圧【hPa(cmH2O)】" <= "CPAP圧【hPa(cmH2O)】" でない時
                        correlationList.push({
                          displayOrder: lampStart.displayOrder,
                          msg: "「ランプスタート圧」に「CPAP圧」以下の値を設定してください。\n",
                        });
                        errorFlag = true;
                      }
                    }
                  }
                  break;
                case 4:
                  // ドリームステーションBiPAP Auto
                  var lampStart = this.reqParams.prescriptionItems.find(val => val.displayName == "ランプスタート圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
                  if(this.reqParams.mode == "4"){
                    // CPAPモード
                    var pressureCpap = this.reqParams.prescriptionItems.find(val => val.displayName == "CPAP圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
                    if (errorMsg.indexOf("CPAP圧【hPa(cmH2O)】") == -1 && errorMsg.indexOf("ランプスタート圧【hPa(cmH2O)】") == -1 ) { // QA427_一括表示対応（単項目チェックを通過した項目のみ項目間チェック）
                      if(Number(lampStart.value) > Number(pressureCpap.value)){
                        // "ランプスタート圧【hPa(cmH2O)】" <= "CPAP圧【hPa(cmH2O)】" でない時
                        correlationList.push({
                          displayOrder: lampStart.displayOrder,
                          msg: "「ランプスタート圧」に「CPAP圧」以下の値を設定してください。\n",
                        });
                        errorFlag = true;
                      }
                    }
                  }else if(this.reqParams.mode == "8"){
                    // Bi-Levelモード
                    var epap = this.reqParams.prescriptionItems.find(val => val.displayName == "EPAP【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
                    var ipap = this.reqParams.prescriptionItems.find(val => val.displayName == "IPAP【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
                    if (errorMsg.indexOf("EPAP【hPa(cmH2O)】") == -1 && errorMsg.indexOf("IPAP【hPa(cmH2O)】") == -1 ) { // QA427_一括表示対応（単項目チェックを通過した項目のみ項目間チェック）
                      if(Number(epap.value) > Number(ipap.value)){
                        // "EPAP【hPa(cmH2O)】" <= "IPAP【hPa(cmH2O)】" で無い時
                        correlationList.push({
                          displayOrder: epap.displayOrder,
                          msg: "「EPAP」に「IPAP」以下の値を設定してください。\n",
                        });
                        errorFlag = true;
                      }
                    }
                    if (errorMsg.indexOf("EPAP【hPa(cmH2O)】") == -1 && errorMsg.indexOf("ランプスタート圧【hPa(cmH2O)】") == -1 ) { // QA427_一括表示対応（単項目チェックを通過した項目のみ項目間チェック）
                      if(Number(lampStart.value) > Number(epap.value)){
                        // "ランプスタート圧【hPa(cmH2O)】" <= "EPAP【hPa(cmH2O)】" でない時
                        correlationList.push({
                          displayOrder: lampStart.displayOrder,
                          msg: "「ランプスタート圧」に「EPAP」以下の値を設定してください。\n",
                        });
                        errorFlag = true;
                      }
                    }
                    var flex = this.reqParams.prescriptionItems.find(val => val.displayName == "Flexタイプ" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
                    if(flex.value=="1"){
                      // 20251128_緊急対応
                      // Bi-Flex
                      // if (errorMsg.indexOf("EPAP【hPa(cmH2O)】") == -1 && errorMsg.indexOf("IPAP【hPa(cmH2O)】") == -1 ) { // QA427_一括表示対応（単項目チェックを通過した項目のみ項目間チェック）
                      //   if(Number(epap.value) == Number(ipap.value)){
                      //     // 「IPAPの値≠EPAPの値」でない場合
                      //     errMsg = errMsg + "「EPAP」「IPAP」に異なる値を設定してください。\n"
                      //     errorFlag = true;
                      //   }
                      // }
                    }else if(flex.value=="2" || flex.value=="3"){
                      // C-Flex
                      // C-Flex+
                      if (errorMsg.indexOf("EPAP【hPa(cmH2O)】") == -1 && errorMsg.indexOf("IPAP【hPa(cmH2O)】") == -1 ) { // QA427_一括表示対応（単項目チェックを通過した項目のみ項目間チェック）
                        if(Number(epap.value) != Number(ipap.value)){
                          // 「IPAPの値=EPAPの値」でない場合
                          correlationList.push({
                            displayOrder: epap.displayOrder,
                            msg: "「EPAP」「IPAP」に同じ値を設定してください。\n",
                          });
                          errorFlag = true;
                        }
                      }
                    }
                  }else if(this.reqParams.mode == "1"){
                    // Auto Bi-Levelモード
                    var epapMin = this.reqParams.prescriptionItems.find(val => val.displayName == "EPAP最小圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
                    var ipapMax = this.reqParams.prescriptionItems.find(val => val.displayName == "IPAP最大圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
                    if (errorMsg.indexOf("EPAP最小圧【hPa(cmH2O)】") == -1 && errorMsg.indexOf("IPAP最大圧【hPa(cmH2O)】") == -1 ) { // QA427_一括表示対応（単項目チェックを通過した項目のみ項目間チェック）
                      if(Number(epapMin.value) > Number(ipapMax.value)){
                        // "EPAP最小圧【hPa(cmH2O)】" <= "IPAP最大圧【hPa(cmH2O)】" で無い時
                        correlationList.push({
                          displayOrder: epapMin.displayOrder,
                          msg: "「EPAP最小圧」に「IPAP最大圧」以下の値を設定してください。\n",
                        });
                        errorFlag = true;
                      }
                    }
                    var psMin = this.reqParams.prescriptionItems.find(val => val.displayName == "PS最小圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
                    var psMax = this.reqParams.prescriptionItems.find(val => val.displayName == "PS最大圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
                    if (errorMsg.indexOf("PS最小圧【hPa(cmH2O)】") == -1 && errorMsg.indexOf("PS最大圧【hPa(cmH2O)】") == -1 ) { // QA427_一括表示対応（単項目チェックを通過した項目のみ項目間チェック）
                      if(Number(psMin.value) > Number(psMax.value)){
                        // "PS最小圧【hPa(cmH2O)】" <= "PS最大圧【hPa(cmH2O)】" で無い時
                        correlationList.push({
                          displayOrder: psMin.displayOrder,
                          msg: "「PS最小圧」に「PS最大圧」以下の値を設定してください。\n",
                        });
                        errorFlag = true;
                      }
                    }
                    if (errorMsg.indexOf("PS最大圧【hPa(cmH2O)】】") == -1 && errorMsg.indexOf("IPAP最大圧【hPa(cmH2O)】") == -1 && errorMsg.indexOf("EPAP最小圧【hPa(cmH2O)】") == -1 ) { // QA427_一括表示対応（単項目チェックを通過した項目のみ項目間チェック）
                      // QA474_処方値関連残
                      if (this.bipapvaliFlag) {
                        // QA267_DS BiPAP AutoにおいてminEPAPとmaxIPAPの差分とPSの設定範囲の関係性が考慮できていない
                        if (Number(ipapMax.value) - Number(epapMin.value) < Number(psMax.value)) {
                          // "IPAP最大圧【hPa(cmH2O)"-"EPAP最小圧【hPa(cmH2O)】" >= "PS最大圧【hPa(cmH2O)】" で無い時
                          correlationList.push({
                            displayOrder: psMax.displayOrder,
                            msg: "「PS最大圧」に「IPAP最大圧」-「EPAP最小圧」以下の値を設定してください。\n",
                          });
                          errorFlag = true;
                        }
                      }
                    }
                    if (errorMsg.indexOf("EPAP最小圧【hPa(cmH2O)】") == -1 && errorMsg.indexOf("ランプスタート圧【hPa(cmH2O)】") == -1 ) { // QA427_一括表示対応（単項目チェックを通過した項目のみ項目間チェック）
                      if(Number(lampStart.value) > Number(epapMin.value)){
                        // "ランプスタート圧【hPa(cmH2O)】" <= "EPAP最小圧【hPa(cmH2O)】" でない時
                        correlationList.push({
                          displayOrder: lampStart.displayOrder,
                          msg: "「ランプスタート圧」に「EPAP最小圧」以下の値を設定してください。\n",
                        });
                        errorFlag = true;
                      }
                    }
                    var flex = this.reqParams.prescriptionItems.find(val => val.displayName == "Flexタイプ" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
                    if(flex.value=="1"){
                      // 20251128_緊急対応
                      // Bi-Flex
                      // if (errorMsg.indexOf("PS最小圧【hPa(cmH2O)】") == -1 && errorMsg.indexOf("PS最大圧【hPa(cmH2O)】") == -1 ) { // QA427_一括表示対応（単項目チェックを通過した項目のみ項目間チェック）
                      //   if(Number(psMin.value)==0 && Number(psMax.value)==0){
                      //     // 「PS最小圧≠0 または PS最大圧≠0 」でない場合
                      //     errMsg = errMsg + "「PS最小圧」または「PS最大圧」に0以外の値を設定してください。\n"
                      //     errorFlag = true;
                      //   }
                      // }
                    }else if(flex.value=="2"){
                      // C-Flex
                      // if (errorMsg.indexOf("PS最小圧【hPa(cmH2O)】") == -1 && errorMsg.indexOf("PS最大圧【hPa(cmH2O)】") == -1 ) { // QA427_一括表示対応（単項目チェックを通過した項目のみ項目間チェック）
                      //   if(Number(psMin.value)!=0 || Number(psMax.value)!=0){
                      //     // 「PS最小圧=0」且つ「PS最大圧=0」でない場合
                      //     errMsg = errMsg + "「PS最小圧」「PS最大圧」に0を設定してください。\n"
                      //     errorFlag = true;
                      //   }
                      // }
                    }
                  }
                  break;
                case 5:
                  // エスボックス バイスタルク
                  var lampStart = this.reqParams.prescriptionItems.find(val => val.displayName == "ランプ開始圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
                  if(this.reqParams.mode == "4"){
                    // CPAPモード
                    // "ランプ開始圧【hPa(cmH2O)】" <= "CPAP圧【hPa(cmH2O)】" でない時
                  }else if(this.reqParams.mode == "1"){
                    // Auto CPAPモード
                    var pressureMax = this.reqParams.prescriptionItems.find(val => val.displayName == "最大圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
                    var pressureMin = this.reqParams.prescriptionItems.find(val => val.displayName == "最小圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
                    if (errorMsg.indexOf("最大圧【hPa(cmH2O)】") == -1 && errorMsg.indexOf("最小圧【hPa(cmH2O)】") == -1 ) { // QA427_一括表示対応（単項目チェックを通過した項目のみ項目間チェック）
                      if(Number(pressureMin.value) > Number(pressureMax.value)){
                        // "最小圧【hPa(cmH2O)】" <= "最大圧【hPa(cmH2O)】" でない時
                        correlationList.push({
                          displayOrder: pressureMin.displayOrder,
                          msg: "「最小圧」に「最大圧」以下の値を設定してください。\n",
                        });
                        errorFlag = true;
                      }
                    }
                    if (errorMsg.indexOf("ランプ開始圧【hPa(cmH2O)】") == -1 && errorMsg.indexOf("最小圧【hPa(cmH2O)】") == -1 ) { // QA427_一括表示対応（単項目チェックを通過した項目のみ項目間チェック）
                      if(Number(lampStart.value) > Number(pressureMin.value)){
                        // "ランプ開始圧【hPa(cmH2O)】" <= "最小圧【hPa(cmH2O)】" でない時
                        correlationList.push({
                          displayOrder: lampStart.displayOrder,
                          msg: "「ランプ開始圧」に「最小圧」以下の値を設定してください。\n",
                        });
                        errorFlag = true;
                      }
                    }
                  }
                  break;
                case 6:
                  // プリズマ ライン (prisma25S)
                  if(this.reqParams.mode == "1"){
                    // APAPモード
                    var pressureMax = this.reqParams.prescriptionItems.find(val => val.displayName == "最大圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
                    var pressureMin = this.reqParams.prescriptionItems.find(val => val.displayName == "最小圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
                    if (errorMsg.indexOf("最大圧【hPa(cmH2O)】") == -1 && errorMsg.indexOf("最小圧【hPa(cmH2O)】") == -1 ) { // QA427_一括表示対応（単項目チェックを通過した項目のみ項目間チェック）
                      if(Number(pressureMin.value) > Number(pressureMax.value)){
                        // "最小圧【hPa(cmH2O)】" <= "最大圧【hPa(cmH2O)】" でない時
                        correlationList.push({
                          displayOrder: pressureMin.displayOrder,
                          msg: "「最小圧」に「最大圧」以下の値を設定してください。\n",
                        });
                        errorFlag = true;
                      }
                    }
                  }else if(this.reqParams.mode == "7"){
                    // Sモード
                    var epap = this.reqParams.prescriptionItems.find(val => val.displayName == "EPAP圧【hPa（cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
                    var ipap = this.reqParams.prescriptionItems.find(val => val.displayName == "IPAP圧【hPa（cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
                    if (errorMsg.indexOf("EPAP圧【hPa（cmH2O)】") == -1 && errorMsg.indexOf("IPAP圧【hPa（cmH2O)】") == -1 ) { // QA427_一括表示対応（単項目チェックを通過した項目のみ項目間チェック）
                      if(Number(epap.value) > Number(ipap.value)){
                        // "EPAP【hPa(cmH2O)】" <= "IPAP【hPa(cmH2O)】" で無い時
                        correlationList.push({
                          displayOrder: epap.displayOrder,
                          msg: "「EPAP」に「IPAP」以下の値を設定してください。\n",
                        });
                        errorFlag = true;
                      }
                    }
                  }else if(this.reqParams.mode == "9"){
                    // autoSモード
                    var pdiffMin = this.reqParams.prescriptionItems.find(val => val.displayName == "PDIFF min 圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
                    var pdiffMax = this.reqParams.prescriptionItems.find(val => val.displayName == "PDIFF max 圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
                    if (errorMsg.indexOf("PDIFF min 圧【hPa(cmH2O)】") == -1 && errorMsg.indexOf("PDIFF max 圧【hPa(cmH2O)】") == -1 ) { // QA427_一括表示対応（単項目チェックを通過した項目のみ項目間チェック）
                      if(Number(pdiffMin.value) > Number(pdiffMax.value)){
                        // "PDIFF min 圧【hPa(cmH2O)】" <= "PDIFF max 圧【hPa(cmH2O)】" で無い時
                        correlationList.push({
                          displayOrder: pdiffMin.displayOrder,
                          msg: "「PDIFF min 圧」に「PDIFF max 圧」以下の値を設定してください。\n",
                        });
                        errorFlag = true;
                      }
                    }
                  }
                  break;
              }
            }
            // 必須チェック結果をdisplayOrderとメッセージのみにする
            var sortList = [];
            if (errorList) {
              sortList = errorList.map(val => {
                const match = val.field.match(/_(\d+)$/);
                let num = match ? Number(match[1]) : null;
                if (val.field.includes("form3")) {
                  num = num + 1;
                }
                return {
                  displayOrder: num,
                  msg: val.msg + "。\n",
                };
              });
            }
            // 必須チェックと相関チェックのエラーメッセージを統合してdisplayOrder順に並び替え
            sortList.push(...correlationList);
            sortList.sort((first, second) => first.displayOrder - second.displayOrder);

            // 表示するメッセージ変数に格納
            for (var i = 0; i < sortList.length; i++) {
              const error = sortList[i];
              errorMsg = errorMsg + error.msg;
            }
          } else if (activeStep==4) {
            // 必須チェック結果をdisplayOrderとメッセージのみにする
            var sortList = [];
            if (errorList) {
              sortList = errorList.map(val => {
                const match = val.field.match(/_(\d+)$/);
                let num = match ? Number(match[1]) : null;
                if (val.field.includes("form4_2")) {        // モデム
                  if (num == null) {
                    num = num + 299;
                  } else {
                    num = num + 200;
                  }
                } else if (val.field.includes("form4")) {   // 加湿器
                  if (num == null) {
                    num = num + 199;
                  } else {
                    num = num + 100;
                  }
                }
                return {
                  displayOrder: num,
                  msg: val.msg + "。\n",
                };
              });
            }
            // 必須チェックと相関チェックのエラーメッセージを統合してdisplayOrder順に並び替え
            sortList.push(...correlationList);
            sortList.sort((first, second) => first.displayOrder - second.displayOrder);

            // 表示するメッセージ変数に格納
            var errorMsg = "";
            for (var i = 0; i < sortList.length; i++) {
              const error = sortList[i];
              errorMsg = errorMsg + error.msg;
            }
            var elements = document.getElementsByClassName(4);
            var result = this.selfMadeValidation(elements);
            errorMsg = errorMsg + result.msg;
          }
        } else {
          // マスクのバリデーションをかけない
          if (activeStep == 4) {
            result.isError = false
            result.msg = ""
            errorFlag = false
            errorMsg = ""
          }
        }
        if (errorFlag || result.isError) {
          errorMsg = errorMsg + errMsg;
          this.showErrorMessage(errorMsg)
          return
        } else {
          // 再レンダリングの為、フラグ切替
          this.renderKey = !this.renderKey
          this.activeStep += 1;
        }
      }
    },
    isHideItem: function(displayName) {
      if(displayName == "登録方法"){
        var patientManagement = this.reqParams.prescriptionItems.find(val => val.displayName == "患者情報管理")
        if(patientManagement && patientManagement.value=='0'){
          return true
        }
      }
      if(displayName == "E-mailアドレス"){
        var mobileApply = this.reqParams.prescriptionItems.find(val => val.displayName == "モバイルアプリ")
        if(mobileApply && mobileApply.value=='0'){
          return true
        }
      }
      return false
    },
    isHospitalNewOrder() {
      return (this.isHospital || this.isDealer) && !this.temp;
    },
    saveCpapRequestDraft() {
      const THIS = this;
      this.$dialog.confirm({
        title: "　",
        message: "申込み内容を保存して入力操作を終了します。",
        cancelText: "キャンセル",
        confirmText: "OK",
        onConfirm: THIS.executeSaveCpapRequestDraft,
      });
    },
    executeSaveCpapRequestDraft() {
      const THIS = this;
      // QA402 再開申込み、預託申込みで指示書保存可能とする
      var belongsId, institutionId, patientCode, serial, moistItemCode, moistSerial, moduleItemCode, moduleSerial, itemCode
      var resume = this.reqParams.resume
      var cancelResume = this.reqParams.cancelResume
      var depositUseFlag = this.reqParams.depositUseFlag
      if (resume) {
        belongsId = this.reqParams.transferDestinationId
        institutionId = this.reqParams.transferInstitutionId ? this.reqParams.transferInstitutionId : null
      } else {
        belongsId = this.belongsId
        institutionId = this.institutionId ? this.institutionId : null
      }
      if (resume || cancelResume) {
        patientCode = this.reqParams.patientCode
        itemCode = this.reqParams.model
        serial = this.reqParams.serial
        moistItemCode = this.reqParams.moistItemCode
        moistSerial = this.reqParams.moistSerial
        moduleItemCode = this.reqParams.moduleItemCode
        moduleSerial = this.reqParams.moduleSerial
      }
      if (depositUseFlag) {
        serial = this.reqParams.serial
        moistSerial = this.reqParams.moistSerial
        moduleSerial = this.reqParams.moduleSerial
      }
      var body = {
        tempReceptionNo: this.reqParams.tempReceptionNo,
        belongsId: belongsId,
        institutionId: institutionId,
        applicationType: this.reqParams.kind,
        medicalInstitutionName: this.reqParams.medicalInstitutionName,
        doctorName: this.reqParams.doctorName,
        clerkName: this.reqParams.clerkName,
        patientCardId: this.reqParams.patient.patientRegistrationCard,
        patientLastName: this.reqParams.patient.patientFamilyName,
        patientFirstName: this.reqParams.patient.patientFirstName,
        patientLastNameKana: this.reqParams.patient.patientFamilyNameKana,
        patientFirstNameKana: this.reqParams.patient.patientFirstNameKana,
        patientGender: this.reqParams.patient.gender,
        patientBirthday: this.reqParams.patient.birthday,
        patientReceiverName: this.reqParams.patient.receiverName,
        patientPostCode: this.reqParams.patient.zip,
        patientAddress: this.reqParams.patient.address,
        patientAddressHouseNumber: this.reqParams.patient.address1,
        patientAddressBuildingName: this.reqParams.patient.address2,
        patientMobilePhoneNumber: this.reqParams.patient.mobilePhone,
        patientOtherPhoneNumber: this.reqParams.patient.phoneNumber,
        isEnabledFollowUpCall: this.reqParams.patient.followUpCall,
        diseaseName: this.reqParams.patient.disease,
        infectionType: this.reqParams.patient.infection,
        infectionName: this.reqParams.patient.infectionName,
        regionalInstitutionName: this.reqParams.patient.hospitalName,
        regionalDoctorName: this.reqParams.patient.doctorName,
        deviceFormatType: this.reqParams.reportFormatType,
        deviceSettingInfo: this.reqParams.prescriptionItems,
        maskId: this.reqParams.maskId,
        destType: this.convertDestType(this.reqParams.delivaryTarget, true),
        deliveryOther: this.reqParams.deliveryOther,
        destPostCode: this.reqParams.zip,
        destAddress: this.reqParams.address,
        destAddressHouseNumber: this.reqParams.address1,
        destAddressBuildingName: this.reqParams.address2,
        destReceiverName: this.reqParams.receiverName,
        destPhoneNumber: this.reqParams.phoneNumber,
        remarks: this.reqParams.memo,
        resume: resume,
        patientCode: patientCode,
        serial: serial,
        moistItemCode: moistItemCode,
        moistSerial: moistSerial,
        moduleItemCode: moduleItemCode,
        moduleSerial: moduleSerial,
        cancelResume: cancelResume,
        depositUseFlag: depositUseFlag,
        mailNotification: this.reqParams.mailNotification,
        hospitalMail: this.reqParams.hospitalMail,
        changeBeforeData: this.changeBeforeData,
        itemCode: itemCode,
        zip: this.reqParams.zip,
        address: this.reqParams.address,
        address1: this.reqParams.address1,
        address2: this.reqParams.address2,
        receiverName: this.reqParams.receiverName,
        phoneNumber: this.reqParams.phoneNumber,
        deliveryPostcode: this.reqParams.deliveryPostcode,
        deliveryAddress: this.reqParams.deliveryAddress,
        deliveryHouseNumber: this.reqParams.deliveryHouseNumber,
        deliveryBuilding: this.reqParams.deliveryBuilding,
        deliveryDestination: this.reqParams.deliveryDestination,
        deliveryPhoneNumber: this.reqParams.deliveryPhoneNumber,
        preReceiptNumber: this.preReceiptNumber,
        preKind: this.preKind
      };
      this.apiCall(
        (client) => {
          return client.apis.externalCpap.saveCpapRequestDraft({
            body: body,
          });
        },
        (result) => {
          THIS.showSuccess(result, THIS.goHome);
        },
        (error) => {
          THIS.showErrorMessage(error);
        }
      );
    },
    convertDestType(value, isGetKey) {
      const DEST_TYPE_MAP = {
        1: "home",
        2: "hospital"
      }
      if(isGetKey) {
        return Object.keys(DEST_TYPE_MAP).find((key) => DEST_TYPE_MAP[key] == value);
      } else {
        return DEST_TYPE_MAP[value];
      }
    },
    requestCpap: function() {
      var model = this.modelList.find(val => val.itemCodes && val.itemCodes.indexOf(this.reqParams.model) != -1)
      var messsage = model.itemName
      messsage += "の処方を申込みます。<br/>機種が正しいことを確認して「OK」ボタンを押してください。"
      this.$dialog.confirm({
        title: "申込み確認",
        message: messsage,
        cancelText: "修正する",
        onConfirm: async () => {
          this.compleateFlg = false;
          var excuteApi = this.setCpapPrescriptionRequestPOST;
          var successCallBack = this.setCpapPrescriptionRequestPOSTSuccess;
          var errorCallBack = this.setCpapPrescriptionRequestPOSTError;
          // WebAPI Call
          await this.apiCall(excuteApi, successCallBack, errorCallBack)
          if(this.compleateFlg){
            this.jumpToTop();
            this.activeStep += 1;
          }
        }
      });
    },
    setCpapPrescriptionRequestPOST: function(client) {
      var obj = JSON.parse(JSON.stringify(this.reqParams));
      obj.clientDate = new Date().toString();
      if (!obj.mailNotification) {
        obj.hospitalMail = ""
      }
      // QA478　選択していないモードの設定値をデフォルトに変更する
      if (obj.prescriptionItems && obj.mode) {
        for (let setting of obj.prescriptionItems) {
          switch(setting.category) {
            case 0: // 本体
              if (setting.mode && !setting.mode.includes("0") && !setting.mode.includes(obj.mode)) {
                setting.value = setting.defaultValue
              }
              break;
            case 1: // 加湿器
            case 2: // モデム
              break;
          }
        }
      }
      // 処方再開の場合
      let changedItems = []
      if(obj.kind == cpapKindMap.applicationResume){
        if(this.changeBeforeData){
          var moistAddFlag = false; //加湿器追加フラグ
          var modulAddFlag = false; //モデム追加フラグ
          // 加湿器追加時（無⇒有）
          if(obj.useMoist && !(this.changeBeforeData.useMoist)){
            moistAddFlag = true;
          }
          // モデム追加時（無⇒有）
          if(obj.useModule && !(this.changeBeforeData.useModule)){
            modulAddFlag = true;
          }
          // 変更した項目(値)をチェック
          for(var item of this.changedCheckItems){
            // 患者情報の場合は、チェック項目の階層が異なる
            var beforeTarget = item.key == "patientArea" ? this.changeBeforeData.patient : this.changeBeforeData
            var target = item.key == "patientArea" ? obj.patient : obj
            // 初期値セット
            var checkValue = {areaName:item.key, isChange:false, items:[]}

            if(item.key == "prescriptionArea"){
              // 設定情報の場合、全項目を順に比較
              var moistAreaValue = {areaName:"moistArea", isChange:false, items:[], moistAdd:moistAddFlag}
              var moduleAreaValue = {areaName:"moduleArea", isChange:false, items:[], modulAdd:modulAddFlag}
              if(this.changeBeforeData["reportFormatType"] != target["reportFormatType"]){
                // 機種変更している場合は、処方項目が異なる為比較不可
                checkValue.isChange = true
                moistAreaValue.isChange = true
                moduleAreaValue.isChange = true
                changedItems.push(checkValue)
                changedItems.push(moistAreaValue)
                changedItems.push(moduleAreaValue)
                continue
              }
              for(var prescription of target.prescriptionItems){
                let beforePrescription = this.changeBeforeData.prescriptionItems.find(v => v.displayOrder==prescription.displayOrder)
                if(beforePrescription && beforePrescription.value != prescription.value){
                  switch(prescription.category){
                    case 0:
                      // 本体
                      checkValue.isChange = true
                      checkValue.items.push({itemName:prescription.displayName, before:beforePrescription.value, after:prescription.value, displayOrder:prescription.displayOrder})
                      break;
                    case 1:
                      // 加湿器
                      moistAreaValue.isChange = true
                      moistAreaValue.items.push({itemName:prescription.displayName, before:beforePrescription.value, after:prescription.value, displayOrder:prescription.displayOrder})
                      break;
                    case 2:
                      // 通信モジュール
                      moduleAreaValue.isChange = true
                      moduleAreaValue.items.push({itemName:prescription.displayName, before:beforePrescription.value, after:prescription.value, displayOrder:prescription.displayOrder})
                      break;
                  }
                }
              }
              changedItems.push(checkValue)
              changedItems.push(moistAreaValue)
              changedItems.push(moduleAreaValue)
              continue
            }
            for(var val of item.value){
              if(beforeTarget[val] != target[val]) {
                checkValue.items.push({itemName:val, before:beforeTarget[val], after:target[val]})
                checkValue.isChange = true
              }
            }
            changedItems.push(checkValue)
          }
        }
      }
      obj.changedItems = changedItems
      obj.instructionDate = obj.instructionDate ? obj.instructionDate.replace(/-/g, "/") :""
      obj.patient.age = obj.patient.age+""
      obj.patient.birthday = obj.patient.birthday ? obj.patient.birthday.replace(/-/g, "/") :""

      // 改行コード、タブを除去
      Object.keys(obj).forEach(key => {
        if (obj[key]) {
          obj[key] = this.replaceCharTab(obj[key]);
        }
      })
      Object.keys(obj.patient).forEach(key => {
        if (obj.patient[key]) {
          obj.patient[key] = this.replaceCharTab(obj.patient[key]);
        }
      })

      if(obj.kind == cpapKindMap.applicationResume && this.reqParams.transferDestinationId){
        obj.belongsId = this.reqParams.transferDestinationId
        obj.institutionId = this.reqParams.transferInstitutionId ? this.reqParams.transferInstitutionId : null
      } else {
        obj.belongsId = this.belongsId
        obj.institutionId = this.institutionId
      }
      // クイックオーダーのロジックを追加
      if(this.isApplicationValid){
        obj.preReceiptNumber = this.preReceiptNumber;
        obj.preKind = this.preKind
      }
      return client.apis.externalCpap.setCpapPrescriptionRequestPOST({
        body:obj
      });
    },
    setCpapPrescriptionRequestPOSTSuccess: function(result) {
      // 成功メッセージ表示
      this.reqParams.applicationDate = result.obj.requestDate
      this.reqParams.applicationTime = result.obj.requestTime
      this.reqParams.applicationUserName = result.obj.requestUserName
      this.reqParams.receiptNumber = result.obj.receiptNumber
      this.reqParams.status = this.cpapRequestStatus.request
      // 再レンダリングの為、フラグ切替
      this.renderKey = !this.renderKey
      this.compleateFlg = true;
    },
    setCpapPrescriptionRequestPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    back: function() {
      if(this.backRoutName && !this.isInstrument){
        this.$router.push({
          name: this.backRoutName,
          params: this.backRoutParams,
        });
      } else if (this.isInstrument) {
        // 預託検索からの場合
        // 品質#20 20240404
        if(!this.isHospital && !this.isDealer){
          this.$router.push({ path: "/philips/cpap/CpapHome" });
        }else{
          this.$router.push({ path: "/guest/cpap/CpapMenu" });
        }
      }else{
        // 転院紹介の場合
        if(this.preReceiptNumber) {
          this.$router.push({ path: "/guest/home" });
        }else{
          if (this.isInstrument){
            // 預託検索からの場合
            // 品質#20 20240404
            if(!this.isHospital && !this.isDealer){
              this.$router.push({ path: "/philips/cpap/CpapHome" });
            }else{
              this.$router.push({ path: "/guest/cpap/CpapMenu" });
            }
          } else {
            this.$router.go(-1);
          }
        }
      }
    },
    goHome: function() {
      if (this.userInfo.belongsId) {
        this.$router.push({ path: "/guest/cpap/CpapMenu" });
      } else {
        this.back();
      }
    },
    changeModel: async function() {
      // 処方値の取得
      this.prevPrescriptionItems = JSON.parse(JSON.stringify(this.reqParams.prescriptionItems)) // QA200 機種変更前の処方値を一時的に保持しておく
      // QA477 Goを経由するとモデム有/無が引き継がれない
      if (this.wkPrevReportFormatType != 3 && this.wkPrevReportFormatType != 5 && this.wkPrevReportFormatType != 6) {
        this.prevUseModule = this.reqParams.useModule
      }
      this.reqParams.prescriptionItems = []
      this.reqParams.useMoist = false
      this.reqParams.useModule = false
      this.reqParams.moduleItemCode = ""
      var model
      //QA75_仮持出中止から処方再開で本体変更処理後、表示が変わらない20240109
      if(this.temp){
        model = this.modelList.find(val => val.itemCodes && val.itemCodes.indexOf(this.reqParams.model) != -1)
      }
      if(!this.reqParams.reportFormatType && !this.reqParams.model){
        return
      }
      //QA75_仮持出中止から処方再開で本体変更処理後、表示が変わらない20240109
      if(!this.temp){
        if(this.reqParams.reportFormatType){
          model = this.modelList.find(val => val.reportFormatType == this.reqParams.reportFormatType)
        } else {
          model = this.modelList.find(val => val.itemCodes && val.itemCodes.indexOf(this.reqParams.model) != -1)
        }
      }
      // 20240215 類似品目選択時
      if(model){
        var modelItem = model.items.find(item => item.itemCode == this.reqParams.model)
        if(modelItem){
          this.reqParams.model = modelItem.itemCode
        }else{
          this.reqParams.model = model ? model.itemCode : ""
        }
      }else{
        this.reqParams.model = ""
      }
      if (this.changeBeforeData) {
        if(this.changeBeforeData.reportFormatType == model.reportFormatType) {
          this.reqParams.moistSerial = this.changeBeforeData.moistSerial;
          this.reqParams.moistItemCode = this.changeBeforeData.changeBeforeMoistItemCode;
          this.reqParams.moduleSerial = this.changeBeforeData.moduleSerial;
          this.reqParams.moduleItemCode = this.changeBeforeData.moduleItemCode;
          this.reqParams.machineChangeFlag = false;
          if(!this.temp){
            this.reqParams.serial = this.changeBeforeData.serial;
          }else if(this.temp){
            this.reqParams.moduleSerial='';
          }
        }
        else if(
          ((this.changeBeforeData.reportFormatType == 3 && model.reportFormatType != 3) || (this.changeBeforeData.reportFormatType != 3 && model.reportFormatType == 3)) ||
          ((this.changeBeforeData.reportFormatType == 5 && model.reportFormatType != 5) || (this.changeBeforeData.reportFormatType != 5 && model.reportFormatType == 5)) ||
          ((this.changeBeforeData.reportFormatType == 6 && model.reportFormatType != 6) || (this.changeBeforeData.reportFormatType != 6 && model.reportFormatType== 6))
          ){
          if(!this.temp){
            this.reqParams.serial = '';
          }
          this.reqParams.moistSerial = '';
          this.reqParams.moistItemCode = '';
          this.reqParams.moduleSerial = '';
          this.reqParams.moduleItemCode = '';
          this.reqParams.machineChangeFlag = true;
        }
        else {
          if(!this.temp){
            this.reqParams.serial = '';
          }
          this.reqParams.moistSerial = this.changeBeforeData.moistSerial;
          this.reqParams.moistItemCode = this.changeBeforeData.changeBeforeMoistItemCode;
          this.reqParams.moduleSerial = '';
          this.reqParams.moduleItemCode = '';
          this.reqParams.machineChangeFlag = true;
        }
      }
      this.reqParams.reportFormatType = model ? model.reportFormatType : ""
      this.wkPrevReportFormatType = this.reqParams.reportFormatType
      var excuteApi = this.getPrescriptionValueItemsPOST;
      var successCallBack = this.getPrescriptionValueItemsPOSTSuccess;
      var errorCallBack = this.getPrescriptionValueItemsPOSTError;
      // WebAPI Call
      return this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getPrescriptionValueItemsPOST: function(client) {
      return client.apis.externalCpap.getPrescriptionValueItemsPOST({
        body:{
          formatType:this.reqParams.reportFormatType
        }
      });
    },
    getPrescriptionValueItemsPOSTSuccess: function(result) {
      this.reqParams.prescriptionItems = result.obj
      this.reqParams.useMoist = true
      this.reqParams.useModule = true

      var model = this.modelList.find(val => val.reportFormatType == this.reqParams.reportFormatType)
      var moistMachine = this.prevPrescriptionItems.find(val => val.displayName === "加温加湿器")
      var moduleMachine = this.prevPrescriptionItems.find(val => val.displayName === "通信モジュール")
      var wkParam = ""
      for(var i=0; i<this.reqParams.prescriptionItems.length; i++){
        var item = this.reqParams.prescriptionItems[i]

        if(item.type=== 'calender'){
          item.value = this.yyyy_hyp_MM_hyp_dd(new Date())
        }
        if(item.displayName == "モード" && item.defaultValue){
          this.reqParams.mode = item.defaultValue
          continue
        }
        // QA479 変更前の機種から処方値を引き継ぐ
        if(item.type=="radio" && item.category==1) {
          if (moistMachine && moistMachine.value == "0") {
            item.value = "0"
            this.reqParams.useMoist = false
          }
        }
        if(item.type=="radio" && item.category==2) {
          if (moduleMachine && moduleMachine.value == "0") {
            item.value = "0"
            this.reqParams.useModule = false
          }
        }

        // 通信モジュール
        if(item.category==2){
          if((item.type=="radio" || item.type=="sel") && item.value=="0"){
            this.reqParams.useModule = false
            continue
          }else if((item.type=="radio" || item.type=="sel")  && item.value=="1"){
            // 通信モジュールの関連項目の場合(Prisma)
            if(model.reportFormatType==6){
              item.value = "0"
              this.reqParams.useModule = false
              continue

            // 通信モジュールの関連項目の場合(DSgo)
            }else if(model.reportFormatType==3 ){
              if(item.displayName == "モバイルアプリ" && moduleMachine && moduleMachine.value == "1"){
                wkParam = this.prevPrescriptionItems.find(val => val.displayName === "モバイルアプリ")
                item.value = wkParam ? wkParam.value : item.value
                continue
              }
              if(item.displayName == "患者情報管理" && moduleMachine && moduleMachine.value == "1"){
                wkParam = this.prevPrescriptionItems.find(val => val.displayName === "患者情報管理")
                item.value = wkParam ? wkParam.value : item.value
                continue
              }

            // 通信モジュールの関連項目の場合(S-BOX)
            }else if(model.reportFormatType==5){
              if(item.type=="radio" && moduleMachine && moduleMachine.value == "0"){
              // 処方変更前が無しだった場合、引き継ぐ
                item.value = "0"
                this.reqParams.useModule = false
                continue
              }
              if(item.displayName == "患者情報管理" && moduleMachine && moduleMachine.value == "1"){
                wkParam = this.prevPrescriptionItems.find(val => val.displayName === "患者情報管理")
                item.value = wkParam ? wkParam.value : item.value
                continue
              }
              if(item.displayName == "登録方法" && moduleMachine && moduleMachine.value == "1"){
                wkParam = this.prevPrescriptionItems.find(val => val.displayName === "登録方法")
                item.value = wkParam ? wkParam.value : item.value
                continue
              }
            // 通信モジュールの関連項目の場合(DSgo以外)
            }else if(model.reportFormatType!=3 && model.reportFormatType!=5 && model.reportFormatType!=6){
              if(item.type=="radio" && !this.prevUseModule){
              // 処方変更前が無しだった場合、引き継ぐ
                item.value = "0"
                this.reqParams.useModule = false
                continue
              }
              if(item.displayName == "患者情報管理" && moduleMachine && moduleMachine.value == "1"){
                wkParam = this.prevPrescriptionItems.find(val => val.displayName === "患者情報管理")
                item.value = wkParam ? wkParam.value : item.value
                continue
              }
              if(item.displayName == "登録方法" && moduleMachine && moduleMachine.value == "1"){
                wkParam = this.prevPrescriptionItems.find(val => val.displayName === "登録方法")
                item.value = wkParam ? wkParam.value : item.value
                continue
              }
            }
          }
        }
        // 加湿器の関連項目の場合
        if(item.category==1){
          if(item.type=="radio" && !moistMachine){
            // 処方変更前が無しだった場合、引き継ぐ
            item.value = "0"
            this.reqParams.useMoist = false
            continue
          } else if(item.type=="radio" && moistMachine && moistMachine.value == "1"){
            // 処方変更前がありだった場合、引き継ぐ
            item.value = "1"
            this.reqParams.useMoist = true
            continue
          }
          if(item.displayName == "加湿モード" && moistMachine && moistMachine.value == "1"){
            wkParam = this.prevPrescriptionItems.find(val => val.displayName === "加湿モード")
            item.value = wkParam ? wkParam.value : item.value
            continue
          }
          if(item.displayName == "加湿器設定" && moistMachine && moistMachine.value == "1"){
            wkParam = this.prevPrescriptionItems.find(val => val.displayName === "加湿器設定")
            item.value = wkParam ? wkParam.value : item.value
            continue
          }
          // 回路温度設定
          var moistMode = this.prevPrescriptionItems.find(val => val.displayName == "加湿モード")
          if (!moistMode) moistMode = this.reqParams.prescriptionItems.find(val => val.displayName == "加湿モード")
          var circuit = this.reqParams.prescriptionItems.find(val => val.displayName == "回路温度設定")
          if(circuit){
            if(moistMode && (moistMode.value=="0" || moistMode.value=="1")){
              circuit.value = ""
              circuit.disabled = true
            }else{
              wkParam = this.prevPrescriptionItems.find(val => val.displayName == "回路温度設定")
              circuit.value = wkParam ? wkParam.value : circuit.defaultValue  // QA200 回路温度設定を引き継ぐ
              circuit.disabled = false
            }
          }
        }
        this.changeSelect(item.displayName,item.value,item.itemName)
      }
      if(this.changeBeforeData){
        if(this.changeBeforeData.useMoist &&
          ((this.changeBeforeData.reportFormatType == 3 && this.reqParams.reportFormatType != 3) || (this.changeBeforeData.reportFormatType != 3 && this.reqParams.reportFormatType == 3)) ||
          ((this.changeBeforeData.reportFormatType == 5 && this.reqParams.reportFormatType != 5) || (this.changeBeforeData.reportFormatType != 5 && this.reqParams.reportFormatType == 5)) ||
          ((this.changeBeforeData.reportFormatType == 6 && this.reqParams.reportFormatType != 6) || (this.changeBeforeData.reportFormatType != 6 && this.reqParams.reportFormatType== 6))
        ){
          var kmode = this.reqParams.prescriptionItems.find(val => val.displayName === "加湿モード")
          if (kmode) {  // QA200 エスボックス、プリズマに加湿モードが存在しないためチェック
            kmode.value = "1"
          }
          var kset = this.reqParams.prescriptionItems.find(val => val.displayName === "加湿器設定")
          kset.value = "3"
        }
        if(this.changeBeforeData.reportFormatType == this.reqParams.reportFormatType) {
          if(!this.changeBeforeData.useMoist){
            var defKmode = this.reqParams.changeBeforePrescriptionContent.find(val => val.displayName === "加湿モード")
            if (defKmode) { // QA200 エスボックス、プリズマに加湿モードが存在しないためチェック
              defKmode.value = "1"
            }
            var defKset = this.reqParams.changeBeforePrescriptionContent.find(val => val.displayName === "加湿器設定")
            if (defKset) {
              defKset.value = "3"
            }
          }
          if(!this.changeBeforeData.useModule){
            var defKjk =this.reqParams.changeBeforePrescriptionContent.find(val => val.displayName === "患者情報管理")
            if (defKjk) {
              defKjk.value = "1"
            }
            var defReg = this.reqParams.changeBeforePrescriptionContent.find(val => val.displayName === "登録方法")
            if (defReg) {
              defReg.value = "1"
            }
          }
          this.reqParams.prescriptionItems = JSON.parse(JSON.stringify(this.reqParams.changeBeforePrescriptionContent))
          var cMode = this.reqParams.prescriptionItems.find(val => val.displayName === "モード")
          this.reqParams.mode = cMode.value
          if(this.changeBeforeData.useMoist){
            this.reqParams.useMoist = true
          }else{
            this.reqParams.useMoist = false
          }
          if(this.changeBeforeData.useModule){
            this.reqParams.useModule = true
          }else{
            this.reqParams.useModule = false
          }
        }
      }

      // QA335_ドリームステーションのランプ設定の誤りを修正
      // 初期表示にてランプスタート圧を活性化
      var lampStart = this.reqParams.prescriptionItems.find(val => val.displayName == "ランプスタート圧【hPa(cmH2O)】")
      if (lampStart) {
        lampStart.disabled = false
      }

      // QA324 DS Auto、DS Go、DS BiPAPの場合
      if (this.reqParams.reportFormatType == 1 || this.reqParams.reportFormatType == 3 || this.reqParams.reportFormatType == 4) {
        // QA200 前処方の機種に戻したとき、ディスコン項目が使用中でなければ選択不可にする。
        // 中止再開なら使用中であっても選択不可。
        if(!this.cancelResume && this.changeBeforeData && this.changeBeforeData.reportFormatType == this.reqParams.reportFormatType) {
          // 呼吸回路タイプ12mmを選択不可とする
          var kokty = this.reqParams.prescriptionItems.find(val => val.itemName === "KOKTY")
          if (kokty.value !== "12") {
            kokty.displayValue = kokty.displayValue.filter(v => v.key !== "12" && v.key !== "")
            if (this.reqParams.reportFormatType == 3 && !kokty.value) {
              kokty.value = "15"
            }
          } else {
            kokty.displayValue = kokty.displayValue.filter(v => v.key !== "")
          }
          // 患者情報管理 「アンコールエニウェア」と空白を選択不可とする
          var kjk = this.reqParams.prescriptionItems.find(val => val.displayName === "患者情報管理")
          if (kjk.value !== "2") {
            kjk.displayValue = kjk.displayValue.filter(v => v.key !== "2" && v.key !== "")
            if (this.reqParams.reportFormatType == 3 && !kjk.value) {
              kjk.value = "1"
            }
          } else {
            kjk.displayValue = kjk.displayValue.filter(v => v.key !== "")
          }
          const order = ["1", "0", "2"]
          kjk.displayValue.sort((a, b) => order.indexOf(a.key) - order.indexOf(b.key))
          // 登録方法 「登録しない」と空白を選択不可とする
          var trh = this.reqParams.prescriptionItems.find(val => val.displayName === "登録方法")
          if (trh.value !== "0") {
            trh.displayValue = trh.displayValue.filter(v => v.key !== "0" && v.key !== "")
          } else {
            trh.displayValue = trh.displayValue.filter(v => v.key !== "")
          }
        } else {
          if (this.reqParams.reportFormatType == 1 || this.reqParams.reportFormatType == 3 || this.reqParams.reportFormatType == 4) {
            // 呼吸回路タイプ12mmを選択不可とする
            var kokty = this.reqParams.prescriptionItems.find(val => val.itemName === "KOKTY")
            kokty.displayValue = kokty.displayValue.filter(v => v.key !== "12" && v.key !== "")
            if (kokty.value == "12" || kokty.value == "") {
              kokty.value = "15"
            }
            // 患者情報管理 「アンコールエニウェア」と空白を選択不可とする
            var kjk = this.reqParams.prescriptionItems.find(val => val.displayName === "患者情報管理")
            kjk.displayValue = kjk.displayValue.filter(v => v.key !== "2" && v.key !== "")
            kjk.displayValue.sort((a, b) => Number(b.key) - Number(a.key))
            if (kjk.value == "2" || kjk.value == "") {
              kjk.value = "1"
            }
            // 登録方法 「登録しない」と空白を選択不可とする
            var trh = this.reqParams.prescriptionItems.find(val => val.displayName === "登録方法")
            trh.displayValue = trh.displayValue.filter(v => v.key !== "0" && v.key !== "")
            if (trh.value == "0" || trh.value == "") {
              trh.value = "1"
            }
          }
        }
      }
      // QA474_処方値関連残
      if (this.reqParams.reportFormatType == 4) {
        var mode = this.reqParams.prescriptionItems.find(val => val.displayOrder == 1)
        var flexLock = this.reqParams.prescriptionItems.find(val => val.displayOrder == 14)
        var flex = this.reqParams.prescriptionItems.find(val => val.displayOrder == 13)
        var riseTime = this.reqParams.prescriptionItems.find(val => val.displayOrder == 15)
        if (mode.value == 1) {
          // Bipap（Auto Bi-Levelモード）IPAP＝EPAPかつPS最大圧0、PS最小圧0のとき、PS最大圧、PS最小圧は非活性とする。
          var ipap = this.reqParams.prescriptionItems.find(val => val.displayOrder == 5)
          var epap = this.reqParams.prescriptionItems.find(val => val.displayOrder == 6)
          var pressureMax = this.reqParams.prescriptionItems.find(val => val.displayOrder == 7)
          var pressureMin = this.reqParams.prescriptionItems.find(val => val.displayOrder == 8)
          if ((Number(ipap.value) == Number(epap.value)) && (Number(pressureMax.value) == 0) && (Number(pressureMin.value) == 0)) {
            pressureMax.disabled = true
            pressureMin.disabled = true
          }
          var flexType1 = this.reqParams.prescriptionItems.find(val => val.displayOrder == 12)
          var flexType8 = this.reqParams.prescriptionItems.find(val => val.displayOrder == 11)
          // Bipap（Auto Bi-Levelモード）Flexタイプの選択肢はBi-Flex、0（オフ）のみとする。
          if (flexType1.value !== "2") {
            flexType1.displayValue = flexType1.displayValue.filter(v => v.key !== "2")
            flexType8.displayValue = flexType8.displayValue.filter(v => v.key !== "2" && v.key !== "3")
          }
          // Bipap（Auto Bi-Levelモード）Flexタイプがオフの場合、Flex設定とFlex設定ロックは非活性とする。
          if (flexType1.value == "0" && !flex.value) {
            flex.disabled = true
          }
          if (flexType1.value == "0" && !flexLock.value) {
            flexLock.disabled = true
          }
          // Bipap（Auto Bi-Levelモード）Flexタイプがオフのときはライズタイムの選択肢を「1～3」とする
          // if (flexType1.value == "0" && riseTime.value !== "0") {
          //   riseTime.displayValue = riseTime.displayValue.filter(v => v.key !== "0")
          // }
          // QA474 仕様変更 20260410
          riseTime.displayValue = [{"key":"","value":""},{"key":"0","value":"0"},{"key":"1","value":"1"},{"key":"2","value":"2"},{"key":"3","value":"3"}]
        } else if (mode.value == 8) {
          var flexType1 = this.reqParams.prescriptionItems.find(val => val.displayOrder == 12)
          var flexType8 = this.reqParams.prescriptionItems.find(val => val.displayOrder == 11)
          // Bipap（Bi-Levelモード）Flexタイプの選択肢はBi-Flex、0（オフ）のみとする。
          if (flexType8.value !== "2" && flexType8.value !== "3") {
            flexType8.displayValue = flexType8.displayValue.filter(v => v.key !== "2" && v.key !== "3")
          }
          if (flexType8.value !== "2") {
            flexType1.displayValue = flexType1.displayValue.filter(v => v.key !== "2")
          }
          // Bipap（Bi-Levelモード）Flexタイプがオフの場合、Flex設定とFlex設定ロックは非活性とする。
          if (flexType8.value == "0" && !flex.value) {
            flex.disabled = true
          }
          if (flexType8.value == "0" && !flexLock.value) {
            flexLock.disabled = true
          }
          // Bipap（Bi-Levelモード）Flexタイプがオフのときはライズタイムの選択肢を「1～3」とする
          // if (flexType8.value == "0" && riseTime.value !== "0") {
          //   riseTime.displayValue = riseTime.displayValue.filter(v => v.key !== "0")
          // }
          // QA474 仕様変更 20260410
          riseTime.displayValue = [{"key":"","value":""},{"key":"0","value":"0"},{"key":"1","value":"1"},{"key":"2","value":"2"},{"key":"3","value":"3"}]
        } else if (mode.value == 4) { // CPAPモード
          var flexType1 = this.reqParams.prescriptionItems.find(val => val.displayOrder == 12)
          flexType1.displayValue = flexType1.displayValue.filter(v => v.key !== "2")
          var flexType8 = this.reqParams.prescriptionItems.find(val => val.displayOrder == 11)
          flexType8.displayValue = flexType8.displayValue.filter(v => v.key !== "2" && v.key !== "3")
        }
      }
      if (this.reqParams.reportFormatType == 1 || this.reqParams.reportFormatType == 3 || this.reqParams.reportFormatType == 4) {
        var flex = this.reqParams.prescriptionItems.find(val => val.displayName == "Flex設定")
        var language = this.reqParams.prescriptionItems.find(val => val.displayName == "言語設定")
        // フレックス設定からOFFを除去
        if (flex.value !== "0") {
          flex.displayValue = flex.displayValue.filter(v => v.key !== "0")
        }
        // 言語設定の選択肢から「その他」の選択肢を除去
        if (language.value !== "5") {
          language.displayValue = language.displayValue.filter(v => v.key !== "5")
        }
      }
    },
    getPrescriptionValueItemsPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    inputRadioValue: function(result,name){
      switch(name){
        case "useMoist":
          this.reqParams.useMoist = result=="1"
          // QA408_処方変更・再開時、加湿器無⇒有の変更でデフォルト値を表示
          // QA478　新規処方時もデフォルト値を設定する
          if (this.reqParams.kind == this.cpapKindMap.application || this.reqParams.kind == this.cpapKindMap.applicationTempRemoval || this.reqParams.kind == cpapKindMap.applicationResume) {
            if (this.changeBeforeData) {
              // 加湿器追加時（無⇒有）
              if (this.reqParams.useMoist && !this.changeBeforeData.useMoist) {
                var moistInfo = this.reqParams.prescriptionItems.filter(val=> val.category==1)
                for (var item of moistInfo) {
                  item.value = item.defaultValue ? item.defaultValue : ""
                  // 加湿器項目の入力制御反映
                  if (item.displayName == "回路温度設定") {
                    var moistMode = this.reqParams.prescriptionItems.find(val => val.displayName == "加湿モード")
                    if (moistMode) {
                      if (moistMode.value=="0" || moistMode.value=="1") {
                        item.value = ""
                        item.disabled = true
                      } else {
                        item.disabled = false
                      }
                    }
                  }
                }
              }
            }
          }
        break;
        case "useModule":
          this.reqParams.useModule = result=="1"
          this.reqParams.moduleItemCode = ""
          // QA408_処方変更・再開時、加湿器無⇒有の変更でデフォルト値を表示
          // QA478　新規処方時もデフォルト値を設定する
          if (this.reqParams.kind == this.cpapKindMap.application || this.reqParams.kind == this.cpapKindMap.applicationTempRemoval || this.reqParams.kind == cpapKindMap.applicationResume) {
            if (this.changeBeforeData) {
              // モデム追加時（無⇒有）
              if (this.reqParams.useModule && !this.changeBeforeData.useModule) {
                var moduleInfo = this.reqParams.prescriptionItems.filter(val=> val.category==2)
                for (var item of moduleInfo) {
                  item.value = item.defaultValue ? item.defaultValue : ""
                }
              }
            }
          }
        break;
      }
    },
    setOrganization: function(organizationInfo){
      this.reqParams.belongsId = organizationInfo.id + "";
      this.reqParams.medicalInstitutionName = organizationInfo.orgName;
      this.reqParams.receiverName = organizationInfo.orgName;
      this.reqParams.resultReceiverName = organizationInfo.orgName;
      this.reqParams.zip = organizationInfo.zip;
      this.reqParams.address = organizationInfo.prefecture + organizationInfo.city;
      this.reqParams.address1 = organizationInfo.address;
      this.reqParams.address2 = organizationInfo.building ? organizationInfo.building : "";
      this.reqParams.phoneNumber = organizationInfo.phoneNumber;
      this.reqParams.note = organizationInfo.note;

      if (!this.belongsId || this.belongsId != organizationInfo.id) {
        // 代理申込時
        this.belongsId = organizationInfo.id
        this.getCpapDefaultsettings();
      }
      // 前回申込み情報の取得
      // this.prevHstSearchParam.belongsId = this.belongsId
    },
    setfacility:  function(facility){
      this.reqParams.institutionId = facility.id + "";
      this.reqParams.medicalInstitutionName = facility.orgName;

      this.reqParams.receiverName = facility.orgName;
      this.reqParams.resultReceiverName = facility.orgName;

      this.reqParams.zip = facility.postcode;
      this.reqParams.address = facility.prefecture + facility.address;
      this.reqParams.address1 = facility.houseNumber;
      this.reqParams.address2 = facility.building ? facility.building : "";
      this.reqParams.phoneNumber = facility.phoneNumber;

      // 前回申込み情報の取得
      // this.prevHstSearchParam.institutionId = facility.id
      this.institutionId = facility.id
      this.getCpapDefaultsettings();
    },
    print: function(){
      window.print();
    },
    inputBirthday: function(birthday){
      var age = this.getAge(birthday)
      if(!isNaN(Number(age))){
        this.reqParams.patient.age = age < 0 ? 0 : age
        const date = new Date(birthday);
        const options = {era: 'long'};
        this.reqParams.patient.japaneseCalendar = "【"+this.getJapaneseCalendar(date)+"】"
      }else{
        this.reqParams.patient.age = ""
      }
    },
    patientAddressSearch: function(val){
      // 検索対象の郵便番号を設定
      this.searchTargetPostCode = val
      this.searchTargetAddress = null
      this.postCodeSearch().then(result=>{
        if (!this.searchTargetAddress) return;
        this.reqParams.patient.address = this.searchTargetAddress.prefecture + " " + this.searchTargetAddress.city + " " + this.searchTargetAddress.town
        this.reqParams.patient.address1 = "";
        this.reqParams.patient.address2 = "";

        // 再レンダリングの為、フラグ切替
        this.renderKey = !this.renderKey
        // QA476 住所設定後フォーカスを移動する
        this.focusMove("patientAddress1");
        this.digitErrorPostcode = false;
      })
    },
    addressSearch: function(val){
      // 検索対象の郵便番号を設定
      this.searchTargetPostCode = val
      this.searchTargetAddress = null
      this.postCodeSearch().then(result=>{
        if (!this.searchTargetAddress) return;
        this.reqParams.deliveryAddress = this.searchTargetAddress.prefecture + " " + this.searchTargetAddress.city + " " + this.searchTargetAddress.town
        this.reqParams.deliveryHouseNumber = "";
        this.reqParams.deliveryBuilding = "";

        // QA476 住所設定後フォーカスを移動する
        this.focusMove("deliveryHouseNumber");
        this.digitErrorDeliveryPostcode = false;
      })
    },
    postCodeSearch: function(){
      var excuteApi = this.getAddressFromPostCodePOST;
      var successCallBack = this.getAddressFromPostCodePOSTSuccess;
      var errorCallBack = this.getAddressFromPostCodePOSTError;
      // WebAPI Call
      return this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getAddressFromPostCodePOST: function(client) {
      return client.apis.apiCommon.getAddressFromPostCodePOST({
        body:{
          postCode:this.searchTargetPostCode
        }
      });
    },
    getAddressFromPostCodePOSTSuccess: function(result) {
      this.searchTargetAddress = result.obj
      this.searchTargetPostCode = ""
    },
    getAddressFromPostCodePOSTError: function(result) {
      this.searchTargetPostCode = ""
    },   
    getChoicesList: async function() {
      this.modelList = this.getCpapMaster();
      this.initEstimateDetailCode = this.reqParams.changeBeforeEstimateDetailCode
      // QA324 ディスコン対応
      // QA389 仮持出新規はディスコン品も使用可能とする
      if (this.reqParams.kind != cpapKindMap.applicationTempRemoval) {
        // 仮持出新規以外
        if (this.resume) {
          this.modelList = this.modelList.filter(val=>{ return val.reportFormatType===1 || val.reportFormatType===3 || val.reportFormatType===4 || val.reportFormatType===this.reqParams.reportFormatType})
        } else if (this.cancelResume) {
          // 中止前がディスコン品目の場合、機種はクリアする
          if (this.reqParams.reportFormatType !== 1 && this.reqParams.reportFormatType !== 3 && this.reqParams.reportFormatType !== 4) {
            this.reqParams.model = ""
          }
          this.modelList = this.modelList.filter(val=>{ return val.reportFormatType===1 || val.reportFormatType===3 || val.reportFormatType===4})
          for (let model of this.modelList) {
            this.initEstimateDetailCode = this.initEstimateDetailCode.filter(val => val.itemCode == model.itemCode)
          }
        } else {
          this.modelList = this.modelList.filter(val=>{ return val.reportFormatType===1 || val.reportFormatType===3 || val.reportFormatType===4})
        }
      }
      this.modelList.unshift({})
    },
    changeSelect: function(name, value) {
      var model = this.modelList.find(val => val.itemCodes && val.itemCodes.indexOf(this.reqParams.model) != -1)
      if(name == "モード"){
        var changeBeforeMode = this.reqParams.mode
        this.reqParams.mode = value
        // "Flexタイプ"
        var changeBeforeFlexType
        var flexType
        // ドリームステーションAuto
        if (model.reportFormatType == 1) {
          // モード変更前のFlexタイプ
          if (changeBeforeMode == 4) { // CPAPモード
            changeBeforeFlexType = this.reqParams.prescriptionItems.find(val => val.displayOrder == 7)
          } else if (changeBeforeMode == 1) { // Auto CPAPモード
            changeBeforeFlexType = this.reqParams.prescriptionItems.find(val => val.displayOrder == 8)
          }
          // モード変更後のFlexタイプ
          if (this.reqParams.mode == 4) { // CPAPモード
            flexType = this.reqParams.prescriptionItems.find(val => val.displayOrder == 7)
          } else if (this.reqParams.mode == 1) { // Auto CPAPモード
            flexType = this.reqParams.prescriptionItems.find(val => val.displayOrder == 8)
          }
        // ドリームステーションGo
        } else if (model.reportFormatType == 3) {
          //  モード変更前のFlexタイプ
          if (changeBeforeMode == 4) { // CPAPモード
            changeBeforeFlexType = this.reqParams.prescriptionItems.find(val => val.displayOrder == 7)
          } else if (changeBeforeMode == 1) { // Auto CPAPモード
            changeBeforeFlexType = this.reqParams.prescriptionItems.find(val => val.displayOrder == 8)
          }
          // モード変更後のFlexタイプ
          if (this.reqParams.mode == 4) { // CPAPモード
            flexType = this.reqParams.prescriptionItems.find(val => val.displayOrder == 7)
          } else if (this.reqParams.mode == 1) { // Auto CPAPモード
            flexType = this.reqParams.prescriptionItems.find(val => val.displayOrder == 8)
          }
        // ドリームステーションBiPAP Auto
        } else if (model.reportFormatType == 4) {
          // モード変更前のFlexタイプ
          if (changeBeforeMode == 4) { // CPAPモード
            changeBeforeFlexType = this.reqParams.prescriptionItems.find(val => val.displayOrder == 10)
          } else if (changeBeforeMode == 8) { // Bi-Levelモード
            changeBeforeFlexType = this.reqParams.prescriptionItems.find(val => val.displayOrder == 11)
          } else if (changeBeforeMode == 1) { // Auto Bi-Levelモード
            changeBeforeFlexType = this.reqParams.prescriptionItems.find(val => val.displayOrder == 12)
          }
          // モード変更後のFlexタイプ
          if (this.reqParams.mode == 4) { // CPAPモード
            flexType = this.reqParams.prescriptionItems.find(val => val.displayOrder == 10)
          } else if (this.reqParams.mode == 8) { // Bi-Levelモード
            flexType = this.reqParams.prescriptionItems.find(val => val.displayOrder == 11)
          } else if (this.reqParams.mode == 1) { // Auto Bi-Levelモード
            flexType = this.reqParams.prescriptionItems.find(val => val.displayOrder == 12)
          }
        }
        // モード変更前のFlexタイプが変更後のモードのFlexタイプの選択肢にあったら引き継ぐ
        var changeBeforeDisplayValue = changeBeforeFlexType.displayValue.filter(val => val.key == changeBeforeFlexType.value)
        if (changeBeforeDisplayValue && changeBeforeDisplayValue.length > 0) {
          var targetDisplayValue = flexType.displayValue.filter(val => val.value === changeBeforeDisplayValue[0].value)
          if (targetDisplayValue && targetDisplayValue.length > 0) {
            flexType.value = targetDisplayValue[0].key
          }
        }
        // QA474追加_Bipapの活性非活性制御
        if (model.reportFormatType == 4) {
          // "Flex設定ロック"
          var flexLock = this.reqParams.prescriptionItems.find(val => val.displayOrder == 14)
          // CPAPモードのときはFlex設定ロックを活性にする
          if (this.reqParams.mode == 4) {
            flexLock.disabled = false
          // Bi-Levelモード・Auto Bi-LevelモードのときFlex設定ロックを非活性にする
          } else if (this.reqParams.mode == 8 || this.reqParams.mode == 1) {
            if (flexType.value == "0") {
              flexLock.disabled = true
              flexLock.value = ""
            }
            // "ライズタイム"
            var riseTime = this.reqParams.prescriptionItems.find(val => val.displayOrder == 15)
            // "ライズタイムロック"
            var riseTimeLock = this.reqParams.prescriptionItems.find(val => val.displayOrder == 16)
            if (flexType.value == "0") {
              riseTime.disabled = false
              riseTimeLock.disabled = false
              // riseTime.displayValue = riseTime.displayValue.filter(v => v.key !== "0")
            } else {
              riseTime.disabled = true
              riseTimeLock.disabled = true
              riseTime.value = ""
              riseTimeLock.value = ""
              // riseTime.displayValue = [{"key":"","value":""},{"key":"0","value":"0"},{"key":"1","value":"1"},{"key":"2","value":"2"},{"key":"3","value":"3"}]
            }
            // QA474 仕様変更 20260410
            riseTime.displayValue = [{"key":"","value":""},{"key":"0","value":"0"},{"key":"1","value":"1"},{"key":"2","value":"2"},{"key":"3","value":"3"}]
          }
        }
        return
      }
      switch(model.reportFormatType){
        case 1:
          // ドリームステーションAuto
          if(name == "Flexタイプ"){
            // "Flex設定"
            var flex = this.reqParams.prescriptionItems.find(val => val.displayName == "Flex設定" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
            if(value=="0"){
              flex.value = ""
              flex.disabled = true
            }else{
              flex.value = flex.defaultValue
              flex.disabled = false
            }
            return
          }
          if(name == "加湿モード"){
            // 回路温度設定
            var circuit = this.reqParams.prescriptionItems.find(val => val.displayName == "回路温度設定" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
            if(value=="0" || value=="1"){
              circuit.value = ""
              circuit.disabled = true
            }else{
              circuit.value = circuit.defaultValue
              circuit.disabled = false
            }
            return
          }
          if(name == "患者情報管理"){
            // 登録方法
            var registMethod = this.reqParams.prescriptionItems.find(val => val.displayName == "登録方法" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
            if(value=="0"){
              registMethod.value = ""
              registMethod.disabled = true
            }else{
              registMethod.value = registMethod.defaultValue
              registMethod.disabled = false
            }
            return
          }
          // QA335_ドリームステーションのランプ設定の誤りを修正
          // ランプ時間とランプスタート圧の相関関係を削除
          // if(name == "ランプ時間【分】"){
          //   // ランプスタート圧【hPa(cmH2O)】
          //   var lampStart = this.reqParams.prescriptionItems.find(val => val.displayName == "ランプスタート圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
          //   if(value=="0"){
          //     lampStart.value = "4"
          //     lampStart.disabled = true
          //   }else{
          //     lampStart.disabled = false
          //   }
          //   return
          // }
          break;
        case 2:
          // ドリームステーションPro
          if(name == "Flexタイプ"){
            // "Flex設定"
            var flex = this.reqParams.prescriptionItems.find(val => val.displayName == "Flex設定" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
            if(value=="0"){
              flex.value = ""
              flex.disabled = true
            }else{
              flex.value = flex.defaultValue
              flex.disabled = false
            }
            return
          }
          if(name == "加湿モード"){
            // 回路温度設定
            var circuit = this.reqParams.prescriptionItems.find(val => val.displayName == "回路温度設定" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
            if(value=="0" || value=="1"){
              circuit.value = ""
              circuit.disabled = true
            }else{
              circuit.value = circuit.defaultValue
              circuit.disabled = false
            }
            return
          }
          if(name == "患者情報管理"){
            // 登録方法
            var registMethod = this.reqParams.prescriptionItems.find(val => val.displayName == "登録方法" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
            if(value=="0"){
              registMethod.value = ""
              registMethod.disabled = true
            }else{
              registMethod.value = registMethod.defaultValue
              registMethod.disabled = false
            }
            return
          }
          // QA335_ドリームステーションのランプ設定の誤りを修正
          // ランプ時間とランプスタート圧の相関関係を削除
          // if(name == "ランプ時間【分】"){
          //   // ランプスタート圧【hPa(cmH2O)】
          //   var lampStart = this.reqParams.prescriptionItems.find(val => val.displayName == "ランプスタート圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
          //   if(value=="0"){
          //     lampStart.value = "4"
          //     lampStart.disabled = true
          //   }else{
          //     lampStart.disabled = false
          //   }
          //   return
          // }
          break;
        case 3:
          // ドリームステーションGo
          if(name == "Flexタイプ"){
            // "Flex設定"
            var flex = this.reqParams.prescriptionItems.find(val => val.displayName == "Flex設定" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
            if(value=="0"){
              flex.value = ""
              flex.disabled = true
            }else{
              flex.value = flex.defaultValue
              flex.disabled = false
            }
            return
          }
          if(name == "患者情報管理"){
            // 登録方法
            var registMethod = this.reqParams.prescriptionItems.find(val => val.displayName == "登録方法" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
            if(value=="0"){
              registMethod.value = ""
              registMethod.disabled = true
            }else{
              registMethod.value = registMethod.defaultValue
              registMethod.disabled = false
            }
            return
          }
          // QA335_ドリームステーションのランプ設定の誤りを修正
          // ランプ時間とランプスタート圧の相関関係を削除
          // if(name == "ランプ時間【分】"){
          //   // ランプスタート圧【hPa(cmH2O)】
          //   var lampStart = this.reqParams.prescriptionItems.find(val => val.displayName == "ランプスタート圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
          //   if(value=="0"){
          //     lampStart.value = "4"
          //     lampStart.disabled = true
          //   }else{
          //     lampStart.disabled = false
          //   }
          //   return
          // }
          break;
        case 4:
          // ドリームステーションBiPAP Auto
          // QA474_処方値関連残
          // Bipap（Auto Bi-Levelモード）IPAP＝EPAPのときPS最大圧、PS最小圧は0－0で非活性とする。
          var ipap = this.reqParams.prescriptionItems.find(val => val.displayOrder == 5)
          var epap = this.reqParams.prescriptionItems.find(val => val.displayOrder == 6)
          var pressureMax = this.reqParams.prescriptionItems.find(val => val.displayOrder == 7)
          var pressureMin = this.reqParams.prescriptionItems.find(val => val.displayOrder == 8)
          if (this.reqParams.mode == 1) {
            if (name == "IPAP最大圧【hPa(cmH2O)】" || name == "EPAP最小圧【hPa(cmH2O)】") {
              if (ipap.value && epap.value && Number(ipap.value) == Number(epap.value)) {
                pressureMax.value = "0.0"
                pressureMin.value = "0.0"
                pressureMax.disabled = true
                pressureMin.disabled = true
              } else {
                pressureMax.disabled = false
                pressureMin.disabled = false
              }
              return
            }
            if (name == "PS最大圧【hPa(cmH2O)】" || name == "PS最小圧【hPa(cmH2O)】") {
              if (ipap.value && epap.value && pressureMax.value && pressureMin.value && Number(ipap.value) == Number(epap.value) && Number(pressureMax.value) == 0 && Number(pressureMin.value) == 0) {
                pressureMax.disabled = true
                pressureMin.disabled = true
              } else {
                pressureMax.disabled = false
                pressureMin.disabled = false
              }
              return
            }
          }
          if(name == "Flexタイプ"){
            // "Flex設定"
            var flex = this.reqParams.prescriptionItems.find(val => val.displayName == "Flex設定" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
            // "Flex設定ロック"
            var flexLock = this.reqParams.prescriptionItems.find(val => val.displayOrder == 14)
            // "ライズタイム"
            var riseTime = this.reqParams.prescriptionItems.find(val => val.displayName == "ライズタイム" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
            // "ライズタイムロック"
            var riseTimeLock = this.reqParams.prescriptionItems.find(val => val.displayName == "ライズタイムロック" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
            if(value=="0"){
              flex.value = ""
              flex.disabled = true
              riseTime.value = !riseTime.value ? riseTime.defaultValue : riseTime.value
              riseTimeLock.value = !riseTimeLock.value ? riseTimeLock.defaultValue : riseTimeLock.value
              riseTime.disabled = false
              riseTimeLock.disabled = false
              // QA474_処方値関連残
              // Bipap（Bi-Levelモード、Auto Bi-Levelモード）Flexタイプがオフの場合、Flex設定とFlex設定ロックは非活性とする。
              if (this.reqParams.mode == 1 || this.reqParams.mode == 8) {
                flexLock.value = ""
                flexLock.disabled = true
                // QA474_処方値関連残
                // Bipap（Bi-Levelモード、Auto Bi-Levelモード）Flexタイプがオフのときは、ライズタイムの選択肢を「1～3」とする
                // riseTime.displayValue = riseTime.displayValue.filter(v => v.key !== "0")
                // QA474 仕様変更 20260410
                riseTime.displayValue = [{"key":"","value":""},{"key":"0","value":"0"},{"key":"1","value":"1"},{"key":"2","value":"2"},{"key":"3","value":"3"}]
              }
            }else{
              flex.value = !flex.value ? flex.defaultValue : flex.value
              flexLock.value = !flexLock.value ? flexLock.defaultValue : flexLock.value
              flex.disabled = false
              flexLock.disabled = false
              riseTime.value = ""
              riseTimeLock.value = ""
              riseTime.disabled = true
              riseTimeLock.disabled = true
              // QA474_処方値関連残
              // Bipap（Bi-Levelモード、Auto Bi-Levelモード）Flexタイプがオフのときは、ライズタイムの選択肢を「1～3」とする
              riseTime.displayValue = [{"key":"","value":""},{"key":"0","value":"0"},{"key":"1","value":"1"},{"key":"2","value":"2"},{"key":"3","value":"3"}]
            }
            return
          }
          if (name == "Flex設定" || name == "Flex設定ロック" || name == "ライズタイム" || name == "ライズタイムロック") {
            // Flexタイプ
            var flexType
            if (this.reqParams.mode == 1) { // Auto Bi-Levelモード
              flexType = this.reqParams.prescriptionItems.find(val => val.displayOrder == 12)
            } else if (this.reqParams.mode == 4) { // CPAPモード
              flexType = this.reqParams.prescriptionItems.find(val => val.displayOrder == 10)
            } else if (this.reqParams.mode == 8) { // Bi-Levelモード
              flexType = this.reqParams.prescriptionItems.find(val => val.displayOrder == 11)
            }
            if (name == "Flex設定") {
              // "Flex設定"
              var flex = this.reqParams.prescriptionItems.find(val => val.displayOrder == 13)
              // Flexタイプ：0、Flex設定：値ありの場合
              // Flex設定「空白」を選択時、Flex設定を非活性とする
              if (value == "" && flexType.value == "0") {
                flex.disabled = true
              }
              return
            }
            if (name == "Flex設定ロック") {
              if (this.reqParams.mode == 1 || this.reqParams.mode == 8) {
                // "Flex設定"
                var flexLock = this.reqParams.prescriptionItems.find(val => val.displayOrder == 14)
                // Flexタイプ：0、Flex設定：値ありの場合
                // Flex設定「空白」を選択時、Flex設定を非活性とする
                if (value == "" && flexType.value == "0") {
                  flexLock.disabled = true
                }
              }
              return
            }
            if (name == "ライズタイム") {
              // Flexタイプ：1or2or3、ライズタイム：値ありの場合
              // ライズタイム「空白」を選択時、ライズタイムを非活性とする
              // "ライズタイム"
              var riseTime = this.reqParams.prescriptionItems.find(val => val.displayOrder == 15)
              if (value == "" && (flexType.value == "1" || flexType.value == "2" || flexType.value == "3")) {
                riseTime.disabled = true
              }
              return
            }
            if (name == "ライズタイムロック") {
              // "ライズタイムロック"
              var riseTimeLock = this.reqParams.prescriptionItems.find(val => val.displayOrder == 16)
              // Flexタイプ：1or2or3、ライズタイムロック：値ありの場合
              // ライズタイムロック「空白」を選択時、ライズタイムロックを非活性とする
              if (value == "" && (flexType.value == "1" || flexType.value == "2" || flexType.value == "3")) {
                riseTimeLock.disabled = true
              }
              return
            }
          }
          if(name == "加湿モード"){
            // 回路温度設定
            var circuit = this.reqParams.prescriptionItems.find(val => val.displayName == "回路温度設定" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
            if(value=="0" || value=="1"){
              circuit.value = ""
              circuit.disabled = true
            }else{
              circuit.value = circuit.defaultValue
              circuit.disabled = false
            }
            return
          }
          if(name == "患者情報管理"){
            // 登録方法
            var registMethod = this.reqParams.prescriptionItems.find(val => val.displayName == "登録方法" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
            if(value=="0"){
              registMethod.value = ""
              registMethod.disabled = true
            }else{
              registMethod.value = registMethod.defaultValue
              registMethod.disabled = false
            }
            return
          }
          // QA335_ドリームステーションのランプ設定の誤りを修正
          // ランプ時間とランプスタート圧の相関関係を削除
          // if(name == "ランプ時間【分】"){
          //   // ランプスタート圧【hPa(cmH2O)】
          //   var lampStart = this.reqParams.prescriptionItems.find(val => val.displayName == "ランプスタート圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
          //   if(value=="0"){
          //     lampStart.value = "4"
          //     lampStart.disabled = true
          //   }else{
          //     lampStart.disabled = false
          //   }
          //   return
          // }
          break;
        case 5:
          // エスボックス バイスタルク
          if(name == "CC+"){
            // "CC+機能有効時間　全治療時間"
            var ccAll = this.reqParams.prescriptionItems.find(val => val.displayName == "CC+機能有効時間　全治療時間" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
            // "CC+機能有効時間　ランプのみ"
            var ccLamp = this.reqParams.prescriptionItems.find(val => val.displayName == "CC+機能有効時間　ランプのみ" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
            if(value=="0"){
              ccAll.value = ""
              ccLamp.value = ""
              ccAll.disabled = true
              ccLamp.disabled = true
            }else{
              ccAll.value = ""
              ccAll.disabled = true
              ccLamp.value = ccLamp.defaultValue
              ccLamp.disabled = false
            }
            return
          }
          if(name == "CC+機能有効時間　全治療時間"){
            // "CC+機能有効時間　全治療時間"
            var ccAll = this.reqParams.prescriptionItems.find(val => val.displayName == "CC+機能有効時間　全治療時間" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
            // "CC+機能有効時間　ランプのみ"
            var ccLamp = this.reqParams.prescriptionItems.find(val => val.displayName == "CC+機能有効時間　ランプのみ" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
            if(value!="" && value!=null && value!="null"){
              // "CC+機能有効時間　ランプのみ"　非活性
              ccLamp.value = ""
              ccLamp.disabled = true
            }else{
              ccLamp.value = ccLamp.defaultValue
              ccLamp.disabled = false
              ccAll.disabled = true
            }
            return
          }
          if(name == "CC+機能有効時間　ランプのみ"){
            // "CC+機能有効時間　全治療時間"
            var ccAll = this.reqParams.prescriptionItems.find(val => val.displayName == "CC+機能有効時間　全治療時間" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
            // "CC+機能有効時間　ランプのみ"
            var ccLamp = this.reqParams.prescriptionItems.find(val => val.displayName == "CC+機能有効時間　ランプのみ" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
            if(value!="" && value!=null && value!="null"){
              ccAll.value = ""
              ccAll.disabled = true
            }else{
              ccAll.value = ccAll.defaultValue
              ccAll.disabled = false
              ccLamp.disabled = true
            }
            return
          }
          if(name == "ランプ機能"){
            // "ランプタイム"
            var lampTime = this.reqParams.prescriptionItems.find(val => val.displayName == "ランプタイム" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
            // "ランプ時間【分】"
            var lampTimeMinutes = this.reqParams.prescriptionItems.find(val => val.displayName == "ランプ時間【分】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
            // "ランプ開始圧【hPa(cmH2O)】"
            var lampStart = this.reqParams.prescriptionItems.find(val => val.displayName == "ランプ開始圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
            if(value=="0"){
              lampTime.value = ""
              lampTimeMinutes.value = ""
              lampStart.value = ""
              lampTime.disabled = true
              lampTimeMinutes.disabled = true
              lampStart.disabled = true
            }else{
              lampTime.value = lampTime.defaultValue
              lampTimeMinutes.value = lampTimeMinutes.defaultValue
              lampStart.value = lampStart.defaultValue
              lampTime.disabled = false
              lampTimeMinutes.disabled = false
              lampStart.disabled = false
            }
            return
          }
          if(name == "ランプタイム"){
            // "ランプ時間【分】"
            var lampTimeMinutes = this.reqParams.prescriptionItems.find(val => val.displayName == "ランプ時間【分】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
            if(value=="1"){
              lampTimeMinutes.value = ""
              lampTimeMinutes.disabled = true
            }else{
              // ランプ機能
              var lamp = this.reqParams.prescriptionItems.find(val => val.displayName == "ランプ機能" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
              if(lamp.value!="0"){
                lampTimeMinutes.value = lampTimeMinutes.defaultValue
                lampTimeMinutes.disabled = false
              }
            }
            return
          }
          if(name == "患者情報管理"){
            // 登録方法
            var registMethod = this.reqParams.prescriptionItems.find(val => val.displayName == "登録方法" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.reqParams.mode)) != -1))
            if(value=="0"){
              registMethod.value = ""
              registMethod.disabled = true
            }else{
              registMethod.value = registMethod.defaultValue
              registMethod.disabled = false
            }
            return
          }
          break;
        case 6:
          // プリズマ ライン (prisma25S)
          break;
      }
    },
    getAgreementStr: async function() {
      var excuteApi = this.getConsentStatementPOST;
      var successCallBack = this.getConsentStatementPOSTSuccess;
      var errorCallBack = this.getConsentStatementPOSTError;
      // WebAPI Call
      await this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getConsentStatementPOST: function(client) {
      var type = this.consentStatement.cpap;
      return client.apis.apiCommon.getConsentStatementPOST({
        body: {
          type: type
        } 
      });
    },
    getConsentStatementPOSTSuccess: function(result) {
      if(result.body.contents != ""){
        this.agreement = result.body.contents;
        this.canAgree = true;
      } else {
        this.agreement = "利用規約が登録されていません。";
      }
    },
    getConsentStatementPOSTError: function(result) {
      this.agreement == "利用規約を取得できませんでした。";
    },
    getMaskMaster: function() {
      var model = this.modelList.find(val => val.itemCodes && val.itemCodes.indexOf(this.reqParams.model) != -1)
      if(model){
        this.formatType = model.reportFormatType
        this.maskSelectModalActive=true
      }else{
        this.showErrorMessage("CPAP機種が選択されていません。")
      }
    },
    maskSelect: function(maskInfo) {
      this.reqParams.maskId = maskInfo.id
      this.reqParams.maskType = maskInfo.maskType
      this.reqParams.maskItemCode = maskInfo.itemCode1
      this.reqParams.cushionSize = maskInfo.cushionSize
      this.reqParams.frameSize = maskInfo.frameSize
      this.reqParams.fixingMethod = maskInfo.fixingMethod
    },
    tempDeviceSelect: function(deviceInfo) {
      this.reqParams.tempDeviceId = deviceInfo.id
      this.reqParams.model = deviceInfo.itemCode
      this.reqParams.serial = deviceInfo.serial
      this.reqParams.provisionalTakenOutItems = [deviceInfo]
      this.changeModel()
    },
    getApplication: async function() {
      if(this.preKind == 'hst') {
        var excuteApi = this.getHstRequestDetailPOST;
        var successCallBack = this.getHstRequestDetailPOSTSuccess;
        var errorCallBack = this.getHstRequestDetailPOSTError;
        // WebAPI Call
        await this.apiCall(excuteApi, successCallBack, errorCallBack);
      } else if (this.preKind == 'psg') {
        var excuteApi = this.getAnalysisDetailPOST;
        var successCallBack = this.getAnalysisDetailPOSTSuccess;
        var errorCallBack = this.getAnalysisDetailPOSTError;
        // WebAPI Call
        await this.apiCall(excuteApi, successCallBack, errorCallBack);
      } else if (this.preKind == 'holter') {
        var excuteApi = this.getHolterRequestDetailPOST;
        var successCallBack = this.getHolterRequestDetailPOSTSuccess;
        var errorCallBack = this.getHolterRequestDetailPOSTError;
        // WebAPI Call
        await this.apiCall(excuteApi, successCallBack, errorCallBack);
      }
    },
    getHstRequestDetailPOST: function(client) {
      return client.apis.internalHst.getHstRequestDetailPOST({
        body:{
          receiptNumber:this.preReceiptNumber,
        }
      });
    },
    getHstRequestDetailPOSTSuccess: function(result) {
      this.isApplicationValid = true
      var obj = result.obj.applicationDetails

      // 施設紹介先からの遷移の場合は、医師名、事務担当者名、患者IDを繋ぎ込まない
      if(this.introduction){
        this.reqParams.doctorName = ""
        this.reqParams.clerkName = ""
        this.reqParams.patient.patientRegistrationCard = ""
      }else{
        this.reqParams.doctorName = obj.doctorName
        this.reqParams.clerkName = obj.clerkName
        this.reqParams.patient.patientRegistrationCard = obj.patientsData[0].patientId
      }

      this.reqParams.patient.patientFamilyName = obj.patientsData[0].patientFamilyName
      this.reqParams.patient.patientFirstName = obj.patientsData[0].patientFirstName
      this.reqParams.patient.patientFamilyNameKana = obj.patientsData[0].patientFamilyNameKana
      this.reqParams.patient.patientFirstNameKana = obj.patientsData[0].patientFirstNameKana
      this.reqParams.patient.gender = obj.patientsData[0].gender
      this.reqParams.patient.birthday = obj.patientsData[0].birthday ? obj.patientsData[0].birthday.replace(/\//g, "-") : ""

      this.reqParams.patient.zip = obj.patientsData[0].zip
      this.reqParams.patient.address = obj.patientsData[0].address
      this.reqParams.patient.address1 = obj.patientsData[0].address1
      this.reqParams.patient.address2 = obj.patientsData[0].address2
      this.reqParams.patient.receiverName = obj.patientsData[0].receiverName
      this.reqParams.patient.mobilePhone = obj.patientsData[0].phoneNumber
    },
    getHstRequestDetailPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    getAnalysisDetailPOST: function(client) {
      return client.apis.externalAnalysis.getAnalysisDetailPOST({
        body:{
          receiptNumber:this.preReceiptNumber,
        }
      });
    },
    getAnalysisDetailPOSTSuccess: function(result) {
      this.isApplicationValid = true
      var obj = result.obj.requestDetails

      // 施設紹介先からの遷移の場合は、医師名、事務担当者名、患者IDを繋ぎ込まない
      if(this.introduction){
        this.reqParams.doctorName = ""
        this.reqParams.clerkName = ""
        this.reqParams.patient.patientRegistrationCard = ""
      }else{
        this.reqParams.doctorName = obj.doctorName
        this.reqParams.clerkName = obj.clerkName
        this.reqParams.patient.patientRegistrationCard = obj.patientId
      }

      this.reqParams.patient.patientFamilyName = obj.patientFamilyName
      this.reqParams.patient.patientFirstName = obj.patientFirstName
      this.reqParams.patient.patientFamilyNameKana = obj.patientFamilyNameKana
      this.reqParams.patient.patientFirstNameKana = obj.patientFirstNameKana
      this.reqParams.patient.gender = obj.gender
      this.reqParams.patient.birthday = obj.birthday ? obj.birthday.replace(/\//g, "-") : ""
      this.reqParams.patient.age = ""
    },
    getAnalysisDetailPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    getHolterRequestDetailPOST: function(client) {
      return client.apis.internalHolter.getHolterRequestDetailPOST({
        body:{
          receiptNumber:this.preReceiptNumber,
        }
      });
    },
    getHolterRequestDetailPOSTSuccess: function(result) {
      this.isApplicationValid = true
      var obj = result.obj.applicationDetails

      // 施設紹介先からの遷移の場合は、医師名、事務担当者名、患者IDを繋ぎ込まない
      if(this.introduction){
        this.reqParams.doctorName = ""
        this.reqParams.clerkName = ""
        this.reqParams.patient.patientRegistrationCard = ""
      }else{
        this.reqParams.doctorName = obj.doctorName
        this.reqParams.clerkName = obj.clerkName
        this.reqParams.patient.patientRegistrationCard = obj.patientsData[0].patientId
      }

      this.reqParams.patient.patientFamilyName = obj.patientsData[0].patientFamilyName
      this.reqParams.patient.patientFirstName = obj.patientsData[0].patientFirstName
      this.reqParams.patient.patientFamilyNameKana = obj.patientsData[0].patientFamilyNameKana
      this.reqParams.patient.patientFirstNameKana = obj.patientsData[0].patientFirstNameKana
      this.reqParams.patient.gender = obj.patientsData[0].gender
      this.reqParams.patient.birthday = obj.patientsData[0].birthday ? obj.patientsData[0].birthday.replace(/\//g, "-") : ""

      //院内貸出の場合、住所を繋ぎ込まない
      if(obj.depositMachineFlag){
        this.reqParams.patient.zip = ""
        this.reqParams.patient.address = ""
        this.reqParams.patient.address1 = ""
        this.reqParams.patient.address2 = ""
        this.reqParams.patient.receiverName = ""
      }else{
        this.reqParams.patient.zip = obj.patientsData[0].zip
        this.reqParams.patient.address = obj.patientsData[0].address
        this.reqParams.patient.address1 = obj.patientsData[0].address1
        this.reqParams.patient.address2 = obj.patientsData[0].address2
        this.reqParams.patient.receiverName = obj.patientsData[0].receiverName
      }
      
      this.reqParams.patient.mobilePhone = obj.patientsData[0].phoneNumber
    },
    getHolterRequestDetailPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    getCpapDefaultsettings: async function() {
      this.cpapBeforeRequestDetail = "";
      this.cpapDefaultSettingList = [];
      var excuteApi = this.getCpapDefaultsettingsListPOST;
      var successCallBack = this.getCpapDefaultsettingsListPOSTSuccess;
      var errorCallBack = this.getCpapDefaultsettingsListPOSTError;
      // WebAPI Call
      await this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getCpapDefaultsettingsListPOST: function(client) {
      return client.apis.externalCpap.getCpapDefaultsettingsListPOST({
        body:{
          belongsId : this.belongsId,
          institutionId : this.institutionId
        }
      });
    },
    getCpapDefaultsettingsListPOSTSuccess: function(result) {
      this.cpapDefaultSettingList = result.obj
    },
    getCpapDefaultsettingsListPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    cpapPreviousRequestCopy: function() {
      if (!this.cpapBeforeRequestDetail) {
        // QA491 空欄を選んだ場合は何もしない
        this.oldCpapBeforeRequestDetail = this.cpapBeforeRequestDetail
        return
      }
      this.isProcessingDefaultSetting = true
      var stepItems = document.getElementsByClassName("step-item")
      var target
      for(var item of stepItems){
        if(item.getAttribute("style") != "display: none;"){
          target = item
        }
      }
      var activeStep = target ? target.getAttribute("step") : ""

      var tmpName = this.cpapBeforeRequestDetail.templateName ? this.cpapBeforeRequestDetail.templateName : ""
      var itemName = this.cpapBeforeRequestDetail.itemName ? this.cpapBeforeRequestDetail.itemName : ""
      var mode = this.cpapBeforeRequestDetail.displayMode ? this.cpapBeforeRequestDetail.displayMode : ""

      var message = ""
      if (this.isDealer) {
        // ディーラーの場合、医療機関名を表示する
        message += "<div class='confirmText-title'><span class='confirmText-large'><strong>" + this.cpapBeforeRequestDetail.medicalInstitutionName + "</strong></span></div>"
      }
      message += "テンプレート名<br/>"
      message += "<span class='confirmText-large'><strong>" + tmpName + "</strong></span><br/>"
      message += "機　種：" + itemName + "<br/>"
      message += "モード：" + mode + "<br/>"
      message += "<br/>"
      message += "下記項目にデフォルト値を反映します。<br/>"
      message += "更新がある場合は手動入力にて変更を行ってください。<br/>"
      if (activeStep == "2") {
        // 医療機関情報
        message += "<span class='confirmText-middle'><strong><医療機関情報></strong></span><br/>"
        message += "　医師名：" + this.cpapBeforeRequestDetail.doctorName + "<br/>"
        message += "　事務担当者名：" + this.cpapBeforeRequestDetail.clerkName + "<br/>"
        if (this.cpapBeforeRequestDetail.mailNotification) {
          message += "　医療機関メールアドレス：" + this.cpapBeforeRequestDetail.mail + "<br/>"
        }
      }

      // 装置情報
      message += "<span class='confirmText-middle'><strong><設定情報></strong></span><br/>"
      // 処方値
      var target = null
      const prescriptionContent = JSON.parse(JSON.stringify(this.cpapBeforeRequestDetail.prescriptionContent))
      if (prescriptionContent) {
        switch (this.cpapBeforeRequestDetail.reportFormatType) {
          case 1: // DS Auto
          case 3: // DS Go
            if (this.cpapBeforeRequestDetail.mode == 1) {  // Auto CPAPモード
              // 最大圧
              var pressureMax = prescriptionContent.find(val => val.displayName == "最大圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.cpapBeforeRequestDetail.mode)) != -1))
              if (pressureMax) {
                message += "　" + pressureMax.displayName + "：" + pressureMax.value + "<br/>"
              }
              // 最小圧
              var pressureMin = prescriptionContent.find(val => val.displayName == "最小圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.cpapBeforeRequestDetail.mode)) != -1))
              if (pressureMin) {
                message += "　" + pressureMin.displayName + "：" + pressureMin.value + "<br/>"
              }
            }
            if (this.cpapBeforeRequestDetail.mode == 4) {  // CPAPモード
              // CPAP圧
              var pressureCpap = prescriptionContent.find(val => val.displayName == "CPAP圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.cpapBeforeRequestDetail.mode)) != -1))
              if (pressureCpap) {
                message += "　" + pressureCpap.displayName + "：" + pressureCpap.value + "<br/>"
              }
            }
            break
          case 4: // DS BiPAP
            if (this.cpapBeforeRequestDetail.mode == 1) {  // Auto Bi-Levelモード
              // IPAP最大圧
              var ipapMax = prescriptionContent.find(val => val.displayName == "IPAP最大圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.cpapBeforeRequestDetail.mode)) != -1))
              if (ipapMax) {
                message += "　" + ipapMax.displayName + "：" + ipapMax.value + "<br/>"
              }
              // EPAP最小圧
              var epapMin = prescriptionContent.find(val => val.displayName == "EPAP最小圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.cpapBeforeRequestDetail.mode)) != -1))
              if (epapMin) {
                message += "　" + epapMin.displayName + "：" + epapMin.value + "<br/>"
              }
              // PS最大圧
              var psMax = prescriptionContent.find(val => val.displayName == "PS最大圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.cpapBeforeRequestDetail.mode)) != -1))
              if (psMax) {
                message += "　" + psMax.displayName + "：" + psMax.value + "<br/>"
              }
              // PS最小圧
              var psMin = prescriptionContent.find(val => val.displayName == "PS最小圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.cpapBeforeRequestDetail.mode)) != -1))
              if (psMin) {
                message += "　" + psMin.displayName + "：" + psMin.value + "<br/>"
              }
            }
            if (this.cpapBeforeRequestDetail.mode == 4) {  // CPAPモード
              // CPAP圧
              var pressureCpap = prescriptionContent.find(val => val.displayName == "CPAP圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.cpapBeforeRequestDetail.mode)) != -1))
              if (pressureCpap) {
                message += "　" + pressureCpap.displayName + "：" + pressureCpap.value + "<br/>"
              }
            }
            if (this.cpapBeforeRequestDetail.mode == 8) {  // Bi-Levelモード
              // IPAP
              var ipap = prescriptionContent.find(val => val.displayName == "IPAP【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.cpapBeforeRequestDetail.mode)) != -1))
              if (ipap) {
                message += "　" + ipap.displayName + "：" + ipap.value + "<br/>"
              }
              // EPAP
              var epap = prescriptionContent.find(val => val.displayName == "EPAP【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.cpapBeforeRequestDetail.mode)) != -1))
              if (epap) {
                message += "　" + epap.displayName + "：" + epap.value + "<br/>"
              }
            }
            break
          default:
            break
        }
        // 全モード共通
        // Flexタイプ
        var flexType = prescriptionContent.find(val => val.displayName == "Flexタイプ" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.cpapBeforeRequestDetail.mode)) != -1))
        if (flexType) {
          var target = flexType.displayValue.find(val => val.key == flexType.value)
          message += "　" + flexType.displayName + "：" + target.value + "<br/>"
        }
        // Flex設定
        var flexOpt = prescriptionContent.find(val => val.displayName == "Flex設定" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.cpapBeforeRequestDetail.mode)) != -1))
        if (flexOpt && !flexOpt.disabled) {
          var target = flexOpt.displayValue.find(val => val.key == flexOpt.value)
          message += "　" + flexOpt.displayName + "：" + target.value + "<br/>"
        }
        // ランプ時間
        var lampTime = prescriptionContent.find(val => val.displayName == "ランプ時間【分】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.cpapBeforeRequestDetail.mode)) != -1))
        if (lampTime) {
          message += "　" + lampTime.displayName + "：" + lampTime.value + "<br/>"
        }
        // ランプスタート圧
        var lampStart = prescriptionContent.find(val => val.displayName == "ランプスタート圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.cpapBeforeRequestDetail.mode)) != -1))
        if (lampStart) {
          message += "　" + lampStart.displayName + "：" + lampStart.value + "<br/>"
        }

        // 加温加湿器
        var moistItem = prescriptionContent.find(val => val.displayName == "加温加湿器" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.cpapBeforeRequestDetail.mode)) != -1))
        if (moistItem) {
          var target = moistItem.displayValue.find(val => val.key == moistItem.value)
          message += "<span class='confirmText-middle'><strong><加温加湿器></strong></span><br/>"
          message += "　" + target.value + "<br/>"
        }

        // 通信モジュール
        if (this.cpapBeforeRequestDetail.reportFormatType == 1 || this.cpapBeforeRequestDetail.reportFormatType == 4) {
          // DS Auto or DS BiPAP
          var moduleItem = prescriptionContent.find(val => val.displayName == "通信モジュール" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.cpapBeforeRequestDetail.mode)) != -1))
          if (moduleItem) {
            var target = moduleItem.displayValue.find(val => val.key == moduleItem.value)
            message += "<span class='confirmText-middle'><strong><通信モジュール></strong></span><br/>"
            message += "　" + target.value + "<br/>"
          }
        } else if (this.cpapBeforeRequestDetail.reportFormatType == 3) {
          // DS Go
          // モバイルアプリを表示する
          var moduleItem = prescriptionContent.find(val => val.displayName == "モバイルアプリ" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.cpapBeforeRequestDetail.mode)) != -1))
          if (moduleItem) {
            var target = moduleItem.displayValue.find(val => val.key == moduleItem.value)
            message += "<span class='confirmText-middle'><strong><通信モジュール></strong></span><br/>"
            message += "　" + moduleItem.displayName + "：" + target.value + "<br/>"
          }
        }
      }

      // マスク
      message += "<span class='confirmText-middle'><strong><マスク></strong></span><br/>"
      if (this.cpapBeforeRequestDetail.maskType) {
        message += "　マスクタイプ：" + this.cpapBeforeRequestDetail.maskType + "<br/>"
      }
      // マスクが「その他」の場合は非表示
      if (this.cpapBeforeRequestDetail.cushionSize && this.cpapBeforeRequestDetail.maskType != "その他") {
        message += "　クッションサイズ：" + this.cpapBeforeRequestDetail.cushionSize + "<br/>"
      }
      if (this.cpapBeforeRequestDetail.frameSize && this.cpapBeforeRequestDetail.maskType != "その他") {
        message += "　フレームサイズ：" + this.cpapBeforeRequestDetail.frameSize + "<br/>"
      }

      // 納品先情報
      if (!this.temp && !this.isInstrument) {
        // 仮持出・預託では機器納品先の概念がないため非表示
        var delivery = this.cpapBeforeRequestDetail.delivaryTarget == "home" ? "患者宅" : "医療機関"
        message += "<span class='confirmText-middle'><strong><納品先情報></strong></span><br/>"
        message += "　" + delivery + "<br/>"
      }

      this.$dialog.confirm({
        title: "反映内容の確認",
        message: message,
        cancelText: "キャンセル",
        onCancel: () => {
          // キャンセルした場合、プルダウンを戻す
          this.cpapBeforeRequestDetail = this.oldCpapBeforeRequestDetail
          this.isProcessingDefaultSetting = false
          return;
        },
        onConfirm: async () => {
          this.oldCpapBeforeRequestDetail = this.cpapBeforeRequestDetail
          // 装置情報のプルダウンも更新
          this.cpapBeforeRequestDetailModel = this.cpapBeforeRequestDetail
          this.oldCpapBeforeRequestDetailModel = this.cpapBeforeRequestDetail
          this.setDefaultParam("2", this.cpapBeforeRequestDetail)
        }
      });
    },
    cpapPreviousRequestCopyModel: function() {
      if (!this.cpapBeforeRequestDetailModel) {
        // QA491 空欄を選んだ場合は何もしない
        this.oldCpapBeforeRequestDetailModel = this.cpapBeforeRequestDetailModel
        return
      }
      this.isProcessingDefaultSetting = true
      var stepItems = document.getElementsByClassName("step-item")
      var target
      for(var item of stepItems){
        if(item.getAttribute("style") != "display: none;"){
          target = item
        }
      }
      var activeStep = target ? target.getAttribute("step") : ""

      var tmpName = this.cpapBeforeRequestDetailModel.templateName ? this.cpapBeforeRequestDetailModel.templateName : ""
      var itemName = this.cpapBeforeRequestDetailModel.itemName ? this.cpapBeforeRequestDetailModel.itemName : ""
      var mode = this.cpapBeforeRequestDetailModel.displayMode ? this.cpapBeforeRequestDetailModel.displayMode : ""

      var message = ""
      if (this.isDealer) {
        // ディーラーの場合、医療機関名を表示する
        message += "<div class='confirmText-title'><span class='confirmText-large'><strong>" + this.cpapBeforeRequestDetailModel.medicalInstitutionName + "</strong></span></div>"
      }
      message += "テンプレート名<br/>"
      message += "<span class='confirmText-large'><strong>" + tmpName + "</strong></span><br/>"
      message += "機　種：" + itemName + "<br/>"
      message += "モード：" + mode + "<br/>"
      message += "<br/>"
      message += "下記項目にデフォルト値を反映します。<br/>"
      message += "更新がある場合は手動入力にて変更を行ってください。<br/>"
      if (activeStep == "3") {
        // 注記文
        message += "<span class='confirmText-small'>※医療機関情報（医師名、事務担当者名）には反映されません。</span><br/>"
      }

      // 装置情報
      message += "<span class='confirmText-middle'><strong><設定情報></strong></span><br/>"
      // 処方値
      var target = null
      const prescriptionContent = JSON.parse(JSON.stringify(this.cpapBeforeRequestDetailModel.prescriptionContent))
      if (prescriptionContent) {
        switch (this.cpapBeforeRequestDetailModel.reportFormatType) {
          case 1: // DS Auto
          case 3: // DS Go
            if (this.cpapBeforeRequestDetailModel.mode == 1) {  // Auto CPAPモード
              // 最大圧
              var pressureMax = prescriptionContent.find(val => val.displayName == "最大圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.cpapBeforeRequestDetailModel.mode)) != -1))
              if (pressureMax) {
                message += "　" + pressureMax.displayName + "：" + pressureMax.value + "<br/>"
              }
              // 最小圧
              var pressureMin = prescriptionContent.find(val => val.displayName == "最小圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.cpapBeforeRequestDetailModel.mode)) != -1))
              if (pressureMin) {
                message += "　" + pressureMin.displayName + "：" + pressureMin.value + "<br/>"
              }
            }
            if (this.cpapBeforeRequestDetailModel.mode == 4) {  // CPAPモード
              // CPAP圧
              var pressureCpap = prescriptionContent.find(val => val.displayName == "CPAP圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.cpapBeforeRequestDetailModel.mode)) != -1))
              if (pressureCpap) {
                message += "　" + pressureCpap.displayName + "：" + pressureCpap.value + "<br/>"
              }
            }
            break
          case 4: // DS BiPAP
            if (this.cpapBeforeRequestDetailModel.mode == 1) {  // Auto Bi-Levelモード
              // IPAP最大圧
              var ipapMax = prescriptionContent.find(val => val.displayName == "IPAP最大圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.cpapBeforeRequestDetailModel.mode)) != -1))
              if (ipapMax) {
                message += "　" + ipapMax.displayName + "：" + ipapMax.value + "<br/>"
              }
              // EPAP最小圧
              var epapMin = prescriptionContent.find(val => val.displayName == "EPAP最小圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.cpapBeforeRequestDetailModel.mode)) != -1))
              if (epapMin) {
                message += "　" + epapMin.displayName + "：" + epapMin.value + "<br/>"
              }
              // PS最大圧
              var psMax = prescriptionContent.find(val => val.displayName == "PS最大圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.cpapBeforeRequestDetailModel.mode)) != -1))
              if (psMax) {
                message += "　" + psMax.displayName + "：" + psMax.value + "<br/>"
              }
              // PS最小圧
              var psMin = prescriptionContent.find(val => val.displayName == "PS最小圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.cpapBeforeRequestDetailModel.mode)) != -1))
              if (psMin) {
                message += "　" + psMin.displayName + "：" + psMin.value + "<br/>"
              }
            }
            if (this.cpapBeforeRequestDetailModel.mode == 4) {  // CPAPモード
              // CPAP圧
              var pressureCpap = prescriptionContent.find(val => val.displayName == "CPAP圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.cpapBeforeRequestDetailModel.mode)) != -1))
              if (pressureCpap) {
                message += "　" + pressureCpap.displayName + "：" + pressureCpap.value + "<br/>"
              }
            }
            if (this.cpapBeforeRequestDetailModel.mode == 8) {  // Bi-Levelモード
              // IPAP
              var ipap = prescriptionContent.find(val => val.displayName == "IPAP【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.cpapBeforeRequestDetailModel.mode)) != -1))
              if (ipap) {
                message += "　" + ipap.displayName + "：" + ipap.value + "<br/>"
              }
              // EPAP
              var epap = prescriptionContent.find(val => val.displayName == "EPAP【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.cpapBeforeRequestDetailModel.mode)) != -1))
              if (epap) {
                message += "　" + epap.displayName + "：" + epap.value + "<br/>"
              }
            }
            break
          default:
            break
        }
        // 全モード共通
        // Flexタイプ
        var flexType = prescriptionContent.find(val => val.displayName == "Flexタイプ" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.cpapBeforeRequestDetailModel.mode)) != -1))
        if (flexType) {
          var target = flexType.displayValue.find(val => val.key == flexType.value)
          message += "　" + flexType.displayName + "：" + target.value + "<br/>"
        }
        // Flex設定
        var flexOpt = prescriptionContent.find(val => val.displayName == "Flex設定" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.cpapBeforeRequestDetailModel.mode)) != -1))
        if (flexOpt && !flexOpt.disabled) {
          var target = flexOpt.displayValue.find(val => val.key == flexOpt.value)
          message += "　" + flexOpt.displayName + "：" + target.value + "<br/>"
        }
        // ランプ時間
        var lampTime = prescriptionContent.find(val => val.displayName == "ランプ時間【分】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.cpapBeforeRequestDetailModel.mode)) != -1))
        if (lampTime) {
          message += "　" + lampTime.displayName + "：" + lampTime.value + "<br/>"
        }
        // ランプスタート圧
        var lampStart = prescriptionContent.find(val => val.displayName == "ランプスタート圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.cpapBeforeRequestDetailModel.mode)) != -1))
        if (lampStart) {
          message += "　" + lampStart.displayName + "：" + lampStart.value + "<br/>"
        }

        // 加温加湿器
        var moistItem = prescriptionContent.find(val => val.displayName == "加温加湿器" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.cpapBeforeRequestDetailModel.mode)) != -1))
        if (moistItem) {
          var target = moistItem.displayValue.find(val => val.key == moistItem.value)
          message += "<span class='confirmText-middle'><strong><加温加湿器></strong></span><br/>"
          message += "　" + target.value + "<br/>"
        }

        // 通信モジュール
        if (this.cpapBeforeRequestDetailModel.reportFormatType == 1 || this.cpapBeforeRequestDetailModel.reportFormatType == 4) {
          // DS Auto or DS BiPAP
          var moduleItem = prescriptionContent.find(val => val.displayName == "通信モジュール" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.cpapBeforeRequestDetailModel.mode)) != -1))
          if (moduleItem) {
            var target = moduleItem.displayValue.find(val => val.key == moduleItem.value)
            message += "<span class='confirmText-middle'><strong><通信モジュール></strong></span><br/>"
            message += "　" + target.value + "<br/>"
          }
        } else if (this.cpapBeforeRequestDetailModel.reportFormatType == 3) {
          // DS Go
          // モバイルアプリを表示する
          var moduleItem = prescriptionContent.find(val => val.displayName == "モバイルアプリ" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.cpapBeforeRequestDetailModel.mode)) != -1))
          if (moduleItem) {
            var target = moduleItem.displayValue.find(val => val.key == moduleItem.value)
            message += "<span class='confirmText-middle'><strong><通信モジュール></strong></span><br/>"
            message += "　" + moduleItem.displayName + "：" + target.value + "<br/>"
          }
        }
      }

      // マスク
      message += "<span class='confirmText-middle'><strong><マスク></strong></span><br/>"
      if (this.cpapBeforeRequestDetailModel.maskType) {
        message += "　マスクタイプ：" + this.cpapBeforeRequestDetailModel.maskType + "<br/>"
      }
      // マスクが「その他」の場合は非表示
      if (this.cpapBeforeRequestDetailModel.cushionSize && this.cpapBeforeRequestDetailModel.maskType != "その他") {
        message += "　クッションサイズ：" + this.cpapBeforeRequestDetailModel.cushionSize + "<br/>"
      }
      if (this.cpapBeforeRequestDetailModel.frameSize && this.cpapBeforeRequestDetailModel.maskType != "その他") {
        message += "　フレームサイズ：" + this.cpapBeforeRequestDetailModel.frameSize + "<br/>"
      }

      // 納品先情報
      if (!this.temp && !this.isInstrument) {
        // 仮持出・預託では機器納品先の概念がないため非表示
        var delivery = this.cpapBeforeRequestDetailModel.delivaryTarget == "home" ? "患者宅" : "医療機関"
        message += "<span class='confirmText-middle'><strong><納品先情報></strong></span><br/>"
        message += "　" + delivery + "<br/>"
      }

      this.$dialog.confirm({
        title: "反映内容の確認",
        message: message,
        cancelText: "キャンセル",
        onCancel: () => {
          // キャンセルした場合、プルダウンを戻す
          this.cpapBeforeRequestDetailModel = this.oldCpapBeforeRequestDetailModel
          this.isProcessingDefaultSetting = false
          return;
        },
        onConfirm: async () => {
          // 医療機関情報のプルダウンを空欄に更新
          this.cpapBeforeRequestDetail = ""
          this.oldCpapBeforeRequestDetailModel = this.cpapBeforeRequestDetailModel
          this.setDefaultParam("3", this.cpapBeforeRequestDetailModel)
        }
      });
    },
    setDefaultParam: function(step, param) {
      // デフォルト値設定の反映
      if (step == "2") {
        // 医師名
        this.reqParams.doctorName = param.doctorName
        // 事務担当者名
        this.reqParams.clerkName = param.clerkName
        // 医療機関へのメール送付(ディーラー代理)
        this.reqParams.mailNotification = param.mailNotification
        // 医療機関メールアドレス(ディーラー代理)
        this.reqParams.hospitalMail = param.mail
      }
      // 機種
      this.reqParams.reportFormatType = param.reportFormatType
      this.reqParams.model = param.itemCode
      // 処方設定
      this.reqParams.prescriptionItems = JSON.parse(JSON.stringify(param.prescriptionContent))
      // QA335_ドリームステーションのランプ設定の誤りを修正
      // 初期表示にてランプスタート圧を活性化
      var lampStart = this.reqParams.prescriptionItems.find(val => val.displayName == "ランプスタート圧【hPa(cmH2O)】")
      if (lampStart) {
        lampStart.disabled = false
      }
      // QA324 DS Auto、DS Go、DS BiPAPの場合
      if (this.reqParams.reportFormatType == 1 || this.reqParams.reportFormatType == 3 || this.reqParams.reportFormatType == 4) {
        // 呼吸回路タイプ12mmを選択不可とする
        var kokty = this.reqParams.prescriptionItems.find(val => val.itemName === "KOKTY")
        kokty.displayValue = kokty.displayValue.filter(v => v.key !== "12" && v.key !== "")
        // kokty.value = "15"
        // 患者情報管理 「アンコールエニウェア」と空白を選択不可とする
        var kjk = this.reqParams.prescriptionItems.find(val => val.displayName === "患者情報管理")
        kjk.displayValue = kjk.displayValue.filter(v => v.key !== "2" && v.key !== "")
        kjk.displayValue.sort((a, b) => Number(b.key) - Number(a.key))
        // kjk.value = "1"
        // 登録方法 「登録しない」と空白を選択不可とする
        var trh = this.reqParams.prescriptionItems.find(val => val.displayName === "登録方法")
        trh.displayValue = trh.displayValue.filter(v => v.key !== "0" && v.key !== "")
        // trh.value = "1"
      }
      // QA307_新ルール設定
      for (let newSelectTarget of this.reqParams.prescriptionItems) {
        // 選択肢から空白除去
        if (newSelectTarget.type == "sel"
            && newSelectTarget.displayName != "Flex設定"
            && newSelectTarget.displayName != "回路温度設定"
            && newSelectTarget.displayName != "ライズタイム"
            && newSelectTarget.displayName != "ライズタイムロック") {
            newSelectTarget.displayValue = newSelectTarget.displayValue.filter(val=> val.key !== "")
        }
        // Flex設定の選択肢から「OFF」を除去
        if (newSelectTarget.displayName == "Flex設定") { 
          newSelectTarget.displayValue = newSelectTarget.displayValue.filter(val=> val.key !== "0")
        }
        // 言語設定の選択肢から「その他」を除去
        if (newSelectTarget.displayName == "言語設定") { 
          newSelectTarget.displayValue = newSelectTarget.displayValue.filter(val=> val.key !== "5")
        }
      }
      switch(this.reqParams.reportFormatType){
        case 1:
        case 3:
          // ドリームステーションAuto
          // ドリームステーションGo
          for (var i = 0; i < this.reqParams.prescriptionItems.length; i++){
            if (this.reqParams.prescriptionItems[i].displayName == "CPAP圧【hPa(cmH2O)】" && this.reqParams.prescriptionItems[i].type == "char") {
              this.reqParams.prescriptionItems[i].value = Number(this.reqParams.prescriptionItems[i].value).toFixed(1)
              this.reqParams.prescriptionItems[i].defaultValue = Number(this.reqParams.prescriptionItems[i].defaultValue).toFixed(1)
              let newRule = [{"key":"4.0","value":"4.0"},{"key":"4.5","value":"4.5"},{"key":"5.0","value":"5.0"},{"key":"5.5","value":"5.5"},{"key":"6.0","value":"6.0"},{"key":"6.5","value":"6.5"},{"key":"7.0","value":"7.0"},{"key":"7.5","value":"7.5"},{"key":"8.0","value":"8.0"},{"key":"8.5","value":"8.5"},{"key":"9.0","value":"9.0"},{"key":"9.5","value":"9.5"},{"key":"10.0","value":"10.0"},{"key":"10.5","value":"10.5"},{"key":"11.0","value":"11.0"},{"key":"11.5","value":"11.5"},{"key":"12.0","value":"12.0"},{"key":"12.5","value":"12.5"},{"key":"13.0","value":"13.0"},{"key":"13.5","value":"13.5"},{"key":"14.0","value":"14.0"},{"key":"14.5","value":"14.5"},{"key":"15.0","value":"15.0"},{"key":"15.5","value":"15.5"},{"key":"16.0","value":"16.0"},{"key":"16.5","value":"16.5"},{"key":"17.0","value":"17.0"},{"key":"17.5","value":"17.5"},{"key":"18.0","value":"18.0"},{"key":"18.5","value":"18.5"},{"key":"19.0","value":"19.0"},{"key":"19.5","value":"19.5"},{"key":"20.0","value":"20.0"}]
              this.reqParams.prescriptionItems[i] = this.newRuleSet(this.reqParams.prescriptionItems[i], newRule)
              continue
            }
            if (this.reqParams.prescriptionItems[i].displayName == "最大圧【hPa(cmH2O)】" && this.reqParams.prescriptionItems[i].type == "char") {
              this.reqParams.prescriptionItems[i].value = Number(this.reqParams.prescriptionItems[i].value).toFixed(1)
              this.reqParams.prescriptionItems[i].defaultValue = Number(this.reqParams.prescriptionItems[i].defaultValue).toFixed(1)
              let newRule = [{"key":"4.0","value":"4.0"},{"key":"4.5","value":"4.5"},{"key":"5.0","value":"5.0"},{"key":"5.5","value":"5.5"},{"key":"6.0","value":"6.0"},{"key":"6.5","value":"6.5"},{"key":"7.0","value":"7.0"},{"key":"7.5","value":"7.5"},{"key":"8.0","value":"8.0"},{"key":"8.5","value":"8.5"},{"key":"9.0","value":"9.0"},{"key":"9.5","value":"9.5"},{"key":"10.0","value":"10.0"},{"key":"10.5","value":"10.5"},{"key":"11.0","value":"11.0"},{"key":"11.5","value":"11.5"},{"key":"12.0","value":"12.0"},{"key":"12.5","value":"12.5"},{"key":"13.0","value":"13.0"},{"key":"13.5","value":"13.5"},{"key":"14.0","value":"14.0"},{"key":"14.5","value":"14.5"},{"key":"15.0","value":"15.0"},{"key":"15.5","value":"15.5"},{"key":"16.0","value":"16.0"},{"key":"16.5","value":"16.5"},{"key":"17.0","value":"17.0"},{"key":"17.5","value":"17.5"},{"key":"18.0","value":"18.0"},{"key":"18.5","value":"18.5"},{"key":"19.0","value":"19.0"},{"key":"19.5","value":"19.5"},{"key":"20.0","value":"20.0"}]
              this.reqParams.prescriptionItems[i] = this.newRuleSet(this.reqParams.prescriptionItems[i], newRule)
              continue
            }
            if (this.reqParams.prescriptionItems[i].displayName == "最小圧【hPa(cmH2O)】" && this.reqParams.prescriptionItems[i].type == "char") {
              this.reqParams.prescriptionItems[i].value = Number(this.reqParams.prescriptionItems[i].value).toFixed(1)
              this.reqParams.prescriptionItems[i].defaultValue = Number(this.reqParams.prescriptionItems[i].defaultValue).toFixed(1)
              let newRule = [{"key":"4.0","value":"4.0"},{"key":"4.5","value":"4.5"},{"key":"5.0","value":"5.0"},{"key":"5.5","value":"5.5"},{"key":"6.0","value":"6.0"},{"key":"6.5","value":"6.5"},{"key":"7.0","value":"7.0"},{"key":"7.5","value":"7.5"},{"key":"8.0","value":"8.0"},{"key":"8.5","value":"8.5"},{"key":"9.0","value":"9.0"},{"key":"9.5","value":"9.5"},{"key":"10.0","value":"10.0"},{"key":"10.5","value":"10.5"},{"key":"11.0","value":"11.0"},{"key":"11.5","value":"11.5"},{"key":"12.0","value":"12.0"},{"key":"12.5","value":"12.5"},{"key":"13.0","value":"13.0"},{"key":"13.5","value":"13.5"},{"key":"14.0","value":"14.0"},{"key":"14.5","value":"14.5"},{"key":"15.0","value":"15.0"},{"key":"15.5","value":"15.5"},{"key":"16.0","value":"16.0"},{"key":"16.5","value":"16.5"},{"key":"17.0","value":"17.0"},{"key":"17.5","value":"17.5"},{"key":"18.0","value":"18.0"},{"key":"18.5","value":"18.5"},{"key":"19.0","value":"19.0"},{"key":"19.5","value":"19.5"},{"key":"20.0","value":"20.0"}]
              this.reqParams.prescriptionItems[i] = this.newRuleSet(this.reqParams.prescriptionItems[i], newRule)
              continue
            }
            if (this.reqParams.prescriptionItems[i].displayName == "ランプ時間【分】" && this.reqParams.prescriptionItems[i].type == "char") {
              let newRule = [{"key":"0","value":"0"},{"key":"5","value":"5"},{"key":"10","value":"10"},{"key":"15","value":"15"},{"key":"20","value":"20"},{"key":"25","value":"25"},{"key":"30","value":"30"},{"key":"35","value":"35"},{"key":"40","value":"40"},{"key":"45","value":"45"}]
              this.reqParams.prescriptionItems[i] = this.newRuleSet(this.reqParams.prescriptionItems[i], newRule)
              continue
            }
            if (this.reqParams.prescriptionItems[i].displayName == "ランプスタート圧【hPa(cmH2O)】" && this.reqParams.prescriptionItems[i].type == "char") {
              this.reqParams.prescriptionItems[i].value = Number(this.reqParams.prescriptionItems[i].value).toFixed(1)
              this.reqParams.prescriptionItems[i].defaultValue = Number(this.reqParams.prescriptionItems[i].defaultValue).toFixed(1)
              let newRule = [{"key":"4.0","value":"4.0"},{"key":"4.5","value":"4.5"},{"key":"5.0","value":"5.0"},{"key":"5.5","value":"5.5"},{"key":"6.0","value":"6.0"},{"key":"6.5","value":"6.5"},{"key":"7.0","value":"7.0"},{"key":"7.5","value":"7.5"},{"key":"8.0","value":"8.0"},{"key":"8.5","value":"8.5"},{"key":"9.0","value":"9.0"},{"key":"9.5","value":"9.5"},{"key":"10.0","value":"10.0"},{"key":"10.5","value":"10.5"},{"key":"11.0","value":"11.0"},{"key":"11.5","value":"11.5"},{"key":"12.0","value":"12.0"},{"key":"12.5","value":"12.5"},{"key":"13.0","value":"13.0"},{"key":"13.5","value":"13.5"},{"key":"14.0","value":"14.0"},{"key":"14.5","value":"14.5"},{"key":"15.0","value":"15.0"},{"key":"15.5","value":"15.5"},{"key":"16.0","value":"16.0"},{"key":"16.5","value":"16.5"},{"key":"17.0","value":"17.0"},{"key":"17.5","value":"17.5"},{"key":"18.0","value":"18.0"},{"key":"18.5","value":"18.5"},{"key":"19.0","value":"19.0"},{"key":"19.5","value":"19.5"},{"key":"20.0","value":"20.0"}]
              this.reqParams.prescriptionItems[i] = this.newRuleSet(this.reqParams.prescriptionItems[i], newRule)
              continue
            }
          }
          break;
        case 4:
          // ドリームステーションBiPAP Auto
          for (var i = 0; i < this.reqParams.prescriptionItems.length; i++){
            if (this.reqParams.prescriptionItems[i].displayName == "CPAP圧【hPa(cmH2O)】" && this.reqParams.prescriptionItems[i].type == "char") {
              this.reqParams.prescriptionItems[i].value = Number(this.reqParams.prescriptionItems[i].value).toFixed(1)
              this.reqParams.prescriptionItems[i].defaultValue = Number(this.reqParams.prescriptionItems[i].defaultValue).toFixed(1)
              let newRule = [{"key":"4.0","value":"4.0"},{"key":"4.5","value":"4.5"},{"key":"5.0","value":"5.0"},{"key":"5.5","value":"5.5"},{"key":"6.0","value":"6.0"},{"key":"6.5","value":"6.5"},{"key":"7.0","value":"7.0"},{"key":"7.5","value":"7.5"},{"key":"8.0","value":"8.0"},{"key":"8.5","value":"8.5"},{"key":"9.0","value":"9.0"},{"key":"9.5","value":"9.5"},{"key":"10.0","value":"10.0"},{"key":"10.5","value":"10.5"},{"key":"11.0","value":"11.0"},{"key":"11.5","value":"11.5"},{"key":"12.0","value":"12.0"},{"key":"12.5","value":"12.5"},{"key":"13.0","value":"13.0"},{"key":"13.5","value":"13.5"},{"key":"14.0","value":"14.0"},{"key":"14.5","value":"14.5"},{"key":"15.0","value":"15.0"},{"key":"15.5","value":"15.5"},{"key":"16.0","value":"16.0"},{"key":"16.5","value":"16.5"},{"key":"17.0","value":"17.0"},{"key":"17.5","value":"17.5"},{"key":"18.0","value":"18.0"},{"key":"18.5","value":"18.5"},{"key":"19.0","value":"19.0"},{"key":"19.5","value":"19.5"},{"key":"20.0","value":"20.0"},{"key":"20.5","value":"20.5"},{"key":"21.0","value":"21.0"},{"key":"21.5","value":"21.5"},{"key":"22.0","value":"22.0"},{"key":"22.5","value":"22.5"},{"key":"23.0","value":"23.0"},{"key":"23.5","value":"23.5"},{"key":"24.0","value":"24.0"},{"key":"24.5","value":"24.5"},{"key":"25.0","value":"25.0"}]
              this.reqParams.prescriptionItems[i] = this.newRuleSet(this.reqParams.prescriptionItems[i], newRule)
              continue
            }
            if (this.reqParams.prescriptionItems[i].displayName == "IPAP【hPa(cmH2O)】" && this.reqParams.prescriptionItems[i].type == "char") {
              this.reqParams.prescriptionItems[i].value = Number(this.reqParams.prescriptionItems[i].value).toFixed(1)
              this.reqParams.prescriptionItems[i].defaultValue = Number(this.reqParams.prescriptionItems[i].defaultValue).toFixed(1)
              let newRule = [{"key":"4.0","value":"4.0"},{"key":"4.5","value":"4.5"},{"key":"5.0","value":"5.0"},{"key":"5.5","value":"5.5"},{"key":"6.0","value":"6.0"},{"key":"6.5","value":"6.5"},{"key":"7.0","value":"7.0"},{"key":"7.5","value":"7.5"},{"key":"8.0","value":"8.0"},{"key":"8.5","value":"8.5"},{"key":"9.0","value":"9.0"},{"key":"9.5","value":"9.5"},{"key":"10.0","value":"10.0"},{"key":"10.5","value":"10.5"},{"key":"11.0","value":"11.0"},{"key":"11.5","value":"11.5"},{"key":"12.0","value":"12.0"},{"key":"12.5","value":"12.5"},{"key":"13.0","value":"13.0"},{"key":"13.5","value":"13.5"},{"key":"14.0","value":"14.0"},{"key":"14.5","value":"14.5"},{"key":"15.0","value":"15.0"},{"key":"15.5","value":"15.5"},{"key":"16.0","value":"16.0"},{"key":"16.5","value":"16.5"},{"key":"17.0","value":"17.0"},{"key":"17.5","value":"17.5"},{"key":"18.0","value":"18.0"},{"key":"18.5","value":"18.5"},{"key":"19.0","value":"19.0"},{"key":"19.5","value":"19.5"},{"key":"20.0","value":"20.0"},{"key":"20.5","value":"20.5"},{"key":"21.0","value":"21.0"},{"key":"21.5","value":"21.5"},{"key":"22.0","value":"22.0"},{"key":"22.5","value":"22.5"},{"key":"23.0","value":"23.0"},{"key":"23.5","value":"23.5"},{"key":"24.0","value":"24.0"},{"key":"24.5","value":"24.5"},{"key":"25.0","value":"25.0"}]
              this.reqParams.prescriptionItems[i] = this.newRuleSet(this.reqParams.prescriptionItems[i], newRule)
              continue
            }
            if (this.reqParams.prescriptionItems[i].displayName == "EPAP【hPa(cmH2O)】" && this.reqParams.prescriptionItems[i].type == "char") {
              this.reqParams.prescriptionItems[i].value = Number(this.reqParams.prescriptionItems[i].value).toFixed(1)
              this.reqParams.prescriptionItems[i].defaultValue = Number(this.reqParams.prescriptionItems[i].defaultValue).toFixed(1)
              let newRule = [{"key":"4.0","value":"4.0"},{"key":"4.5","value":"4.5"},{"key":"5.0","value":"5.0"},{"key":"5.5","value":"5.5"},{"key":"6.0","value":"6.0"},{"key":"6.5","value":"6.5"},{"key":"7.0","value":"7.0"},{"key":"7.5","value":"7.5"},{"key":"8.0","value":"8.0"},{"key":"8.5","value":"8.5"},{"key":"9.0","value":"9.0"},{"key":"9.5","value":"9.5"},{"key":"10.0","value":"10.0"},{"key":"10.5","value":"10.5"},{"key":"11.0","value":"11.0"},{"key":"11.5","value":"11.5"},{"key":"12.0","value":"12.0"},{"key":"12.5","value":"12.5"},{"key":"13.0","value":"13.0"},{"key":"13.5","value":"13.5"},{"key":"14.0","value":"14.0"},{"key":"14.5","value":"14.5"},{"key":"15.0","value":"15.0"},{"key":"15.5","value":"15.5"},{"key":"16.0","value":"16.0"},{"key":"16.5","value":"16.5"},{"key":"17.0","value":"17.0"},{"key":"17.5","value":"17.5"},{"key":"18.0","value":"18.0"},{"key":"18.5","value":"18.5"},{"key":"19.0","value":"19.0"},{"key":"19.5","value":"19.5"},{"key":"20.0","value":"20.0"},{"key":"20.5","value":"20.5"},{"key":"21.0","value":"21.0"},{"key":"21.5","value":"21.5"},{"key":"22.0","value":"22.0"},{"key":"22.5","value":"22.5"},{"key":"23.0","value":"23.0"},{"key":"23.5","value":"23.5"},{"key":"24.0","value":"24.0"},{"key":"24.5","value":"24.5"},{"key":"25.0","value":"25.0"}]
              this.reqParams.prescriptionItems[i] = this.newRuleSet(this.reqParams.prescriptionItems[i], newRule)
              continue
            }
            if (this.reqParams.prescriptionItems[i].displayName == "IPAP最大圧【hPa(cmH2O)】" && this.reqParams.prescriptionItems[i].type == "char") {
              this.reqParams.prescriptionItems[i].value = Number(this.reqParams.prescriptionItems[i].value).toFixed(1)
              this.reqParams.prescriptionItems[i].defaultValue = Number(this.reqParams.prescriptionItems[i].defaultValue).toFixed(1)
              let newRule = [{"key":"4.0","value":"4.0"},{"key":"4.5","value":"4.5"},{"key":"5.0","value":"5.0"},{"key":"5.5","value":"5.5"},{"key":"6.0","value":"6.0"},{"key":"6.5","value":"6.5"},{"key":"7.0","value":"7.0"},{"key":"7.5","value":"7.5"},{"key":"8.0","value":"8.0"},{"key":"8.5","value":"8.5"},{"key":"9.0","value":"9.0"},{"key":"9.5","value":"9.5"},{"key":"10.0","value":"10.0"},{"key":"10.5","value":"10.5"},{"key":"11.0","value":"11.0"},{"key":"11.5","value":"11.5"},{"key":"12.0","value":"12.0"},{"key":"12.5","value":"12.5"},{"key":"13.0","value":"13.0"},{"key":"13.5","value":"13.5"},{"key":"14.0","value":"14.0"},{"key":"14.5","value":"14.5"},{"key":"15.0","value":"15.0"},{"key":"15.5","value":"15.5"},{"key":"16.0","value":"16.0"},{"key":"16.5","value":"16.5"},{"key":"17.0","value":"17.0"},{"key":"17.5","value":"17.5"},{"key":"18.0","value":"18.0"},{"key":"18.5","value":"18.5"},{"key":"19.0","value":"19.0"},{"key":"19.5","value":"19.5"},{"key":"20.0","value":"20.0"},{"key":"20.5","value":"20.5"},{"key":"21.0","value":"21.0"},{"key":"21.5","value":"21.5"},{"key":"22.0","value":"22.0"},{"key":"22.5","value":"22.5"},{"key":"23.0","value":"23.0"},{"key":"23.5","value":"23.5"},{"key":"24.0","value":"24.0"},{"key":"24.5","value":"24.5"},{"key":"25.0","value":"25.0"}]
              this.reqParams.prescriptionItems[i] = this.newRuleSet(this.reqParams.prescriptionItems[i], newRule)
              continue
            }
            if (this.reqParams.prescriptionItems[i].displayName == "EPAP最小圧【hPa(cmH2O)】" && this.reqParams.prescriptionItems[i].type == "char") {
              this.reqParams.prescriptionItems[i].value = Number(this.reqParams.prescriptionItems[i].value).toFixed(1)
              this.reqParams.prescriptionItems[i].defaultValue = Number(this.reqParams.prescriptionItems[i].defaultValue).toFixed(1)
              let newRule = [{"key":"4.0","value":"4.0"},{"key":"4.5","value":"4.5"},{"key":"5.0","value":"5.0"},{"key":"5.5","value":"5.5"},{"key":"6.0","value":"6.0"},{"key":"6.5","value":"6.5"},{"key":"7.0","value":"7.0"},{"key":"7.5","value":"7.5"},{"key":"8.0","value":"8.0"},{"key":"8.5","value":"8.5"},{"key":"9.0","value":"9.0"},{"key":"9.5","value":"9.5"},{"key":"10.0","value":"10.0"},{"key":"10.5","value":"10.5"},{"key":"11.0","value":"11.0"},{"key":"11.5","value":"11.5"},{"key":"12.0","value":"12.0"},{"key":"12.5","value":"12.5"},{"key":"13.0","value":"13.0"},{"key":"13.5","value":"13.5"},{"key":"14.0","value":"14.0"},{"key":"14.5","value":"14.5"},{"key":"15.0","value":"15.0"},{"key":"15.5","value":"15.5"},{"key":"16.0","value":"16.0"},{"key":"16.5","value":"16.5"},{"key":"17.0","value":"17.0"},{"key":"17.5","value":"17.5"},{"key":"18.0","value":"18.0"},{"key":"18.5","value":"18.5"},{"key":"19.0","value":"19.0"},{"key":"19.5","value":"19.5"},{"key":"20.0","value":"20.0"},{"key":"20.5","value":"20.5"},{"key":"21.0","value":"21.0"},{"key":"21.5","value":"21.5"},{"key":"22.0","value":"22.0"},{"key":"22.5","value":"22.5"},{"key":"23.0","value":"23.0"},{"key":"23.5","value":"23.5"},{"key":"24.0","value":"24.0"},{"key":"24.5","value":"24.5"},{"key":"25.0","value":"25.0"}]
              this.reqParams.prescriptionItems[i] = this.newRuleSet(this.reqParams.prescriptionItems[i], newRule)
              continue
            }
            if (this.reqParams.prescriptionItems[i].displayName == "PS最大圧【hPa(cmH2O)】" && this.reqParams.prescriptionItems[i].type == "char") {
              this.reqParams.prescriptionItems[i].value = Number(this.reqParams.prescriptionItems[i].value).toFixed(1)
              this.reqParams.prescriptionItems[i].defaultValue = Number(this.reqParams.prescriptionItems[i].defaultValue).toFixed(1)
              let newRule = [{"key":"0.0","value":"0.0"},{"key":"0.5","value":"0.5"},{"key":"1.0","value":"1.0"},{"key":"1.5","value":"1.5"},{"key":"2.0","value":"2.0"},{"key":"2.5","value":"2.5"},{"key":"3.0","value":"3.0"},{"key":"3.5","value":"3.5"},{"key":"4.0","value":"4.0"},{"key":"4.5","value":"4.5"},{"key":"5.0","value":"5.0"},{"key":"5.5","value":"5.5"},{"key":"6.0","value":"6.0"},{"key":"6.5","value":"6.5"},{"key":"7.0","value":"7.0"},{"key":"7.5","value":"7.5"},{"key":"8.0","value":"8.0"}]
              this.reqParams.prescriptionItems[i] = this.newRuleSet(this.reqParams.prescriptionItems[i], newRule)
              continue
            }
            if (this.reqParams.prescriptionItems[i].displayName == "PS最小圧【hPa(cmH2O)】" && this.reqParams.prescriptionItems[i].type == "char") {
              this.reqParams.prescriptionItems[i].value = Number(this.reqParams.prescriptionItems[i].value).toFixed(1)
              this.reqParams.prescriptionItems[i].defaultValue = Number(this.reqParams.prescriptionItems[i].defaultValue).toFixed(1)
              let newRule = [{"key":"0.0","value":"0.0"},{"key":"0.5","value":"0.5"},{"key":"1.0","value":"1.0"},{"key":"1.5","value":"1.5"},{"key":"2.0","value":"2.0"},{"key":"2.5","value":"2.5"},{"key":"3.0","value":"3.0"},{"key":"3.5","value":"3.5"},{"key":"4.0","value":"4.0"},{"key":"4.5","value":"4.5"},{"key":"5.0","value":"5.0"},{"key":"5.5","value":"5.5"},{"key":"6.0","value":"6.0"},{"key":"6.5","value":"6.5"},{"key":"7.0","value":"7.0"},{"key":"7.5","value":"7.5"},{"key":"8.0","value":"8.0"}]
              this.reqParams.prescriptionItems[i] = this.newRuleSet(this.reqParams.prescriptionItems[i], newRule)
              continue
            }
            if (this.reqParams.prescriptionItems[i].displayName == "ランプ時間【分】" && this.reqParams.prescriptionItems[i].type == "char") {
              let newRule = [{"key":"0","value":"0"},{"key":"5","value":"5"},{"key":"10","value":"10"},{"key":"15","value":"15"},{"key":"20","value":"20"},{"key":"25","value":"25"},{"key":"30","value":"30"},{"key":"35","value":"35"},{"key":"40","value":"40"},{"key":"45","value":"45"}]
              this.reqParams.prescriptionItems[i] = this.newRuleSet(this.reqParams.prescriptionItems[i], newRule)
              continue
            }
            if (this.reqParams.prescriptionItems[i].displayName == "ランプスタート圧【hPa(cmH2O)】" && this.reqParams.prescriptionItems[i].type == "char") {
              this.reqParams.prescriptionItems[i].value = Number(this.reqParams.prescriptionItems[i].value).toFixed(1)
              this.reqParams.prescriptionItems[i].defaultValue = Number(this.reqParams.prescriptionItems[i].defaultValue).toFixed(1)
              let newRule = [{"key":"4.0","value":"4.0"},{"key":"4.5","value":"4.5"},{"key":"5.0","value":"5.0"},{"key":"5.5","value":"5.5"},{"key":"6.0","value":"6.0"},{"key":"6.5","value":"6.5"},{"key":"7.0","value":"7.0"},{"key":"7.5","value":"7.5"},{"key":"8.0","value":"8.0"},{"key":"8.5","value":"8.5"},{"key":"9.0","value":"9.0"},{"key":"9.5","value":"9.5"},{"key":"10.0","value":"10.0"},{"key":"10.5","value":"10.5"},{"key":"11.0","value":"11.0"},{"key":"11.5","value":"11.5"},{"key":"12.0","value":"12.0"},{"key":"12.5","value":"12.5"},{"key":"13.0","value":"13.0"},{"key":"13.5","value":"13.5"},{"key":"14.0","value":"14.0"},{"key":"14.5","value":"14.5"},{"key":"15.0","value":"15.0"},{"key":"15.5","value":"15.5"},{"key":"16.0","value":"16.0"},{"key":"16.5","value":"16.5"},{"key":"17.0","value":"17.0"},{"key":"17.5","value":"17.5"},{"key":"18.0","value":"18.0"},{"key":"18.5","value":"18.5"},{"key":"19.0","value":"19.0"},{"key":"19.5","value":"19.5"},{"key":"20.0","value":"20.0"},{"key":"20.5","value":"20.5"},{"key":"21.0","value":"21.0"},{"key":"21.5","value":"21.5"},{"key":"22.0","value":"22.0"},{"key":"22.5","value":"22.5"},{"key":"23.0","value":"23.0"},{"key":"23.5","value":"23.5"},{"key":"24.0","value":"24.0"},{"key":"24.5","value":"24.5"},{"key":"25.0","value":"25.0"}]
              this.reqParams.prescriptionItems[i] = this.newRuleSet(this.reqParams.prescriptionItems[i], newRule)
              continue
            }
          }
          // QA474_処方値関連残
          var mode = this.reqParams.prescriptionItems.find(val => val.displayOrder == 1)
          var flexLock = this.reqParams.prescriptionItems.find(val => val.displayOrder == 14)
          var flex = this.reqParams.prescriptionItems.find(val => val.displayOrder == 13)
          var riseTime = this.reqParams.prescriptionItems.find(val => val.displayOrder == 15)
          // Bipap（Auto Bi-Levelモード）Flexタイプの選択肢はBi-Flex、0（オフ）のみとする。
          var flexType1 = this.reqParams.prescriptionItems.find(val => val.displayOrder == 12)
          var flexType8 = this.reqParams.prescriptionItems.find(val => val.displayOrder == 11)
          flexType1.displayValue = flexType1.displayValue.filter(v => v.key !== "2")
          flexType8.displayValue = flexType8.displayValue.filter(v => v.key !== "2" && v.key !== "3")
          if (mode.value == 1) {
            // Bipap（Auto Bi-Levelモード）IPAP＝EPAPかつPS最大圧0、PS最小圧0のとき、PS最大圧、PS最小圧は非活性とする。
            var ipapMax = this.reqParams.prescriptionItems.find(val => val.displayOrder == 5)
            var epapMin = this.reqParams.prescriptionItems.find(val => val.displayOrder == 6)
            var pressureMax = this.reqParams.prescriptionItems.find(val => val.displayOrder == 7)
            var pressureMin = this.reqParams.prescriptionItems.find(val => val.displayOrder == 8)
            if (Number(ipapMax.value) == Number(epapMin.value)) {
              pressureMax.value = "0.0"
              pressureMin.value = "0.0"
              pressureMax.disabled = true
              pressureMin.disabled = true
            }
            // Bipap（Auto Bi-Levelモード）Flexタイプがオフの場合、Flex設定とFlex設定ロックは非活性とする。
            if (flexType1.value == "0") {
              flex.value = ""
              flex.disabled = true
              flexLock.value = ""
              flexLock.disabled = true
              // Bipap（Auto Bi-Levelモード）Flexタイプがオフのときはライズタイムの選択肢を「1～3」とする
              // riseTime.displayValue = riseTime.displayValue.filter(v => v.key !== "0")
              // QA474 仕様変更 20260410
              riseTime.displayValue = [{"key":"","value":""},{"key":"0","value":"0"},{"key":"1","value":"1"},{"key":"2","value":"2"},{"key":"3","value":"3"}]
            }
          } else if (mode.value == 8) {
            // Bipap（Bi-Levelモード）Flexタイプがオフの場合、Flex設定とFlex設定ロックは非活性とする。
            if (flexType8.value == "0") {
              flex.value = ""
              flex.disabled = true
              flexLock.value = ""
              flexLock.disabled = true
              // Bipap（Bi-Levelモード）Flexタイプがオフのときはライズタイムの選択肢を「1～3」とする
              // riseTime.displayValue = riseTime.displayValue.filter(v => v.key !== "0")
              // QA474 仕様変更 20260410
              riseTime.displayValue = [{"key":"","value":""},{"key":"0","value":"0"},{"key":"1","value":"1"},{"key":"2","value":"2"},{"key":"3","value":"3"}]
            }
          }
          break;
      }
      // 20230927 デフォルト設定一律で設置日に当日日付を設定
      // 加温加湿器：設置日,通信モジュール：設置日
      for(var item of this.reqParams.prescriptionItems){
        if(item.displayName.indexOf("設置日") == -1) continue
        //処方再開(中止)の場合は設置日を空に、それ以外は本日日付を入力
        item.value = this.yyyy_hyp_MM_hyp_dd(new Date())
      }
      for(var item of param.prescriptionContent){
        if(item.displayName.indexOf("設置日") == -1) continue
        item.value = this.yyyy_hyp_MM_hyp_dd(new Date())
      }
      // モード
      this.reqParams.mode = param.mode
      // 加湿器有無
      this.reqParams.useMoist = param.useMoist
      // 通信モジュール有無
      this.reqParams.useModule = param.useModule
      // マスク情報
      this.reqParams.maskId = param.maskId
      this.reqParams.maskType = param.maskType
      this.reqParams.maskItemCode = param.maskItemCode
      this.reqParams.cushionSize = param.cushionSize
      this.reqParams.frameSize = param.frameSize
      this.reqParams.fixingMethod = param.fixingMethod
      this.reqParams.memo = param.maskMemo ? param.maskMemo : ""
      // 納品先情報(患者宅/医療機関)
      this.reqParams.delivaryTarget = param.delivaryTarget
      // QA316
      if (this.reqParams.delivaryTarget == 'hospital') {
        this.reqParams.deliveryPostcode = this.reqParams.zip
        this.reqParams.deliveryAddress = this.reqParams.address
        this.reqParams.deliveryHouseNumber = this.reqParams.address1
        this.reqParams.deliveryBuilding = this.reqParams.address2
        this.reqParams.deliveryDestination = this.reqParams.receiverName
        this.reqParams.deliveryPhoneNumber = this.reqParams.phoneNumber
      }
      this.$nextTick(() => {
        // QA491デフォルト値の更新が終わってからフラグを落とす
        this.isProcessingDefaultSetting = false
      })
    },
    download: function() {
      this.$store.dispatch("downloadConsentStatement", {
          type: this.consentStatement.cpap,
          uid: this.userInfo.id
      }).then(result => {
          if(!result.status || result.status != 200){
              if(result.obj){
                  this.showErrorMessage(result.obj.message);
              } else {
                  this.showErrorMessage(result.message);
              }
          }
      }).catch(error => {
          this.showErrorMessage(error);
      });
    },
    getEscrowStock: async function() {
      var excuteApi = this.getEscrowStockPOST;
      var successCallBack = this.getEscrowStockPOSTSuccess;
      var errorCallBack = this.getEscrowStockPOSTError;
      // WebAPI Call
      await this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getEscrowStockPOST: function(client) {
      return client.apis.externalCpap.getEscrowStockPOST({
        body:{
          hospitalCode:this.medicalInstitutionCode,
        }
      });
    },
    getEscrowStockPOSTSuccess: function(result) {
      this.escrowStockList = result.body.map((value) => value.items).flat();
      this.stockItemNameList = this.escrowStockList.map((value) => value.itemName);
      this.stockItemCodeList = this.escrowStockList.map((value) => value.itemCode);
      this.stockItemSeialList = this.escrowStockList.map((value) => value.serial);
    },
    replaceCharTab: function(inputChar) {
      if (typeof inputChar == 'string') {
        inputChar = inputChar.replace(/\t/g, '').replace(/(\r)*\n/g, '').replace(/\r/g, '');
      }
      return inputChar;
    },
    changeDelivaryTarget: function(delivaryTarget) {
      if (delivaryTarget == 'home') {
        this.reqParams.deliveryPostcode = this.reqParams.patient.zip
        this.reqParams.deliveryAddress = this.reqParams.patient.address
        this.reqParams.deliveryHouseNumber = this.reqParams.patient.address1
        this.reqParams.deliveryBuilding = this.reqParams.patient.address2
        this.reqParams.deliveryDestination = this.reqParams.patient.patientFamilyName + " " + this.reqParams.patient.patientFirstName
        if (this.reqParams.patient.mobilePhone) {
          this.reqParams.deliveryPhoneNumber = this.reqParams.patient.mobilePhone
        } else {
          this.reqParams.deliveryPhoneNumber = this.reqParams.patient.phoneNumber
        }
      } else {
        this.reqParams.deliveryPostcode = this.reqParams.zip
        this.reqParams.deliveryAddress = this.reqParams.address
        this.reqParams.deliveryHouseNumber = this.reqParams.address1
        this.reqParams.deliveryBuilding = this.reqParams.address2
        this.reqParams.deliveryDestination = this.reqParams.receiverName
        this.reqParams.deliveryPhoneNumber = this.reqParams.phoneNumber
      }
      this.isChangeDelivaryTarget = true;
    },
    newRuleSet: function(newRuleTarget,newRule){
      // QA307_新ルール設定
      // 受け取ったオブジェクトをコピー(deep)
      var tmpTarget = JSON.parse(JSON.stringify(newRuleTarget));
      // 設定値更新
      tmpTarget.type = "sel"
      tmpTarget.validationRule = newRule
      // キーを置換
      var replaceKeys = { validationRule: 'displayValue' }
      var sortedObject = Object.keys(tmpTarget).map(key => {
        const newKey = replaceKeys[key] || key
        return { [newKey]: tmpTarget[key] }
      })
      // Array->Objectにして返す
      return Object.assign({}, ...sortedObject);
    },
    async setDraftDate(params) {
      // hospital info
      this.isPatientAgree = true;
      this.reqParams.medicalInstitutionName = params.medicalInstitutionName;
      this.reqParams.doctorName = params.doctorName;
      this.reqParams.clerkName = params.clerkName;
      // patient info
      this.reqParams.patient.patientRegistrationCard = params.patientCardId;
      this.reqParams.patient.patientFamilyName = params.patientLastName;
      this.reqParams.patient.patientFirstName = params.patientFirstName;
      this.reqParams.patient.patientFamilyNameKana = params.patientLastNameKana;
      this.reqParams.patient.patientFirstNameKana = params.patientFirstNameKana;
      this.reqParams.patient.gender = params.patientGender;
      this.reqParams.patient.birthday = params.patientBirthday;
      this.reqParams.patient.receiverName = params.patientReceiverName;
      this.reqParams.patient.zip = params.patientPostCode;
      this.reqParams.patient.address = params.patientAddress;
      this.reqParams.patient.address1 = params.patientAddressHouseNumber;
      this.reqParams.patient.address2 = params.patientAddressBuildingName;
      this.reqParams.patient.mobilePhone = params.patientMobilePhoneNumber;
      this.reqParams.patient.phoneNumber = params.patientOtherPhoneNumber;
      this.reqParams.patient.followUpCall = params.isEnabledFollowUpCall;
      this.reqParams.patient.disease = params.diseaseName;
      this.reqParams.patient.infection = params.infectionType;
      this.reqParams.patient.infectionName = params.infectionName;
      this.reqParams.patient.hospitalName = params.regionalInstitutionName;
      this.reqParams.patient.doctorName = params.regionalDoctorName;
      // delivery info
      this.reqParams.delivaryTarget = this.convertDestType(params.destType);
      this.reqParams.deliveryOther = params.deliveryOther;
      this.reqParams.zip = params.zip;
      this.reqParams.address = params.address;
      this.reqParams.address1 = params.address1;
      this.reqParams.address2 = params.address2;
      this.reqParams.receiverName = params.receiverName;
      this.reqParams.phoneNumber = params.phoneNumber;
      this.reqParams.deliveryPostcode = params.destPostCode;
      this.reqParams.deliveryAddress = params.destAddress;
      this.reqParams.deliveryHouseNumber = params.destAddressHouseNumber;
      this.reqParams.deliveryBuilding = params.destAddressBuildingName;
      this.reqParams.deliveryDestination = params.destReceiverName;
      this.reqParams.deliveryPhoneNumber = params.destPhoneNumber;
      // other
      this.reqParams.memo = params.remarks;
      // device info
      if (params.deviceFormatType) {
        this.reqParams.reportFormatType = Number(params.deviceFormatType);
      }
      this.modelList = this.getCpapMaster();
      this.modelList = this.modelList.filter(val=>{ return val.reportFormatType===1 || val.reportFormatType===3 || val.reportFormatType===4 || val.reportFormatType===this.reqParams.reportFormatType})
      let model = this.modelList.find(val => val.reportFormatType == this.reqParams.reportFormatType);
      this.reqParams.model = model.itemCode
      this.reqParams.prescriptionItems = params.deviceSettingInfo;
      for(var screenItem of this.reqParams.prescriptionItems) {
        if(screenItem.displayOrder == 1) {
            this.reqParams.mode = screenItem.value
        }
        if(screenItem.displayName == "加温加湿器") {
          this.reqParams.useMoist = screenItem.value == 1;
        }
        if(screenItem.displayName == "通信モジュール") {
          this.reqParams.useModule = screenItem.value == 1;
        }
      }
      // QA324 DS Auto、DS Go、DS BiPAPの場合
      if (this.reqParams.reportFormatType == 1 || this.reqParams.reportFormatType == 3 || this.reqParams.reportFormatType == 4) {
        // 呼吸回路タイプ12mmを選択不可とする
        var kokty = this.reqParams.prescriptionItems.find(val => val.itemName === "KOKTY")
        if (kokty.value !== "12") {
          kokty.displayValue = kokty.displayValue.filter(v => v.key !== "12" && v.key !== "")
          if (this.reqParams.reportFormatType == 3 && !kokty.value) {
            kokty.value = "15"
          }
        } else {
          kokty.displayValue = kokty.displayValue.filter(v => v.key !== "")
        }
        // 患者情報管理 「アンコールエニウェア」と空白を選択不可とする
        var kjk = this.reqParams.prescriptionItems.find(val => val.displayName === "患者情報管理")
        if (kjk.value !== "2") {
          kjk.displayValue = kjk.displayValue.filter(v => v.key !== "2" && v.key !== "")
          if (this.reqParams.reportFormatType == 3 && !kjk.value) {
            kjk.value = "1"
          }
        } else {
          kjk.displayValue = kjk.displayValue.filter(v => v.key !== "")
        }
        const order = ["1", "0", "2"]
        kjk.displayValue.sort((a, b) => order.indexOf(a.key) - order.indexOf(b.key))
        // 登録方法 「登録しない」と空白を選択不可とする
        var trh = this.reqParams.prescriptionItems.find(val => val.displayName === "登録方法")
        if (trh.value !== "0") {
          trh.displayValue = trh.displayValue.filter(v => v.key !== "0" && v.key !== "")
        } else {
          trh.displayValue = trh.displayValue.filter(v => v.key !== "")
        }
      }
      if (this.reqParams.model == "RJPG500S16") {
        this.reqParams.useModule = true;
      }
      this.reqParams.maskId = params.maskId;
      this.reqParams.maskType = params.maskType;
      this.reqParams.cushionSize = params.maskCushionSize;
      this.reqParams.frameSize = params.maskFrameSize;
      this.reqParams.fixingMethod = params.maskFixingMethod;
      this.reqParams.maskItemCode = params.maskItemCode1;
      this.reqParams.tempReceptionNo = params.tempReceptionNo;
      if (this.isDealer) {
        this.isHospitalAgree = true;
        this.institutionId = params.institutionId;
        if (this.institutionId) {
          // QA491 保存一覧から遷移した時、デフォルト値が取得するように追加
          await this.getCpapDefaultsettings()
        }
      }
      this.reqParams.mailNotification = params.mailNotification;
      this.reqParams.hospitalMail = params.hospitalMail;
      if (params.applicationType) {
        this.reqParams.kind = Number(params.applicationType)
      }
      this.reqParams.cancelResume = params.cancelResume;
      this.cancelResume = params.cancelResume;
      this.reqParams.resume = params.resume;
      this.resume = params.resume;
      this.reqParams.depositUseFlag = params.depositUseFlag;
      this.isInstrument = params.depositUseFlag;
      // 再開申込み
      if (this.reqParams.kind == cpapKindMap.applicationResume) {
        this.reqParams.patientCode = params.patientCode;
        this.reqParams.model = params.itemCode;
        if (this.resume) {
          this.reqParams.transferDestinationId = this.belongsId
          this.reqParams.transferInstitutionId = params.institutionId ? params.institutionId : null
        }
        this.reqParams.serial = params.serial;
        this.reqParams.moistItemCode = params.moistItemCode;
        this.reqParams.moistSerial = params.moistSerial;
        this.reqParams.moduleItemCode = params.moduleItemCode;
        this.reqParams.moduleSerial = params.moduleSerial;
        this.reqParams.receiptNumber = ''
        this.reqParams.applicationDate = ''
        this.reqParams.applicationTime = ''
        this.reqParams.applicationUserName = ''
        this.reqParams.applicationType = Number(params.applicationType)
        this.changeBeforeData = params.changeBeforeData;
        // 変更ありマーク用定義
        this.changedCheckItems = [
          {key:"basicArea", value:["instructionDate","doctorName","clerkName","hospitalMail"]},
          {key:"patientArea", value:["patientRegistrationCard","patientFamilyName","patientFirstName","patientFamilyNameKana","patientFirstNameKana","gender","birthday","zip","address","address1","address2","receiverName","mobilePhone","phoneNumber","followUpCall","disease","infection","infectionName","hospitalName","doctorName"]},
          {key:"hardwareArea", value:["reportFormatType","serial","settingChanger"]},
          {key:"prescriptionArea", value:[]},
          {key:"maskArea", value:["maskType","cushionSize","frameSize","fixingMethod","lot"]},
          {key:"orderArea", value:["billingStartDate","billComment","directShippingType","leaseUpType","memo"]}
        ]
        // 変更ありマークの項目
        this.reqParams.billComment = ""
        this.reqParams.directShippingType = ""
        this.reqParams.leaseUpType = ""
        this.reqParams.lot = ""
      }
      // 預託申込み
      if (this.isInstrument) {
        this.reqParams.serial = params.serial;
        this.reqParams.moistSerial = params.moistSerial;
        this.reqParams.moduleSerial = params.moduleSerial;
      }

      // クイックオーダーのロジックを追加
      if(params.preReceptionNo && params.preKind){
        this.isApplicationValid = true;
        this.preReceiptNumber = params.preReceptionNo
        this.preKind = params.preKind
      }

      // QA491 現在のパラメータからデフォルト値テンプレート名を復帰する
      this.setDefaultSettingsSelect()

      // forward step.
      // 通常新規申込み、中止後通常再開申込みは納品先情報画面あり
      if ((this.reqParams.kind == cpapKindMap.application || this.cancelResume) && !this.isInstrument) {
        this.activeStep = 5;
      } else if (this.resume || this.isInstrument) {
        // 転院再開申込み、預託新規申込み、中止後預託再開申込みは納品先情報画面なし
        this.activeStep = 4;
      }
    },
    setDefaultSettingsSelect: function() {
      if (this.cpapDefaultSettingList) {
        for (const setting of this.cpapDefaultSettingList) {
          // 加温加湿器：設置日,通信モジュール：設置日
          for(var item of setting.prescriptionContent){
            if(item.displayName.indexOf("設置日") == -1) continue
            // 保存済みの設置日からコピー
            var target = this.reqParams.prescriptionItems.find(val => val.displayName == item.displayName)
            item.value = target ? target.value : ""
          }

          // 医師名
          if (this.reqParams.doctorName != setting.doctorName) {
            continue
          }
          // 事務担当者名
          if (this.reqParams.clerkName != setting.clerkName) {
            continue
          }
          // 医療機関へのメール送付(ディーラー代理)
          if (this.reqParams.mailNotification != setting.mailNotification) {
            continue
          }
          // 医療機関メールアドレス(ディーラー代理)
          if (this.reqParams.hospitalMail != setting.mail) {
            continue
          }
          // 機種
          if (this.reqParams.reportFormatType != setting.reportFormatType) {
            continue
          }
          if (this.reqParams.model != setting.itemCode) {
            continue
          }
          // 処方設定
          // JSON化して一致するか比較
          if (JSON.stringify(this.reqParams.prescriptionItems) != JSON.stringify(setting.prescriptionContent)) {
            continue
          }
          if (this.reqParams.mode != setting.mode) {
            continue
          }
          // マスク情報
          if (this.reqParams.maskId != setting.maskId) {
            continue
          }
          // 設定値セット
          this.cpapBeforeRequestDetail = setting;
          this.oldCpapBeforeRequestDetail = setting;
          this.cpapBeforeRequestDetailModel = setting;
          this.oldCpapBeforeRequestDetailModel = setting;
          break;
        }
      }
    },
    downloadInstructionsPDF: function(){
      var _this = this;
      this.downloadApiCall(function(client){
          return client.apis.apiCommon.getInstructionsPDFPOST({
            body:{receiptNumber:_this.reqParams.receiptNumber}
          })
        },
        function(message) {
          _this.showErrorMessage(message);
        }
      );
    },
    /**
     * QA476 郵便番号からフォーカスが外れたら桁数に応じて桁数判定フラグを設定する
     * @param zipCode 郵便番号
     * @param flagName 桁数判定フラグ
     */
    onZipBlur(zipCode, flagName) {
      this[flagName] = zipCode.length < 7;
    },
    /**
     * QA476 引数に指定した項目の末尾にフォーカスを移動する
     * @param refName フォーカスをあてる項目定義
     */
    focusMove(refName) {
      this.$nextTick(() => {
        const element = this.$refs[refName];
        if (element) {
          element.focus();
          const length = element.value.length;
          element.setSelectionRange(length, length);
        }
      })
    },
    onPaste() {
      this.isChangeDelivaryTarget = false;
    }
  },
  data() {
    var applicationType = cpapKindMap.application
    // 処方再開(転院)判定
    var resume = false;
    if(this.$route.params["resume"]){
      resume = this.$route.params["resume"];
      applicationType = cpapKindMap.applicationResume
    }
    // 処方変更の際、変更した項目のチェック用定義
    var changedCheckItems = [
      {key:"basicArea", value:["instructionDate","contractEndDate","billingCurrentMonth","cancelReasonCode","depositContractEndDate","depositCancelReasonCode","depositBillingCurrentMonth","doctorName","clerkName","hospitalMail"]},
      {key:"patientArea", value:["patientRegistrationCard","patientFamilyName","patientFirstName","patientFamilyNameKana","patientFirstNameKana","gender","birthday","zip","address","address1","address2","receiverName","mobilePhone","phoneNumber","followUpCall","disease","infection","infectionName","hospitalName","doctorName"]},
      {key:"hardwareArea", value:["reportFormatType","serial","settingChanger"]},
      {key:"prescriptionArea", value:[]},
      // {key:"moistArea", value:[]},
      // {key:"moduleArea", value:[]},
      {key:"maskArea", value:["maskType","cushionSize","frameSize","fixingMethod","lot"]},
      {key:"orderArea", value:["billingStartDate","billComment","departmentCode","customerClass","directShippingType","leaseUpType","memo"]}
    ]
    // 処方再開(中止から)判定
    var cancelResume = false;
    if(this.$route.params["cancelResume"]){
      cancelResume = this.$route.params["cancelResume"];
    }
    // 仮持出申込み判定
    var temp = false;
    if(this.$route.params["temp"]){
      temp = this.$route.params["temp"];
      applicationType = cpapKindMap.applicationTempRemoval
    }
    // 預託在庫からの申込み判定
    var isInstrument = false;
    if(this.$route.params["instrument"]){
      isInstrument = this.$route.params["instrument"];
    }
    // 処方変更判定
    var changePrescription = false;
    if(this.$route.params["changePrescription"]){
      changePrescription = this.$route.params["changePrescription"];
      applicationType = cpapKindMap.applicationChange
    }
    // 継続申請/転院紹介
    var preReceiptNumber = this.$route.params["receiptNumber"];
    var preKind = this.$route.params["kind"];
    var introduction = this.$route.params["introduction"];
    var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    var roleId = userInfo.roleId;
    var userId = userInfo.id;
    var miniday = new Date()
    var maxDate = new Date()
    maxDate.setDate(maxDate.getDate() + 365);
    var maxday = new Date(maxDate.getFullYear(), maxDate.getMonth(), maxDate.getDate());
    var isDealer = roleId == role.role_dealer;
    var isSalesOffice = roleId == role.role_salesOffice;
    var isHospital = roleId == role.role_hospital;
    var isHonsha = roleId == role.role_headOffice;
    var isAdmin = roleId == role.role_admin;
    var belongsId = userInfo.belongsId
    var institutionId
    var reqParams = {
      instructionDate:this.yyyy_hyp_MM_hyp_dd(new Date()),
      serial:"",
      mode:"",
      useMoist:false,
      useModule:false,
      isDealer: isDealer,
      medicalInstitutionName: isHospital ? userInfo.medicalInstitutionName + " " + userInfo.departmentName : "",
      doctorName: "",
      clerkName:"",
      mailNotification:false,
      hospitalMail:"",
      zip:isHospital ? userInfo.postcode : "",
      address:isHospital ? userInfo.prefecture + " " + userInfo.city : "",
      address1:isHospital ? userInfo.address : "",
      address2:isHospital ? userInfo.building : "",
      receiverName:isHospital ? userInfo.medicalInstitutionName + " " + userInfo.departmentName : "",
      phoneNumber:isHospital ? userInfo.phoneNumber : "",
      desiredDeliveryTimeZone:"",
      model:"",
      depositUseFlag:isInstrument,
      settingChanger:0,
      delivaryTarget:"home",
      returnDate:"",
      shippingDate:null,
      deliverySlip:false,
      // institutionId: "",
      patient: {
        patientRegistrationCard:"",
        patientFamilyName:"",
        patientFirstName:"",
        patientFamilyNameKana:"",
        patientFirstNameKana:"",
        gender:"-",
        birthday:"",
        age:"",
        japaneseCalendar:"",
        followUpCall: true,
        disease:"",
        infectionFlag: false,
        infectionName: "",
        hospitalName: "",
        doctorName: "",
        zip: "",
        address:"",
        address1:"",
        address2:"",
        receiverName:"",
        phoneNumber:"",
        disease:""
      },
      prescriptionItems:[],
      memo:"",
      status:cpapRequestStatus.request,
      kind:applicationType,
      moduleItemCode:"",
      // 加湿器、通信モジュール(シリアル)
      moistSerial:"",
      moduleSerial:"",
      // マスク関連
      maskId:0,
      maskType:"",
      maskItemCode:"",
      cushionSize:"",
      frameSize:"",
      fixingMethod:"",
      // 処方再開(転院)
      resume:resume,
      // 処方再開(中止)
      cancelResume:cancelResume,
      // 仮持出
      temp:temp,
      // 預託在庫からの処方
      isInstrument:isInstrument,
      // 処方変更
      changePrescription:changePrescription,
      // その他配送先
      deliveryOther:false,
      deliveryPostcode:"",
      deliveryAddress:"",
      deliveryHouseNumber:"",
      deliveryBuilding:"",
      deliveryDestination:"",
      deliveryPhoneNumber:"",
    }
    var changeBeforeData = null;
    
    // 転院患者の処方再開(元データ)
    var patientData = this.$route.params["selectedData"];
    var backRoutName = this.$route.params["name"];
    var backRoutParams = this.$route.params;
    if(patientData){
      reqParams = patientData
      reqParams.instructionDate = this.yyyy_hyp_MM_hyp_dd(new Date())
      reqParams.applicationDate = ""
      reqParams.applicationTime = ""
      reqParams.applicationUserName = ""
      reqParams.receiptNumber = ""
      reqParams.status = cpapRequestStatus.request
      // reqParams.kind = cpapKindMap.application
      reqParams.kind = cpapKindMap.applicationResume
      if (backRoutParams.isEscrow) {
        reqParams.depositUseFlag = true;
      }
      if(!resume || cancelResume){
        belongsId = reqParams.belongsId
        institutionId = reqParams.institutionId
      }else if (resume && !cancelResume){
        // 転院後の再開の場合
        belongsId = reqParams.belongsId
        institutionId = reqParams.transferInstitutionId ? reqParams.transferInstitutionId : ""
        reqParams.medicalInstitutionName = reqParams.transferDestinationName
        reqParams.receiverName = reqParams.transferDestinationName
        reqParams.doctorName = ""
        reqParams.patient.patientRegistrationCard = ""
      }
      // 処方再開(転院)
      reqParams.resume = resume
      // 処方再開(中止)
      reqParams.cancelResume = cancelResume
      // 仮持出
      reqParams.temp = temp
      // 預託在庫からの処方
      reqParams.isInstrument = isInstrument
      // 処方変更
      reqParams.changePrescription = changePrescription
      delete reqParams.billingStartDate
      for(var item of reqParams.prescriptionItems){
        if(item.displayName.indexOf("設置日") == -1) continue
        if (resume && !cancelResume){
          item.value = this.yyyy_hyp_MM_hyp_dd(new Date())
        }else{
          item.value = ""
        }
      }
      changeBeforeData = JSON.parse(JSON.stringify(reqParams));
      // その他配送先
      reqParams.deliveryOther = false
      reqParams.deliveryPostcode = ""
      reqParams.deliveryAddress = ""
      reqParams.deliveryHouseNumber = ""
      reqParams.deliveryBuilding = ""
      reqParams.deliveryDestination = ""
      reqParams.deliveryPhoneNumber = ""
      if (resume) {
        reqParams.delivaryTarget = ""
      }
      if (cancelResume) {
        reqParams.delivaryTarget = reqParams.returnSource == 1 ? "hospital" : "home"
        if (reqParams.delivaryTarget == "hospital") {
          reqParams.deliveryPostcode = reqParams.zip
          reqParams.deliveryAddress = reqParams.address
          reqParams.deliveryHouseNumber = reqParams.address1
          reqParams.deliveryBuilding = reqParams.address2
          reqParams.deliveryDestination = reqParams.receiverName
          reqParams.deliveryPhoneNumber = reqParams.phoneNumber
        }
      }
      // QA324 DS Auto、DS Go、DS BiPAPの場合
      if (reqParams.reportFormatType == 1 || reqParams.reportFormatType == 3 || reqParams.reportFormatType == 4) {
        // QA324 3Gモデム ディスコン
        if (cancelResume && reqParams.moduleItemCode == "R100630C") {
          reqParams.moduleItemCode = "R100631C"
        }
        // 呼吸回路タイプ12mmを選択不可とする
        var kokty = reqParams.prescriptionItems.find(val => val.itemName === "KOKTY")
        if (kokty.value !== "12") {
          kokty.displayValue = kokty.displayValue.filter(v => v.key !== "12" && v.key !== "")
          if (reqParams.reportFormatType == 3 && !kokty.value) {
            kokty.value = "15"
          }
        } else {
          if (cancelResume) {
            kokty.displayValue = kokty.displayValue.filter(v => v.key !== "12" && v.key !== "")
            kokty.value = "15"
          } else {
            kokty.displayValue = kokty.displayValue.filter(v => v.key !== "")
          }
        }
        // 患者情報管理 「アンコールエニウェア」と空白を選択不可とする
        var kjk = reqParams.prescriptionItems.find(val => val.displayName === "患者情報管理")
        if (kjk.value !== "2") {
          kjk.displayValue = kjk.displayValue.filter(v => v.key !== "2" && v.key !== "")
          if (reqParams.reportFormatType == 3 && !kjk.value) {
            kjk.value = "1"
          }
        } else {
          if (cancelResume) {
            kjk.displayValue = kjk.displayValue.filter(v => v.key !== "2" && v.key !== "")
            kjk.value = "1"
          } else {
            kjk.displayValue = kjk.displayValue.filter(v => v.key !== "")
          }
        }
        const order = ["1", "0", "2"]
        kjk.displayValue.sort((a, b) => order.indexOf(a.key) - order.indexOf(b.key))
        // 登録方法 「登録しない」と空白を選択不可とする
        var trh = reqParams.prescriptionItems.find(val => val.displayName === "登録方法")
        if (trh.value !== "0") {
          trh.displayValue = trh.displayValue.filter(v => v.key !== "0" && v.key !== "")
        } else {
          if (cancelResume) {
            trh.displayValue = trh.displayValue.filter(v => v.key !== "0" && v.key !== "")
            trh.value = "1"
          } else {
            trh.displayValue = trh.displayValue.filter(v => v.key !== "")
          }
        }
      }
    }

    // マスクディスコン対応
    // 中止前にマスクディスコン品目を処方している案件は、中止再開申込みでマスク情報を空にする
    if (cancelResume && reqParams.maskInfo.length == 0) {
      reqParams.maskId = null
      reqParams.maskItemCode = ''
      reqParams.maskOrderId = ''
      reqParams.maskType = ''
      reqParams.cushionSize = ''
      reqParams.frameSize = ''
      reqParams.fixingMethod = ''
    }
    // QA474_処方値関連残
    var bipapvaliFlag = true
    if (!reqParams.existingFlag) {
      if (applicationType == cpapKindMap.applicationResume || cancelResume) {
        if (reqParams.reportFormatType == 4) {
          var mode = reqParams.prescriptionItems.find(val => val.displayOrder == 1)
          var flexLock = reqParams.prescriptionItems.find(val => val.displayOrder == 14)
          var flex = reqParams.prescriptionItems.find(val => val.displayOrder == 13)
          var riseTime = reqParams.prescriptionItems.find(val => val.displayOrder == 15)
          if (mode.value == 1) {
            // Bipap（Auto Bi-Levelモード）IPAP＝EPAPかつPS最大圧0、PS最小圧0のとき、PS最大圧、PS最小圧は非活性とする。
            var ipap = reqParams.prescriptionItems.find(val => val.displayOrder == 5)
            var epap = reqParams.prescriptionItems.find(val => val.displayOrder == 6)
            var pressureMax = reqParams.prescriptionItems.find(val => val.displayOrder == 7)
            var pressureMin = reqParams.prescriptionItems.find(val => val.displayOrder == 8)
            if ((Number(ipap.value) == Number(epap.value)) && (Number(pressureMax.value) == 0) && (Number(pressureMin.value) == 0)) {
              pressureMax.disabled = true
              pressureMin.disabled = true
            }
            // Bipap（Auto Bi-Levelモード）Flexタイプの選択肢はBi-Flex、0（オフ）のみとする。
            var flexType1 = reqParams.prescriptionItems.find(val => val.displayOrder == 12)
            var flexType8 = reqParams.prescriptionItems.find(val => val.displayOrder == 11)
            if (flexType1.value !== "2") {
              flexType1.displayValue = flexType1.displayValue.filter(v => v.key !== "2")
              flexType8.displayValue = flexType8.displayValue.filter(v => v.key !== "2" && v.key !== "3")
            }
            // Bipap（Auto Bi-Levelモード）Flexタイプがオフの場合、Flex設定とFlex設定ロックは非活性とする。
            if (flexType1.value == "0" && !flex.value) {
              flex.disabled = true
            }
            if (flexType1.value == "0" && !flexLock.value) {
              flexLock.disabled = true
            }
            // Bipap（Auto Bi-Levelモード）Flexタイプオフのときはライズタイムの選択肢を「1～3」とする
            // if (flexType1.value == "0" && riseTime.value !== "0") {
            //   riseTime.displayValue = riseTime.displayValue.filter(v => v.key !== "0")
            // }
            // QA474 仕様変更 20260410
            riseTime.displayValue = [{"key":"","value":""},{"key":"0","value":"0"},{"key":"1","value":"1"},{"key":"2","value":"2"},{"key":"3","value":"3"}]
            // DS BiPAP AutoにおいてminEPAPとmaxIPAPの差分とPSの設定範囲の関係性が考慮できていない
            var epapMin = reqParams.prescriptionItems.find(val => val.displayOrder == 6)
            var ipapMax = reqParams.prescriptionItems.find(val => val.displayOrder == 5)
            var psMax = reqParams.prescriptionItems.find(val => val.displayOrder == 7)
            if (Number(ipapMax.value) - Number(epapMin.value) < Number(psMax.value)) {
              // "IPAP最大圧【hPa(cmH2O)"-"EPAP最小圧【hPa(cmH2O)】" >= "PS最大圧【hPa(cmH2O)】" で無い時
              bipapvaliFlag = false
            }
          } else if (mode.value == 8) {
            var flexType1 = reqParams.prescriptionItems.find(val => val.displayOrder == 12)
            var flexType8 = reqParams.prescriptionItems.find(val => val.displayOrder == 11)
            // Bipap（Bi-Levelモード）Flexタイプの選択肢はBi-Flex、0（オフ）のみとする。
            if (flexType8.value !== "2" && flexType8.value !== "3") {
              flexType8.displayValue = flexType8.displayValue.filter(v => v.key !== "2" && v.key !== "3")
            }
            if (flexType8.value !== "2") {
              flexType1.displayValue = flexType1.displayValue.filter(v => v.key !== "2")
            }
            // Bipap（Bi-Levelモード）Flexタイプがオフの場合、Flex設定とFlex設定ロックは非活性とする。
            if (flexType8.value == "0" && !flex.value) {
              flex.disabled = true
            }
            if (flexType8.value == "0" && !flexLock.value) {
              flexLock.disabled = true
            }
            // Bipap（Bi-Levelモード）Flexタイプオフのときはライズタイムの選択肢を「1～3」とする
            // if (flexType8.value == "0" && riseTime.value !== "0") {
            //   riseTime.displayValue = riseTime.displayValue.filter(v => v.key !== "0")
            // }
            // QA474 仕様変更 20260410
            riseTime.displayValue = [{"key":"","value":""},{"key":"0","value":"0"},{"key":"1","value":"1"},{"key":"2","value":"2"},{"key":"3","value":"3"}]
          } else if (mode.value == 4) { // CPAPモード
            var flexType1 = reqParams.prescriptionItems.find(val => val.displayOrder == 12)
            flexType1.displayValue = flexType1.displayValue.filter(v => v.key !== "2")
            var flexType8 = reqParams.prescriptionItems.find(val => val.displayOrder == 11)
            flexType8.displayValue = flexType8.displayValue.filter(v => v.key !== "2" && v.key !== "3")
          }
        }
        if (reqParams.reportFormatType == 1 || reqParams.reportFormatType == 3 || reqParams.reportFormatType == 4) {
          var flex = reqParams.prescriptionItems.find(val => val.displayName == "Flex設定")
          var language = reqParams.prescriptionItems.find(val => val.displayName == "言語設定")
          // フレックス設定からOFFを除去
          if (flex.value !== "0") {
            flex.displayValue = flex.displayValue.filter(v => v.key !== "0")
          }
          // 言語設定の選択肢から「その他」の選択肢を除去
          if (language.value !== "5") {
            language.displayValue = language.displayValue.filter(v => v.key !== "5")
          }
        }
      }
    }
    var cpapAccessories = this.getCpapAccessoryList();
    var cpapSetItems = this.getCpapSetItemList();

    var serviceId = service.cpap;
    var cpapAgentReqFlg = false;
    if(this.$route.params["cpapAgentReqFlg"]){
      cpapAgentReqFlg = this.$route.params["cpapAgentReqFlg"];
    }
    return {
      role: role,
      roleId: roleId,
      userId: userId,
      cpapKindMap:cpapKindMap,
      choicesType:choicesType,
      extUserStatus: extUserStatus,
      belongsId,
      institutionId,
      userInfo: userInfo,
      lendingPeriod:LendingPeriod.period,
      organizationModalActive: false,
      isChecked: false,
      activeStep: 0,
      prevRouteName: "",
      isHospitalAgree: roleId != role.role_dealer,
      isPatientAgree: !isDealer && !isHospital,
      isDealer: isDealer,
      isSalesOffice: isSalesOffice,
      isHonsha: isHonsha,
      isAdmin: isAdmin,
      miniday: miniday,
      maxday:maxday,
      disabledDays: [],
      reqParams,
      compleateFlg:false,
      searchTargetPostCode:"",
      searchTargetAddress:null,
      requestDate:"",
      receiptNumber:"",
      renderKey:true,
      canAgree:false,
      consentStatement:consentStatement,
      modelList:[],
      desiredDeliveryTimeZoneList:[],
      cannulaSizeList:[],
      beltSizeList:[],
      attachedWaveformList:[],
      isHospital,
      inspectionPurposeList:[],
      temp:temp,
      resume:resume,
      cancelResume:cancelResume,
      cpapRequestStatus,
      patientData,
      backRoutName,
      backRoutParams,
      needAgree: isHospital || isDealer,
      agreement: "",
      isInstrument,
      changePrescription,
      maskSelectModalActive:false,
      formatType:"",
      tempDeviceSelectModalActive:false,
      preReceiptNumber,
      preKind,
      introduction,
      searchType:"",
      cpapAccessories,
      cpapSetItems,
      moduleList:"",
      isProcessingDefaultSetting:false,
      cpapBeforeRequestDetail:"",
      oldCpapBeforeRequestDetail:"",
      cpapBeforeRequestDetailModel:"",
      oldCpapBeforeRequestDetailModel:"",
      cpapDefaultSettingList:[],
      // institutionId:null,
      invalidPostcode: false,
      invalidMobilePhoneNumber: false,
      invalidPhoneNumber: false,
      invalidDeliveryPostcode: false,
      invalidDeliveryPhoneNumber: false,
      note:"",
      // template message
      invalidNumberMessage,
      postcodePlaceholder,
      phonePlaceholder,
      changedCheckItems,
      changeBeforeData,
      note:"",
      prescriptionHardwareList,
      serviceId,
      cpapAgentReqFlg:cpapAgentReqFlg,
      isApplicationValid: false,
      initEstimateDetailCode:[{}],
      prevPrescriptionItems:[],
      prevUseModule:false,
      wkPrevReportFormatType:"",
      bipapvaliFlag,
      digitErrorZipMessage,
      digitErrorPostcode:false,
      digitErrorDeliveryPostcode:false,
      isInitial:true,
      isChangeDelivaryTarget:false,
    };
  },
  computed: {},
  filters: {
    getNameFilter: function(val, list){
      var target = list.find(item => item.value == val)
      if(target){
        return target.label1
      }
      return ""
    }
  },
  components: {
    organizationSelectModal:OrganizationSelectModal,
    facilitySelectModal:FacilitySelectModal,
    cpapRequestDetail:CpapRequestDetail,
    officeCalenderModal:OfficeCalenderModal,
    instrumentSelectModal:InstrumentSelectModal,
    cpapMaskSelectModal:CpapMaskSelectModal
  },
  async mounted() {
    //同意文取得
    await this.getAgreementStr();
    // マスタ取得
    await this.getChoicesList();
    if(this.isHospital){
      if(this.preReceiptNumber) {
        await this.getApplication();
      }
      await this.getCpapDefaultsettings();
    }
    if (this.isDealer) {
      // ディーラー
      if (this.institutionId && this.cancelResume) {
        // QA491 中止再開の時、初期表示だとデフォルト値設定が取得できていない。かつ医療機関選択が行えないので取得しておく
        this.getCpapDefaultsettings();
      }
    }
    // 預託機の処方変更、再開用の在庫データをWEB/HTより取得　
    // QA314対応：預託機在庫リスト未利用のためコメントアウト
    //if (this.isInstrument) {
      //this.getEscrowStock();
    //}
    if(this.prevRouteName == "CpapRequestDraftView") {
      var params = this.$route.params.results;
      if(params){
        this.setDraftDate(params);
      }
    }
    // QA335_ドリームステーションのランプ設定の誤りを修正
    // 初期表示にてランプスタート圧を活性化
    var lampStart = this.reqParams.prescriptionItems.find(val => val.displayName == "ランプスタート圧【hPa(cmH2O)】")
    if (lampStart) {
      lampStart.disabled = false
    }
  },
  created: function() {
    this.$validator.extend("validationCheck", {
      getMessage: field => `${field}の入力内容に誤りがあります。`, // QA427_エラーメッセージに項目名を追加
      validate: (value, indexArray) => {
        var ret = false;
        var value = indexArray[0];
        // 正規表現にカンマが含まれるとパラメタ数が変化するのでここで結合する
        var validationRule = "";

        if (value.indexOf("'") != -1) {
          // シングルコーテーションはサーバ側でSQLエラーとなる為、ここではじく
          return false;
        }

        for (var i = 1; i < indexArray.length; i++) {
          validationRule += decodeURI(indexArray[i]);
          if (i != indexArray.length - 1) {
            validationRule += ",";
          }
        }
        validationRule = validationRule.replace(/'/g, "");
        // QA403_小数点以下が入力されていると赤文字のエラーとなってしまう
        // 「0.5」刻みのルールを持つ場合、「.0」を許容
        if (validationRule.indexOf(".[05]") != -1) {
          value = value.replace(/\.0$/, "");
        }
        // 入力値チェック
        var regex = RegExp(validationRule);
        if (regex.test(value)) {
          ret = true;
        }
        return ret;
      }
    });
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRouteName = from.name;
    });
  },
  watch: {
    /** QA491 デフォルト値設定後に医師名・事務担当者名/装置情報/関連用品を変更した時空欄にする */
    "reqParams.doctorName"(newValue) {
      if (!this.isProcessingDefaultSetting && this.cpapBeforeRequestDetail && newValue != this.cpapBeforeRequestDetail.doctorName) {
        this.cpapBeforeRequestDetail = ""
        this.oldCpapBeforeRequestDetail = ""
      }
    },
    "reqParams.clerkName"(newValue) {
      if (!this.isProcessingDefaultSetting && this.cpapBeforeRequestDetail && newValue != this.cpapBeforeRequestDetail.clerkName) {
        this.cpapBeforeRequestDetail = ""
        this.oldCpapBeforeRequestDetail = ""
      }
    },
    "reqParams.mailNotification"(newValue) {
      if (!this.isProcessingDefaultSetting && this.cpapBeforeRequestDetail && newValue != this.cpapBeforeRequestDetail.mailNotification) {
        this.cpapBeforeRequestDetail = ""
        this.oldCpapBeforeRequestDetail = ""
      }
    },
    "reqParams.hospitalMail"(newValue) {
      if (!this.isProcessingDefaultSetting && this.cpapBeforeRequestDetail && newValue != this.cpapBeforeRequestDetail.mail) {
        this.cpapBeforeRequestDetail = ""
        this.oldCpapBeforeRequestDetail = ""
      }
    },
    "reqParams.reportFormatType"(newValue) {
      if (!this.isProcessingDefaultSetting && this.cpapBeforeRequestDetail && newValue != this.cpapBeforeRequestDetail.reportFormatType) {
        this.cpapBeforeRequestDetail = ""
        this.oldCpapBeforeRequestDetail = ""
      }
      if (!this.isProcessingDefaultSetting && this.cpapBeforeRequestDetailModel && newValue != this.cpapBeforeRequestDetailModel.reportFormatType) {
        this.cpapBeforeRequestDetailModel = ""
        this.oldCpapBeforeRequestDetailModel = ""
      }
    },
    "reqParams.model"(newValue) {
      if (!this.isProcessingDefaultSetting && this.cpapBeforeRequestDetail && newValue != this.cpapBeforeRequestDetail.itemCode) {
        this.cpapBeforeRequestDetail = ""
        this.oldCpapBeforeRequestDetail = ""
      }
      if (!this.isProcessingDefaultSetting && this.cpapBeforeRequestDetailModel && newValue != this.cpapBeforeRequestDetailModel.itemCode) {
        this.cpapBeforeRequestDetailModel = ""
        this.oldCpapBeforeRequestDetailModel = ""
      }
    },
    "reqParams.prescriptionItems": {
      handler:function(newValue) {
        if (!this.isProcessingDefaultSetting && this.cpapBeforeRequestDetail && JSON.stringify(newValue) != JSON.stringify(this.cpapBeforeRequestDetail.prescriptionContent)) {
          this.cpapBeforeRequestDetail = ""
          this.oldCpapBeforeRequestDetail = ""
        }
        if (!this.isProcessingDefaultSetting && this.cpapBeforeRequestDetailModel && JSON.stringify(newValue) != JSON.stringify(this.cpapBeforeRequestDetailModel.prescriptionContent)) {
          this.cpapBeforeRequestDetailModel = ""
          this.oldCpapBeforeRequestDetailModel = ""
        }
      },
      deep: true
    },
    "reqParams.mode"(newValue) {
      if (!this.isProcessingDefaultSetting && this.cpapBeforeRequestDetail && newValue != this.cpapBeforeRequestDetail.mode) {
        this.cpapBeforeRequestDetail = ""
        this.oldCpapBeforeRequestDetail = ""
      }
      if (!this.isProcessingDefaultSetting && this.cpapBeforeRequestDetailModel && newValue != this.cpapBeforeRequestDetailModel.mode) {
        this.cpapBeforeRequestDetailModel = ""
        this.oldCpapBeforeRequestDetailModel = ""
      }
    },
    "reqParams.useMoist"(newValue) {
      if (!this.isProcessingDefaultSetting && this.cpapBeforeRequestDetail && newValue != this.cpapBeforeRequestDetail.useMoist) {
        this.cpapBeforeRequestDetail = ""
        this.oldCpapBeforeRequestDetail = ""
      }
      if (!this.isProcessingDefaultSetting && this.cpapBeforeRequestDetailModel && newValue != this.cpapBeforeRequestDetailModel.useMoist) {
        this.cpapBeforeRequestDetailModel = ""
        this.oldCpapBeforeRequestDetailModel = ""
      }
    },
    "reqParams.useModule"(newValue) {
      if (!this.isProcessingDefaultSetting && this.cpapBeforeRequestDetail && newValue != this.cpapBeforeRequestDetail.useModule) {
        this.cpapBeforeRequestDetail = ""
        this.oldCpapBeforeRequestDetail = ""
      }
      if (!this.isProcessingDefaultSetting && this.cpapBeforeRequestDetailModel && newValue != this.cpapBeforeRequestDetailModel.useModule) {
        this.cpapBeforeRequestDetailModel = ""
        this.oldCpapBeforeRequestDetailModel = ""
      }
    },
    "reqParams.maskId"(newValue) {
      if (!this.isProcessingDefaultSetting && this.cpapBeforeRequestDetail && newValue != this.cpapBeforeRequestDetail.maskId) {
        this.cpapBeforeRequestDetail = ""
        this.oldCpapBeforeRequestDetail = ""
      }
      if (!this.isProcessingDefaultSetting && this.cpapBeforeRequestDetailModel && newValue != this.cpapBeforeRequestDetailModel.maskId) {
        this.cpapBeforeRequestDetailModel = ""
        this.oldCpapBeforeRequestDetailModel = ""
      }
    },
    "reqParams.patient.zip"(newValue) {
      // 数値以外、7桁以外の場合は住所を自動検索しない
      this.invalidPostcode = isNaN(Number(newValue));
      if (this.invalidPostcode || newValue.length != 7) {
        // 転院再開のみ納品先情報が空（転院先に引き継がない）のため初期遷移フラグをfalseにする
        if (this.resume) {
          this.isInitial = false
        }
        return
      }
      // 指示書保存またはクイックオーダー時の初期表示は住所を自動検索しない
      if ((this.reqParams.tempReceptionNo || this.preReceiptNumber) && this.isInitial) {
        this.isInitial = false
        return
      }
      // QA476 郵便番号自動検索処理
      this.patientAddressSearch(newValue);
      // 転院再開のみ納品先情報が空（転院先に引き継がない）のため初期遷移フラグをfalseにする
      if (this.resume) {
        this.isInitial = false
      }
    },
    "reqParams.patient.mobilePhone"(newValue) {
      this.invalidMobilePhoneNumber = isNaN(Number(newValue));
    },
    "reqParams.patient.phoneNumber"(newValue) {
      this.invalidPhoneNumber = isNaN(Number(newValue));
    },
    "reqParams.deliveryPostcode"(newValue) {
      this.invalidDeliveryPostcode = isNaN(Number(newValue));
      // QA476 郵便番号自動検索処理
      // 機器納品先が変更されたタイミングは郵便番号検索はしない
      if (this.isChangeDelivaryTarget) {
        this.isChangeDelivaryTarget = false;
        return
      }
      // 納品先情報画面のみ自動検索する
      // 指示書保存後、納品先住所を自動検索しない
      // 内部ユーザーはactiveStep：3、外部ユーザーはactiveStep：4
      if (!this.invalidDeliveryPostcode && newValue.length === 7 && (this.activeStep === 3 || this.activeStep === 4) && (!this.reqParams.tempReceptionNo || !this.isInitial)) {
        this.addressSearch(newValue);
      }
      this.isInitial = false
    },
    "reqParams.deliveryPhoneNumber"(newValue) {
      this.invalidDeliveryPhoneNumber = isNaN(Number(newValue));
    }
  }
};
</script>

<style>
</style>
<style lang="scss" scoped>
.shippingDate {
  width: 150px  !important;
}
.valueInput {
  width: 150px
}
#item-contens table.settings tr th {
  width: 300px;
}
.pdfbutton {
  position: absolute !important;
  width: 200px !important;
  right: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/mock/guest/cpap/CpapRequest.vue